// src/components/sort-filters/sort-filters.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSButtonFragment on EGDSButton {\n    primary\n    disabled\n    accessibility\n    icon {\n      id\n      description\n      token\n      title\n    }\n    analytics {\n      linkName\n      referrerId\n    }\n    action {\n      accessibility\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSRemovablePillFragment on EGDSRemovablePill {\n    primary\n    accessibility\n    disabled\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ShoppingSearchCriteriaFragment on ShoppingSearchCriteria {\n    selections {\n      id\n      value\n    }\n    booleans {\n      id\n      value\n    }\n    counts {\n      id\n      value\n    }\n    dates {\n      id\n      value {\n        day\n        month\n        year\n      }\n    }\n    ranges {\n      id\n      max\n      min\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  fragment AppliedFilterFragment on ShoppingSortAndFilterAppliedFilter {\n    pill {\n      ...EGDSRemovablePillFragment\n    }\n    nextSearchCriteria {\n      ...ShoppingSearchCriteriaFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SearchToolsAppliedFiltersFragment on ShoppingSortAndFilters {\n    appliedFilters {\n      ...AppliedFilterFragment\n    }\n    clearAll {\n      egdsElementId\n      ...EGDSButtonFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  fragment IconFragment on Icon {\n    id\n    title\n    token\n    description\n    size\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSBasicPillFragment on EGDSBasicPill {\n    accessibility\n    disabled\n    name\n    primary\n    selected\n    selectedText\n    value\n    icon {\n      ...IconFragment\n    }\n    selectAnalytics {\n      ...AnalyticsFragment\n    }\n    deselectAnalytics {\n      ...AnalyticsFragment\n    }\n  }\n\n  fragment AnalyticsFragment on ClientSideAnalytics {\n    linkName\n    referrerId\n  }\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSBasicRemovablePillFragment on EGDSBasicRemovablePill {\n    primary\n    name\n    accessibility\n    id\n    removeAnalytics {\n      referrerId\n      linkName\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSBasicTriggerPillFragment on EGDSBasicTriggerPill {\n    id\n    disabled\n    primary\n    selected\n    icon {\n      ...IconFragment\n    }\n    selectAnalytics {\n      ...AnalyticsFragment\n    }\n    deselectAnalytics {\n      ...AnalyticsFragment\n    }\n    accessibility\n  }\n\n  fragment AnalyticsFragment on ClientSideAnalytics {\n    linkName\n    referrerId\n  }\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSPillFragment on EGDSPill {\n    __typename\n\n    ...EGDSBasicPillFragment\n    ...EGDSBasicTriggerPillFragment\n    ...EGDSBasicRemovablePillFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ToggleFilterPillFieldFragment on ShoppingSortAndFilterToggleFilter {\n    filterPill {\n      ...EGDSPillFragment\n    }\n    __typename\n  }\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SearchToolsFilterPillFragment on ShoppingSortAndFilters {\n    quickAccessFilters {\n      ...ToggleFilterPillFieldFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  fragment DropdownFieldFragment on ShoppingDropdownField {\n    __typename\n    primary\n    secondary\n    dropdownOptions: options {\n      accessibility\n      id\n      primary\n      value\n      defaultOption: default\n      selected\n      selectAnalytics {\n        linkName\n        referrerId\n      }\n      deselectAnalytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  fragment MultiSelectionStackedTileFieldOptionFragment on ShoppingSelectableFilterOption {\n    __typename\n    fieldId: id\n    primary\n    selected\n    value\n    accessibility\n    disabled\n    selectAnalytics {\n      linkName\n      referrerId\n    }\n    deselectAnalytics {\n      linkName\n      referrerId\n    }\n    icon {\n      ...IconFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  fragment MultiSelectionStackedTileFieldFragment on ShoppingMultiSelectionStackedTileField {\n    __typename\n    multiOptions: options {\n      ...MultiSelectionStackedTileFieldOptionFragment\n    }\n    primary\n    secondary\n  }\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  fragment MultiSelectionTileFieldOptionFragment on ShoppingSelectableFilterOption {\n    __typename\n    fieldId: id\n    primary\n    secondary\n    selected\n    value\n    accessibility\n    selectAnalytics {\n      linkName\n      referrerId\n    }\n    deselectAnalytics {\n      linkName\n      referrerId\n    }\n    disabled\n    selectAnalytics {\n      linkName\n      referrerId\n    }\n    deselectAnalytics {\n      linkName\n      referrerId\n    }\n    icon {\n      ...IconFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  fragment MultiSelectionTileFieldFragment on ShoppingMultiSelectionTileField {\n    __typename\n    multiOptions: options {\n      ...MultiSelectionTileFieldOptionFragment\n    }\n    primary\n    secondary\n  }\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  fragment MarkFragment on Mark {\n    description\n    id\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  fragment UIGraphicFragment on UIGraphic {\n    ...MarkFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  fragment TemplateModelFragment on TemplateModel {\n    key\n    source\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSBasicLocalizedTextFragment on EGDSBasicLocalizedText {\n    template\n    models {\n      ...TemplateModelFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSCardinalLocalizedTextFragment on EGDSCardinalLocalizedText {\n    egdsElementId\n    text\n    models {\n      ...TemplateModelFragment\n    }\n    templates {\n      ...CardinalTemplateFragment\n    }\n  }\n\n  fragment CardinalTemplateFragment on CardinalTemplate {\n    template\n    category\n  }\n\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSCompositeLocalizedTextFragment on EGDSCompositeLocalizedText {\n    egdsElementId\n    text\n    template\n    models {\n      ...CompositeLocalizedTextModelFragment\n    }\n  }\n\n  fragment CompositeLocalizedTextModelFragment on CompositeLocalizedTextModel {\n    key\n    models {\n      ...EGDSTemplateModelsFragment\n    }\n  }\n\n  fragment EGDSTemplateModelsFragment on EGDSTemplateModels {\n    models {\n      ...TemplateModelFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSLocalizedTextFragment on EGDSLocalizedText {\n    ...EGDSBasicLocalizedTextFragment\n    ...EGDSCardinalLocalizedTextFragment\n    ...EGDSCompositeLocalizedTextFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n  }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SortAndFilterSignalReceiverFragment on SortAndFilterSignalReceiver {\n    signalId\n  }\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SortAndFilterSignalEmitterFragment on SortAndFilterSignalEmitter {\n    signalId\n    condition\n    payload {\n      ...SortAndFilterSignalPayloadFragment\n    }\n  }\n\n  fragment SortAndFilterSignalPayloadFragment on SortAndFilterSignalPayload {\n    ...SortAndFilterBasicFilterPayloadFragment\n    ...SortAndFilterSelectedFilterPillPayloadFragment\n  }\n\n  fragment SortAndFilterBasicFilterPayloadFragment on SortAndFilterBasicFilterPayload {\n    filterId\n    type\n  }\n\n  fragment SortAndFilterSelectedFilterPillPayloadFragment on SortAndFilterSelectedFilterPillPayload {\n    deselectionSignalId\n    filter {\n      ...EGDSBasicRemovablePillPartialFragment\n    }\n    filterName {\n      ...SortAndFilterSignalDataSourceFragment\n    }\n  }\n\n  fragment EGDSBasicRemovablePillPartialFragment on EGDSBasicRemovablePill {\n    name\n    accessibility\n    id\n    removeAnalytics {\n      linkName\n      referrerId\n    }\n  }\n\n  fragment SortAndFilterSignalDataSourceFragment on SortAndFilterSignalDataSource {\n    ...EGDSPlainTextFragment\n    ...EGDSBasicLocalizedTextFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _taggedTemplateLiteral([
        "\n  fragment MultiSelectionOptionFieldFragment on ShoppingSelectableFilterOption {\n    __typename\n    accessibility\n    fieldId: id\n    description\n    graphic {\n      ...UIGraphicFragment\n    }\n    primary\n    secondary\n    selected\n    value\n    disabled\n    selectAnalytics {\n      linkName\n      referrerId\n    }\n    deselectAnalytics {\n      linkName\n      referrerId\n    }\n    receivers {\n      ...SortAndFilterSignalReceiverFragment\n    }\n    emitters {\n      ...SortAndFilterSignalEmitterFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _taggedTemplateLiteral([
        "\n  fragment MultiSelectionFieldFragment on ShoppingMultiSelectionField {\n    __typename\n    primary\n    secondary\n    expando {\n      collapseLabel\n      collapseAccessibilityLabel\n      expandAccessibilityLabel\n      collapseAnalytics {\n        linkName\n        referrerId\n      }\n      expandAnalytics {\n        linkName\n        referrerId\n      }\n      expandLabel\n      minimalHeight\n      threshold\n      visible\n    }\n    options {\n      ...MultiSelectionOptionFieldFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _taggedTemplateLiteral([
        "\n  fragment RangeFieldFragment on ShoppingRangeField {\n    __typename\n    primary\n    range {\n      characteristics {\n        labels {\n          label\n          value\n        }\n        max\n        maxLabel\n        min\n        minLabel\n        step\n        minStepDistance\n      }\n      id\n      selected {\n        id\n        max\n        min\n      }\n      analytics {\n        linkName\n        referrerId\n      }\n      receivers {\n        ...SortAndFilterSignalReceiverFragment\n      }\n      emitters {\n        ...SortAndFilterSignalEmitterFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SelectionOptionFieldFragment on ShoppingSelectableFilterOption {\n    __typename\n    accessibility\n    fieldId: id\n    primary\n    selected\n    value\n    selectAnalytics {\n      linkName\n      referrerId\n    }\n    deselectAnalytics {\n      linkName\n      referrerId\n    }\n    disabled\n    receivers {\n      ...SortAndFilterSignalReceiverFragment\n    }\n    emitters {\n      ...SortAndFilterSignalEmitterFragment\n    }\n  }\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SelectionFieldFragment on ShoppingSelectionField {\n    __typename\n    primary\n    expando {\n      collapseLabel\n      expandLabel\n      collapseAccessibilityLabel\n      expandAccessibilityLabel\n      collapseAnalytics {\n        linkName\n        referrerId\n      }\n      expandAnalytics {\n        linkName\n        referrerId\n      }\n      minimalHeight\n      threshold\n      visible\n    }\n    options {\n      ...SelectionOptionFieldFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _taggedTemplateLiteral([
        "\n  fragment StepInputFieldFragment on ShoppingStepInputField {\n    __typename\n    primary\n    stepInputId: id\n    stepInput {\n      decreaseText\n      increaseText\n      label\n      max\n      min\n      step\n      subLabel\n      value\n      key\n      decreaseAnalytics {\n        linkName\n        referrerId\n      }\n      increaseAnalytics {\n        linkName\n        referrerId\n      }\n    }\n    receivers {\n      ...SortAndFilterSignalReceiverFragment\n    }\n    emitters {\n      ...SortAndFilterSignalEmitterFragment\n    }\n    accessibility\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _taggedTemplateLiteral([
        "\n  fragment MutexFieldFragment on ShoppingMutexField {\n    __typename\n    mutexId: id\n    primary\n    secondary\n    options {\n      __typename\n      mutexOption: option {\n        ...MultiSelectionFieldFragment\n        ...RangeFieldFragment\n        ...MultiSelectionStackedTileFieldFragment\n        ...MultiSelectionTileFieldFragment\n        ...StepInputFieldFragment\n      }\n      mutexValue: value {\n        ...SelectionOptionFieldFragment\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ShoppingSelectedFilterFragment on ShoppingSelectedFilter {\n    filter {\n      ...EGDSBasicRemovablePillFragment\n    }\n\n    emitters {\n      ...SortAndFilterSignalEmitterFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SelectedFiltersFieldFragment on ShoppingSelectedFiltersField {\n    selectedFiltersFieldAccessiblity: accessibility {\n      ... on EGDSBasicLocalizedText {\n        egdsElementId\n        text\n      }\n      ... on EGDSCardinalLocalizedText {\n        egdsElementId\n        accessibilityText\n        text\n      }\n      ... on EGDSCompositeLocalizedText {\n        egdsElementId\n        text\n      }\n    }\n    primary\n    secondary\n    selectedFiltersOrdering\n    shoppingSelectedFilters {\n      ...ShoppingSelectedFilterFragment\n    }\n    receivers {\n      ...SortAndFilterSignalReceiverFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _taggedTemplateLiteral([
        "\n  fragment TextInputFieldFragment on ShoppingTextInputField {\n    __typename\n    id\n    primary\n    secondary\n    label\n    placeholder\n    selected\n    icon {\n      id\n      description\n    }\n    typeaheadInfo {\n      client\n      isDestination\n      lineOfBusiness\n      maxNumberOfResults\n      regionType\n      typeaheadFeatures\n      allowExactMatch\n      listTitle\n      categorize\n      dismissButtonText\n      domain\n      emptyResultsPlaceholder\n      typeaheadMultiSelect {\n        isMultiLocation\n        showPills\n        selectedItemHeading\n        clearAllText\n      }\n    }\n    analytics {\n      referrerId\n      linkName\n    }\n    multiSelections {\n      text\n      value\n    }\n  }\n"
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SortAndFilterSectionFragment on ShoppingSortAndFilterSection {\n    __typename\n    id\n    title\n    subTitle\n    fields {\n      ...DropdownFieldFragment\n      ...MultiSelectionFieldFragment\n      ...RangeFieldFragment\n      ...SelectionFieldFragment\n      ...TextInputFieldFragment\n      ...MultiSelectionStackedTileFieldFragment\n      ...MultiSelectionTileFieldFragment\n      ...StepInputFieldFragment\n      ...MutexFieldFragment\n      ...SelectedFiltersFieldFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SearchToolsFiltersFragment on ShoppingSortAndFilters {\n    filterSections {\n      ...SortAndFilterSectionFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SearchToolsSortFragment on ShoppingSortAndFilters {\n    sortSections {\n      id\n      fields {\n        ...DropdownFieldFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _taggedTemplateLiteral([
        "\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    linkName\n    referrerId\n  }\n"
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _taggedTemplateLiteral([
        "\n  fragment UIPrimaryFloatingActionButtonFragment on UIPrimaryFloatingActionButton {\n    primary\n    badge\n    accessibility\n    action {\n      accessibility\n    }\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    icon {\n      ...IconFragment\n    }\n    egdsElementId\n    disabled\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _taggedTemplateLiteral([
        "\n  fragment UISecondaryFloatingActionButtonFragment on UISecondaryFloatingActionButton {\n    primary\n    badge\n    accessibility\n    action {\n      accessibility\n    }\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    icon {\n      ...IconFragment\n    }\n    egdsElementId\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = _taggedTemplateLiteral([
        "\n  fragment UIFloatingActionButtonFragment on UIFloatingActionButton {\n    __typename\n    accessibility\n\n    ... on UIPrimaryFloatingActionButton {\n      ...UIPrimaryFloatingActionButtonFragment\n    }\n\n    ... on UISecondaryFloatingActionButton {\n      ...UISecondaryFloatingActionButtonFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSTertiaryButtonFragment on UITertiaryButton {\n    egdsElementId\n    ...EGDSButtonFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SortFilterToolbarFragment on UIToolbar {\n    __typename\n    primary\n    actions {\n      primary {\n        ...EGDSTertiaryButtonFragment\n      }\n      secondaries {\n        ...EGDSTertiaryButtonFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject45 = function _templateObject45() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SearchToolsSortAndFiltersFragment on ShoppingSortAndFilters {\n    sections {\n      ...SortAndFilterSectionFragment\n    }\n    sortSections {\n      ...SortAndFilterSectionFragment\n    }\n    filterSections {\n      ...SortAndFilterSectionFragment\n    }\n    containers {\n      ... on ShoppingSortAndFilterDialogContainer {\n        view\n        revealAction {\n          ...UIFloatingActionButtonFragment\n        }\n        applyAction {\n          ...UIFloatingActionButtonFragment\n        }\n        toolbar {\n          ...SortFilterToolbarFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject46 = function _templateObject46() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = _taggedTemplateLiteral([
        "\n  fragment AllFilterSheetFooterFragment on ShoppingSortAndFilters {\n    footerLabel\n    containers {\n      ... on ShoppingSortAndFilterDialogContainer {\n        view\n        applyAction {\n          ...UIFloatingActionButtonFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject47 = function _templateObject47() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSSecondaryButtonFragment on UISecondaryButton {\n    egdsElementId\n    ...EGDSButtonFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject48 = function _templateObject48() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSPrimaryButtonFragment on UIPrimaryButton {\n    egdsElementId\n    ...EGDSButtonFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject49 = function _templateObject49() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = _taggedTemplateLiteral([
        "\n  fragment QuickAccessFilterSheetFooterFragment on ShoppingSortAndFilterQuickFilter {\n    resultCountLabel\n    applyAction {\n      ...EGDSPrimaryButtonFragment\n    }\n    filterPill {\n      id\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject50 = function _templateObject50() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = _taggedTemplateLiteral([
        "\n  fragment QuickAccessFilterFieldFragment on ShoppingSortAndFilterQuickFilter {\n    ...QuickAccessFilterSheetFooterFragment\n    clearAll {\n      ...EGDSSecondaryButtonFragment\n    }\n    fields {\n      ...DropdownFieldFragment\n      ...MultiSelectionFieldFragment\n      ...RangeFieldFragment\n      ...SelectionFieldFragment\n      ...TextInputFieldFragment\n      ...MultiSelectionStackedTileFieldFragment\n      ...MultiSelectionTileFieldFragment\n      ...StepInputFieldFragment\n      ...MutexFieldFragment\n      ...SelectedFiltersFieldFragment\n    }\n    filterPill {\n      ...EGDSPillFragment\n    }\n    resultCountLabel\n    toolbar {\n      ...SortFilterToolbarFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject51 = function _templateObject51() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = _taggedTemplateLiteral([
        "\n  fragment QuickAccessFilterMoreFiltersFragment on ShoppingSortAndFilterButtonTrigger {\n    container {\n      ... on ShoppingSortAndFilterDialogContainer {\n        revealAction {\n          ...UIFloatingActionButtonFragment\n        }\n        applyAction {\n          ...UIFloatingActionButtonFragment\n        }\n        toolbar {\n          ...SortFilterToolbarFragment\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject52 = function _templateObject52() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SearchToolsFilterBarFragment on ShoppingSortAndFilters {\n    ...AllFilterSheetFooterFragment\n    filterSections {\n      ...SortAndFilterSectionFragment\n    }\n    containers {\n      ... on ShoppingSortAndFilterDialogContainer {\n        view\n        revealAction {\n          ...UIFloatingActionButtonFragment\n        }\n        applyAction {\n          ...UIFloatingActionButtonFragment\n        }\n        toolbar {\n          ...SortFilterToolbarFragment\n        }\n      }\n    }\n    quickAccessFilters {\n      ...QuickAccessFilterFieldFragment\n      ...QuickAccessFilterMoreFiltersFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject53 = function _templateObject53() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SearchToolsFilterDialogFragment on ShoppingSortAndFilters {\n    sections {\n      ...SortAndFilterSectionFragment\n    }\n    filterSections {\n      ...SortAndFilterSectionFragment\n    }\n    containers {\n      ... on ShoppingSortAndFilterDialogContainer {\n        view\n        revealAction {\n          ...UIFloatingActionButtonFragment\n        }\n        applyAction {\n          ...UIFloatingActionButtonFragment\n        }\n        toolbar {\n          ...SortFilterToolbarFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject54 = function _templateObject54() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = _taggedTemplateLiteral([
        "\n  fragment TabSelectionFieldFragment on ShoppingTabSelectionField {\n    __typename\n    tabOptions: options {\n      __typename\n      accessibility\n      id\n      primary\n      secondary\n      value\n      selected\n      selectAnalytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n"
    ]);
    _templateObject55 = function _templateObject55() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = _taggedTemplateLiteral([
        "\n  fragment SearchToolsSortTabsFragment on ShoppingSortAndFilters {\n    sortSections {\n      id\n      fields {\n        ...TabSelectionFieldFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject56 = function _templateObject56() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSBadgeFragment on EGDSBadge {\n    accessibility\n    text\n    theme\n    size\n  }\n"
    ]);
    _templateObject57 = function _templateObject57() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = _taggedTemplateLiteral([
        "\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    text\n    weight\n    size\n  }\n"
    ]);
    _templateObject58 = function _templateObject58() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = _taggedTemplateLiteral([
        "\n  fragment FlightsBadgeMessageFragment on FlightsBadgeMessage {\n    badge {\n      ...EGDSBadgeFragment\n    }\n    message {\n      ...EGDSStylizedTextFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject59 = function _templateObject59() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = _taggedTemplateLiteral([
        "\n  query FlightsUniversalSortAndFiltersQuery(\n    $context: ContextInput!\n    $flightsSearchContext: FlightsSearchContextInput\n    $journeyCriteria: [FlightsJourneyCriteriaInput!]!\n    $travelerDetails: [FlightsTravelerDetailsInput!]\n    $searchFilterValuesList: [FlightsSearchFilterValuesInput!]\n    $sortOption: FlightsSortOptionTypeInput\n    $queryState: FlightsQueryState\n    $searchPreferences: FlightsSearchPreferencesInput\n    $searchPagination: PaginationInput\n    $flightsSearchComponentCriteria: FlightsSearchComponentCriteriaInput\n    $shoppingContext: ShoppingContextInput\n    $faresSeparationType: FlightsFaresSeparationType\n    $sideSheetQueryContext: SideSheetQueryContextInput\n  ) {\n    flightsSearch(\n      context: $context\n      flightsSearchContext: $flightsSearchContext\n      journeyCriteria: $journeyCriteria\n      travelerDetails: $travelerDetails\n      searchFilterValuesList: $searchFilterValuesList\n      sortOption: $sortOption\n      queryState: $queryState\n      searchPreferences: $searchPreferences\n      searchPagination: $searchPagination\n      flightsSearchComponentCriteria: $flightsSearchComponentCriteria\n      shoppingContext: $shoppingContext\n      faresSeparationType: $faresSeparationType\n      sideSheetQueryContext: $sideSheetQueryContext\n    ) {\n      universalSortAndFilterResult {\n        ...SearchToolsFiltersFragment\n        ...SearchToolsAppliedFiltersFragment\n        ...SearchToolsSortFragment\n        ...SearchToolsSortAndFiltersFragment\n        ...SearchToolsFilterPillFragment\n        ...SearchToolsSortTabsFragment\n      }\n      newAddOnFeatureBadgeMessage {\n        ...FlightsBadgeMessageFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject60 = function _templateObject60() {
        return data;
    };
    return data;
}
import React58 from "react";
import { gql as gql56, useQuery } from "@apollo/client";
import { useBexApi as useBexApi4 } from "@shared-ui/bex-api-context";
// ../internal/src/components/sort-filter/search-tools-applied-filters.tsx
import React3 from "react";
import { gql as gql5 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkLink } from "uitk-react-link";
import { UitkPillContainer } from "uitk-react-pill";
import { UitkSpacing } from "uitk-react-spacing";
// ../internal/src/components/common/button/egds-button-fragment.ts
import { gql } from "@apollo/client";
var EGDSButtonFragment = gql(_templateObject());
// ../internal/src/components/sort-filter/__private/__fragments/applied-filter.tsx
import React2 from "react";
import { gql as gql4 } from "@apollo/client";
// ../internal/src/components/common/removable-pill/egds-removable-pill.tsx
import React from "react";
import { gql as gql2 } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkRemovablePill } from "uitk-react-pill";
var __Fragment = gql2(_templateObject1());
var EGDSRemovablePill = function(param) {
    var data = param.data, onClick = param.onClick, disabled = param.disabled;
    var primary = data.primary, accessibility = data.accessibility, action = data.action;
    var clickTracker = useClickTracker();
    var handleClick = function() {
        if (action === null || action === void 0 ? void 0 : action.analytics) {
            var _action_analytics = action.analytics, linkName = _action_analytics.linkName, referrerId = _action_analytics.referrerId;
            clickTracker(referrerId, linkName);
        }
        onClick();
    };
    return /* @__PURE__ */ React.createElement(UitkRemovablePill, {
        id: primary,
        onClick: handleClick,
        altText: accessibility || "",
        a11yRemoveText: (action === null || action === void 0 ? void 0 : action.accessibility) || "",
        disabled: data.disabled || disabled
    }, primary);
};
EGDSRemovablePill.displayName = "EGDSRemovablePill";
EGDSRemovablePill.fragment = __Fragment;
// ../internal/src/components/sort-filter/__private/__fragments/next-search-criteria-fragment.tsx
import { gql as gql3 } from "@apollo/client";
var NextSearchCriteriaFragment = gql3(_templateObject2());
// ../internal/src/components/sort-filter/__private/__fragments/applied-filter.tsx
var __Fragment2 = gql4(_templateObject3(), EGDSRemovablePill.fragment, NextSearchCriteriaFragment);
var AppliedFilter = function(param) {
    var data = param.data, onRemove = param.onRemove, allowEmptySelections = param.allowEmptySelections, disabled = param.disabled;
    var _nextSearchCriteria_selections;
    var pill = data.pill, nextSearchCriteria = data.nextSearchCriteria;
    if (pill.__typename !== "EGDSRemovablePill" || !((_nextSearchCriteria_selections = nextSearchCriteria.selections) === null || _nextSearchCriteria_selections === void 0 ? void 0 : _nextSearchCriteria_selections[0]) && !allowEmptySelections) {
        return null;
    }
    var handleClick = function() {
        onRemove === null || onRemove === void 0 ? void 0 : onRemove(nextSearchCriteria);
    };
    return /* @__PURE__ */ React2.createElement(EGDSRemovablePill, {
        data: pill,
        onClick: handleClick,
        disabled: disabled
    });
};
AppliedFilter.displayName = "AppliedFilter";
AppliedFilter.fragment = __Fragment2;
// ../internal/src/components/sort-filter/search-tools-applied-filters.tsx
var __Fragment3 = gql5(_templateObject4(), AppliedFilter.fragment, EGDSButtonFragment);
var SearchToolsAppliedFilters = function(param) {
    var data = param.data, onEmptyResults = param.onEmptyResults, onRemoveAppliedFilter = param.onRemoveAppliedFilter, onRemoveAllAppliedFilters = param.onRemoveAllAppliedFilters, _param_wrapAppliedFilters = param.wrapAppliedFilters, wrapAppliedFilters = _param_wrapAppliedFilters === void 0 ? false : _param_wrapAppliedFilters, allowEmptySelectionsPills = param.allowEmptySelectionsPills, loading = param.loading, appliedFiltersSpacing = param.appliedFiltersSpacing;
    var _data_clearAll;
    var appliedFilters = data.appliedFilters, clearAll = data.clearAll;
    var track = useClickTracker2();
    var clearElementId = clearAll === null || clearAll === void 0 ? void 0 : clearAll.egdsElementId;
    var handleClearAll = React3.useCallback(function() {
        var _data_clearAll;
        if ((_data_clearAll = data.clearAll) === null || _data_clearAll === void 0 ? void 0 : _data_clearAll.analytics) {
            var _data_clearAll_analytics = data.clearAll.analytics, referrerId = _data_clearAll_analytics.referrerId, linkName = _data_clearAll_analytics.linkName;
            track(referrerId, linkName);
        }
        onRemoveAllAppliedFilters === null || onRemoveAllAppliedFilters === void 0 ? void 0 : onRemoveAllAppliedFilters();
    }, [
        (_data_clearAll = data.clearAll) === null || _data_clearAll === void 0 ? void 0 : _data_clearAll.analytics,
        onRemoveAllAppliedFilters,
        track
    ]);
    if (!(appliedFilters === null || appliedFilters === void 0 ? void 0 : appliedFilters.length)) {
        onEmptyResults === null || onEmptyResults === void 0 ? void 0 : onEmptyResults();
        return null;
    }
    return /* @__PURE__ */ React3.createElement(UitkPillContainer, {
        wrap: wrapAppliedFilters
    }, (appliedFilters === null || appliedFilters === void 0 ? void 0 : appliedFilters.length) > 0 && /* @__PURE__ */ React3.createElement(UitkSpacing, _objectSpread({}, appliedFiltersSpacing), /* @__PURE__ */ React3.createElement("div", null, appliedFilters.map(function(appliedFilter, index) {
        return /* @__PURE__ */ React3.createElement(AppliedFilter, {
            key: "applied-filter-".concat(index),
            data: appliedFilter,
            onRemove: onRemoveAppliedFilter,
            allowEmptySelections: allowEmptySelectionsPills,
            disabled: loading
        });
    }))), clearAll && /* @__PURE__ */ React3.createElement(UitkSpacing, {
        margin: {
            inlineend: "one"
        },
        padding: {
            inlinestart: "four",
            blockstart: "four"
        }
    }, /* @__PURE__ */ React3.createElement(UitkLink, {
        inline: true,
        noWrap: true
    }, /* @__PURE__ */ React3.createElement("button", {
        type: "button",
        onClick: handleClearAll,
        disabled: loading,
        "data-test-id": clearElementId
    }, clearAll.primary))));
};
SearchToolsAppliedFilters.displayName = "SearchToolsAppliedFilters";
SearchToolsAppliedFilters.fragment = __Fragment3;
// ../internal/src/components/sort-filter/search-tools-filter-pill.tsx
import React10 from "react";
import { gql as gql12 } from "@apollo/client";
import { UitkPillContainer as UitkPillContainer2 } from "uitk-react-pill";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
// ../internal/src/components/sort-filter/__private/__fragments/toggle-filter-pill-field.tsx
import React9 from "react";
import { gql as gql11 } from "@apollo/client";
// ../internal/src/components/common/egds-pill/egds-pill.tsx
import React8 from "react";
import { gql as gql10 } from "@apollo/client";
// ../internal/src/components/common/egds-pill/egds-basic-pill.tsx
import React5, { useRef } from "react";
import { gql as gql7 } from "@apollo/client";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { useFormCallback } from "uitk-react-form";
import { UitkPill } from "uitk-react-pill";
import { liveAnnounce } from "uitk-react-utils";
// ../internal/src/components/common/icon.tsx
import React4 from "react";
import { gql as gql6 } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
// ../internal/src/__generated__/globalTypes.ts
var SortAndFiltersViewType = /* @__PURE__ */ function(SortAndFiltersViewType3) {
    SortAndFiltersViewType3["APPLIED_FILTERS"] = "APPLIED_FILTERS";
    SortAndFiltersViewType3["FILTERS"] = "FILTERS";
    SortAndFiltersViewType3["FILTERS_PILLS"] = "FILTERS_PILLS";
    SortAndFiltersViewType3["FILTER_BAR"] = "FILTER_BAR";
    SortAndFiltersViewType3["FILTER_DIALOG"] = "FILTER_DIALOG";
    SortAndFiltersViewType3["SORT"] = "SORT";
    SortAndFiltersViewType3["SORT_AND_FILTERS"] = "SORT_AND_FILTERS";
    SortAndFiltersViewType3["SORT_TABS"] = "SORT_TABS";
    return SortAndFiltersViewType3;
}(SortAndFiltersViewType || {});
// ../internal/src/components/common/icon.tsx
var __Fragment4 = gql6(_templateObject5());
var _obj;
var iconSizeMap = (_obj = {}, _defineProperty(_obj, "EXTRA_SMALL" /* EXTRA_SMALL */ , UitkIconSize.EXTRA_SMALL), _defineProperty(_obj, "SMALL" /* SMALL */ , UitkIconSize.SMALL), _defineProperty(_obj, "MEDIUM" /* MEDIUM */ , UitkIconSize.MEDIUM), _defineProperty(_obj, "MEDIUM_LARGE" /* MEDIUM_LARGE */ , UitkIconSize.MEDIUM), _defineProperty(_obj, "LARGE" /* LARGE */ , UitkIconSize.LARGE), _defineProperty(_obj, "XLARGE" /* XLARGE */ , UitkIconSize.XLARGE), _obj);
var Icon = function(props) {
    var data = props.data;
    var id = data.id, title = data.title, description = data.description, size = data.size;
    var iconSize = iconSizeMap[size !== null && size !== void 0 ? size : "LARGE"];
    return /* @__PURE__ */ React4.createElement(UitkIcon, {
        id: id,
        name: id,
        title: title !== null && title !== void 0 ? title : description,
        description: description,
        size: iconSize
    });
};
Icon.displayName = "Icon";
Icon.fragment = __Fragment4;
// ../internal/src/components/common/egds-pill/egds-basic-pill.tsx
var EGDS_BASIC_PILL_PREFIX = "EGDSBasicPill";
var __Fragment5 = gql7(_templateObject6(), Icon.fragment);
var EGDSBasicPill = function(props) {
    var data = props.data, onChange = props.onChange, triggerPill = props.triggerPill, onClick = props.onClick, active = props.active;
    var accessibility = data.accessibility, name = data.name, primary = data.primary, selected = data.selected, value = data.value, disabled = data.disabled, icon = data.icon, selectAnalytics = data.selectAnalytics, deselectAnalytics = data.deselectAnalytics, selectedText = data.selectedText;
    var clickTracker = useClickTracker3();
    var id = name !== null && name !== void 0 ? name : "egds-basic-pill";
    var _React5_useState = _slicedToArray(React5.useState(selected), 2), checked = _React5_useState[0], setCheckState = _React5_useState[1];
    var pillRef = useRef(false);
    var onPillSelectText = selectedText || primary;
    var handleOnChange = useFormCallback(id, function(event) {
        var _event_currentTarget = event.currentTarget, newSelection = _event_currentTarget.checked;
        setCheckState(newSelection);
        if (!pillRef.current) {
            pillRef.current = true;
        }
        if (onChange) {
            onChange(event);
        }
        if (selectAnalytics && newSelection) {
            var linkName = selectAnalytics.linkName, referrerId = selectAnalytics.referrerId;
            clickTracker(referrerId, linkName);
            return event;
        }
        if (deselectAnalytics && !newSelection) {
            var linkName1 = deselectAnalytics.linkName, referrerId1 = deselectAnalytics.referrerId;
            clickTracker(referrerId1, linkName1);
        }
        return event;
    });
    var handleOnClick = function() {
        if (onClick) {
            onClick();
        }
    };
    React5.useEffect(function() {
        if (pillRef.current) {
            liveAnnounce(accessibility !== null && accessibility !== void 0 ? accessibility : void 0);
        }
    }, [
        accessibility,
        pillRef.current
    ]);
    React5.useEffect(function() {
        setCheckState(selected);
    }, [
        selected
    ]);
    return /* @__PURE__ */ React5.createElement(UitkPill, {
        checked: checked,
        active: active,
        disabled: disabled,
        icon: (icon === null || icon === void 0 ? void 0 : icon.__typename) === "Icon" ? icon.token : "",
        id: id,
        name: "".concat(EGDS_BASIC_PILL_PREFIX, "-").concat(name),
        onChange: handleOnChange,
        value: value !== null && value !== void 0 ? value : "",
        altText: accessibility !== null && accessibility !== void 0 ? accessibility : "",
        triggerPill: triggerPill,
        onClick: handleOnClick
    }, checked ? onPillSelectText : primary);
};
EGDSBasicPill.displayName = "EGDSBasicPill";
EGDSBasicPill.fragment = __Fragment5;
EGDSBasicPill.fragment.__typename = "EGDSBasicPill";
// ../internal/src/components/common/egds-pill/egds-basic-removable-pill.tsx
import React6 from "react";
import { gql as gql8 } from "@apollo/client";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
import { UitkRemovablePill as UitkRemovablePill2 } from "uitk-react-pill";
var __Fragment6 = gql8(_templateObject7());
var EGDSBasicRemovablePill = function(param) {
    var data = param.data, onClick = param.onClick;
    var id = data.id, primary = data.primary, accessibility = data.accessibility, removeAnalytics = data.removeAnalytics, name = data.name;
    var _ref;
    var title = (_ref = id !== null && id !== void 0 ? id : name) !== null && _ref !== void 0 ? _ref : "egds-basic-removable-pill";
    var clickTracker = useClickTracker4();
    var handleOnClick = function() {
        if (onClick) {
            onClick();
        }
        if (removeAnalytics) {
            var referrerId = removeAnalytics.referrerId, linkName = removeAnalytics.linkName;
            clickTracker(referrerId, linkName);
        }
    };
    return /* @__PURE__ */ React6.createElement(UitkRemovablePill2, {
        id: title,
        onClick: handleOnClick,
        a11yRemoveText: accessibility || ""
    }, primary);
};
EGDSBasicRemovablePill.displayName = "EGDSBasicRemovablePill";
EGDSBasicRemovablePill.fragment = __Fragment6;
// ../internal/src/components/common/egds-pill/egds-basic-trigger-pill.tsx
import React7 from "react";
import { gql as gql9 } from "@apollo/client";
import { useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
import { useFormCallback as useFormCallback2 } from "uitk-react-form";
import { UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkPill as UitkPill2 } from "uitk-react-pill";
var EGDS_BASIC_TRIGGER_PILL_PREFIX = "EGDSBasicTriggerPill";
var __Fragment7 = gql9(_templateObject8(), Icon.fragment);
var EGDSBasicTriggerPill = function(props) {
    var data = props.data, onChange = props.onChange, triggerPill = props.triggerPill, onClick = props.onClick, domRef = props.domRef, active = props.active;
    var id = data.id, primary = data.primary, selected = data.selected, disabled = data.disabled, icon = data.icon, selectAnalytics = data.selectAnalytics, deselectAnalytics = data.deselectAnalytics, accessibility = data.accessibility;
    var clickTracker = useClickTracker5();
    var name = id !== null && id !== void 0 ? id : "egds-basic-pill";
    var _React7_useState = _slicedToArray(React7.useState(active || selected), 2), checked = _React7_useState[0], check = _React7_useState[1];
    React7.useEffect(function() {
        check(active !== null && active !== void 0 ? active : false);
    }, [
        active
    ]);
    var handleOnClick = useFormCallback2(name, function(event) {
        check(!checked);
        if (onChange) {
            onChange(event);
        }
        if (onClick) {
            onClick();
        }
        if (selectAnalytics && checked) {
            var linkName = selectAnalytics.linkName, referrerId = selectAnalytics.referrerId;
            clickTracker(referrerId, linkName);
            return event;
        }
        if (deselectAnalytics && !checked) {
            var linkName1 = deselectAnalytics.linkName, referrerId1 = deselectAnalytics.referrerId;
            clickTracker(referrerId1, linkName1);
        }
        return event;
    });
    return /* @__PURE__ */ React7.createElement(UitkLayoutFlexItem, {
        shrink: 0
    }, /* @__PURE__ */ React7.createElement(UitkPill2, {
        checked: checked,
        active: checked,
        selected: selected,
        disabled: disabled,
        icon: (icon === null || icon === void 0 ? void 0 : icon.__typename) === "Icon" ? icon.token : "",
        id: name,
        name: "".concat(EGDS_BASIC_TRIGGER_PILL_PREFIX, "-").concat(name),
        triggerPill: triggerPill,
        onClick: handleOnClick,
        altText: accessibility !== null && accessibility !== void 0 ? accessibility : "",
        domRef: domRef
    }, primary));
};
EGDSBasicTriggerPill.displayName = "EGDSBasicTriggerPillFragment";
EGDSBasicTriggerPill.fragment = __Fragment7;
// ../internal/src/components/common/egds-pill/egds-pill.tsx
var __Fragment8 = gql10(_templateObject9(), EGDSBasicPill.fragment, EGDSBasicTriggerPill.fragment, EGDSBasicRemovablePill.fragment);
var EGDSPill = function(props) {
    var data = props.data;
    switch(data.__typename){
        case "EGDSBasicPill":
            return /* @__PURE__ */ React8.createElement(EGDSBasicPill, _objectSpreadProps(_objectSpread({}, props), {
                data: data
            }));
        case "EGDSBasicTriggerPill":
            return /* @__PURE__ */ React8.createElement(EGDSBasicTriggerPill, _objectSpreadProps(_objectSpread({}, props), {
                data: data
            }));
        case "EGDSBasicRemovablePill":
            return /* @__PURE__ */ React8.createElement(EGDSBasicRemovablePill, _objectSpreadProps(_objectSpread({}, props), {
                data: data
            }));
        default:
            return null;
    }
};
EGDSPill.displayName = "EGDSPill";
EGDSPill.fragment = __Fragment8;
// ../internal/src/components/sort-filter/__private/__fragments/toggle-filter-pill-field.tsx
var __Fragment9 = gql11(_templateObject10(), EGDSPill.fragment);
var ToggleFilterPillField = function(param) {
    var data = param.data;
    var filterPill = data.filterPill;
    if (filterPill === null || filterPill.__typename !== "EGDSBasicPill") {
        return null;
    }
    return /* @__PURE__ */ React9.createElement(EGDSPill, {
        data: filterPill
    });
};
ToggleFilterPillField.displayName = "ToggleFilterPillField";
ToggleFilterPillField.fragment = __Fragment9;
ToggleFilterPillField.fragment.__typename = "ShoppingSortAndFilterToggleFilter";
// ../internal/src/components/sort-filter/search-tools-filter-pill.tsx
var __Fragment10 = gql12(_templateObject11(), ToggleFilterPillField.fragment);
var filterPillpadding = {
    block: "half"
};
var SearchToolsFilterPill = function(param) {
    var data = param.data, onClick = param.onClick, onEmptyResults = param.onEmptyResults;
    var quickAccessFilters = data.quickAccessFilters;
    if (!quickAccessFilters) {
        onEmptyResults === null || onEmptyResults === void 0 ? void 0 : onEmptyResults();
        return null;
    }
    return /* @__PURE__ */ React10.createElement(UitkPillContainer2, null, quickAccessFilters === null || quickAccessFilters === void 0 ? void 0 : quickAccessFilters.map(function(filterPill, index) {
        var fieldID = "filter-pill-".concat(index);
        if (filterPill.__typename !== ToggleFilterPillField.fragment.__typename) {
            return null;
        }
        return /* @__PURE__ */ React10.createElement(UitkSpacing2, {
            key: fieldID,
            padding: filterPillpadding
        }, /* @__PURE__ */ React10.createElement("div", {
            "test-id": fieldID,
            "data-stid": fieldID
        }, /* @__PURE__ */ React10.createElement(ToggleFilterPillField, {
            data: filterPill
        })));
    }));
};
SearchToolsFilterPill.displayName = "SearchToolsFilterPill";
SearchToolsFilterPill.fragment = __Fragment10;
// ../internal/src/components/sort-filter/search-tools-filters.tsx
import React34 from "react";
import { gql as gql34 } from "@apollo/client";
// ../internal/src/components/sort-filter/__private/__fragments/section.tsx
import React33 from "react";
import { gql as gql33 } from "@apollo/client";
import { UitkSpacing as UitkSpacing12 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading11 } from "uitk-react-text";
// ../internal/src/components/sort-filter/__private/__fragments/context/field-state-provider.tsx
import React11 from "react";
// ../internal/src/components/sort-filter/__private/__fragments/context/utils.ts
var updateSliderValueForMutex = function(field, action) {
    if ((field === null || field === void 0 ? void 0 : field.__typename) === "ShoppingMutexField") {
        var _field_options;
        var _field_options_map;
        return _objectSpreadProps(_objectSpread({}, field), {
            options: (_field_options_map = (_field_options = field.options) === null || _field_options === void 0 ? void 0 : _field_options.map(function(option) {
                var mutexOption = option.mutexOption;
                if (mutexOption.__typename === "ShoppingRangeField") {
                    var _mutexOption_range;
                    return _objectSpreadProps(_objectSpread({}, option), {
                        mutexOption: _objectSpreadProps(_objectSpread({}, mutexOption), {
                            range: ((_mutexOption_range = mutexOption.range) === null || _mutexOption_range === void 0 ? void 0 : _mutexOption_range.id) === action.id ? _objectSpreadProps(_objectSpread({}, mutexOption.range), {
                                selected: action.min !== -1 && action.max !== -1 ? _objectSpreadProps(_objectSpread({}, mutexOption.range.selected), {
                                    min: action.min,
                                    max: action.max
                                }) : _objectSpreadProps(_objectSpread({}, mutexOption.range.selected), {
                                    min: mutexOption.range.characteristics.min,
                                    max: mutexOption.range.characteristics.max
                                })
                            }) : mutexOption.range
                        })
                    });
                }
                return option;
            })) !== null && _field_options_map !== void 0 ? _field_options_map : null
        });
    }
    return field;
};
var calculateQuickFilterFields = function(fields) {
    var clearQuickFilterFields = [];
    fields === null || fields === void 0 ? void 0 : fields.forEach(function(field) {
        if (field.__typename === "ShoppingStepInputField") {
            clearQuickFilterFields.push({
                key: "".concat(field.stepInputId)
            });
        }
        if (field.__typename === "ShoppingRangeField") {
            clearQuickFilterFields.push({
                key: field.range.id
            });
        }
        if (field.__typename === "ShoppingMutexField") {
            field.options.forEach(function(option) {
                clearQuickFilterFields.push({
                    key: "".concat(option.mutexOption.range.id)
                });
            });
        }
        if (field.__typename === "ShoppingMultiSelectionField") {
            field.options.forEach(function(option) {
                clearQuickFilterFields.push({
                    key: option.fieldId,
                    value: option.value
                });
            });
        }
        if (field.__typename === "ShoppingSelectionField") {
            field.options.forEach(function(option) {
                clearQuickFilterFields.push({
                    key: option.fieldId,
                    value: option.value
                });
            });
        }
        if (field.__typename === "ShoppingMultiSelectionStackedTileField") {
            field.multiOptions.forEach(function(option) {
                clearQuickFilterFields.push({
                    key: option.fieldId
                });
            });
        }
    });
    return clearQuickFilterFields;
};
// ../internal/src/components/sort-filter/__private/__fragments/context/field-state-reducer.tsx
var fieldStateReducer = function(state, action) {
    switch(action.type){
        case "RESET_STATE" /* RESET_STATE_FOR_MUTEX */ :
            {
                return action.state;
            }
        case "UPDATE_SLIDER_VALUE" /* UPDATE_SLIDER_VALUE_FOR_MUTEX */ :
            {
                var field = updateSliderValueForMutex(state.field, action);
                return _objectSpreadProps(_objectSpread({}, state), {
                    field: field
                });
            }
        default:
            return state;
    }
};
// ../internal/src/components/sort-filter/__private/__fragments/context/field-state-provider.tsx
var FieldStateContext = React11.createContext({
    state: {}
});
var FieldStateProvider = function(param) {
    var children = param.children, field = param.field;
    var _React11_useReducer = _slicedToArray(React11.useReducer(fieldStateReducer, {
        field: field
    }), 2), state = _React11_useReducer[0], dispatch = _React11_useReducer[1];
    var fieldStateContext = {
        state: state,
        dispatch: dispatch
    };
    return /* @__PURE__ */ React11.createElement(FieldStateContext.Provider, {
        value: fieldStateContext
    }, children);
};
var useFieldStateContext = function() {
    return React11.useContext(FieldStateContext);
};
// ../internal/src/components/sort-filter/__private/__fragments/dropdown-field.tsx
import React12 from "react";
import { gql as gql13 } from "@apollo/client";
import { useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
import { useFormCallback as useFormCallback3 } from "uitk-react-form";
import { UitkSelect } from "uitk-react-input";
import { UitkHeading } from "uitk-react-text";
var __Fragment11 = gql13(_templateObject12());
var DropdownField = function(param) {
    var data = param.data, onSelectedField = param.onSelectedField, onKeyPress = param.onKeyPress, onClick = param.onClick, resetFilters = param.resetFilters, hasNoSectionTitle = param.hasNoSectionTitle;
    var _data_dropdownOptions_find;
    var primary = data.primary, secondary = data.secondary, dropdownOptions = data.dropdownOptions;
    var _ref;
    var label = (_ref = primary !== null && primary !== void 0 ? primary : secondary) !== null && _ref !== void 0 ? _ref : "";
    var _dropdownOptions_;
    var _ref1 = (_dropdownOptions_ = dropdownOptions[0]) !== null && _dropdownOptions_ !== void 0 ? _dropdownOptions_ : {}, id = _ref1.id, firstValue = _ref1.value;
    var defaultValue = Array.isArray(data.dropdownOptions) ? (_data_dropdownOptions_find = data.dropdownOptions.find(function(option) {
        return option.selected;
    })) === null || _data_dropdownOptions_find === void 0 ? void 0 : _data_dropdownOptions_find.value : firstValue;
    var _React12_useState = _slicedToArray(React12.useState(defaultValue), 2), selectedFieldValue = _React12_useState[0], setSelectedFieldValue = _React12_useState[1];
    var clickTracker = useClickTracker6();
    var handleChange = useFormCallback3(id, function(event) {
        var selectedOption = dropdownOptions.find(function(value) {
            return value.value === event.currentTarget.value;
        });
        var deselectedOption = dropdownOptions.find(function(value) {
            return value.value === selectedFieldValue;
        });
        if (deselectedOption === null || deselectedOption === void 0 ? void 0 : deselectedOption.deselectAnalytics) {
            var _deselectedOption_deselectAnalytics = deselectedOption.deselectAnalytics, referrerId = _deselectedOption_deselectAnalytics.referrerId, linkName = _deselectedOption_deselectAnalytics.linkName;
            clickTracker(referrerId, linkName);
        }
        if (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.selectAnalytics) {
            var _selectedOption_selectAnalytics = selectedOption.selectAnalytics, referrerId1 = _selectedOption_selectAnalytics.referrerId, linkName1 = _selectedOption_selectAnalytics.linkName;
            clickTracker(referrerId1, linkName1);
        }
        setSelectedFieldValue(event.currentTarget.value);
        onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
        return event;
    });
    var handleOnClick = function() {
        var field = {
            name: id
        };
        onClick === null || onClick === void 0 ? void 0 : onClick(field);
    };
    var handleKeyPress = function() {
        onKeyPress === null || onKeyPress === void 0 ? void 0 : onKeyPress();
    };
    React12.useEffect(function() {
        setSelectedFieldValue(defaultValue);
    }, [
        defaultValue
    ]);
    React12.useEffect(function() {
        if (resetFilters) {
            setSelectedFieldValue(firstValue);
        }
    }, [
        resetFilters
    ]);
    return /* @__PURE__ */ React12.createElement(React12.Fragment, null, hasNoSectionTitle && /* @__PURE__ */ React12.createElement(UitkHeading, {
        className: "is-visually-hidden",
        tag: "h4"
    }, label), /* @__PURE__ */ React12.createElement(UitkSelect, {
        id: "sort-filter-dropdown-".concat(id),
        value: selectedFieldValue,
        defaultValue: selectedFieldValue,
        name: id,
        label: label,
        emptyState: false,
        onChange: handleChange,
        onKeyPress: handleKeyPress,
        onClick: handleOnClick
    }, dropdownOptions.map(function(param, optionIndex) {
        var primaryOption = param.primary, selected = param.selected, value = param.value;
        return /* @__PURE__ */ React12.createElement("option", {
            key: optionIndex,
            value: value,
            "aria-selected": selected,
            "data-opt-id": value
        }, primaryOption);
    })));
};
DropdownField.displayName = "DropdownField";
DropdownField.fragment = __Fragment11;
DropdownField.fragment.__typename = "ShoppingDropdownField";
// ../internal/src/components/sort-filter/__private/__fragments/multi-selection-stacked-tile-field.tsx
import React14 from "react";
import { gql as gql15 } from "@apollo/client";
import { UitkButtonToggleGroup } from "uitk-react-button-toggle";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading2, UitkParagraph } from "uitk-react-text";
// ../internal/src/components/sort-filter/__private/__fragments/multi-selection-stacked-tile-field-option.tsx
import React13, { useState } from "react";
import { gql as gql14 } from "@apollo/client";
import { useClickTracker as useClickTracker7 } from "@shared-ui/clickstream-analytics-context";
import { UitkButtonToggle } from "uitk-react-button-toggle";
import { useFormCallback as useFormCallback4 } from "uitk-react-form";
import { UitkIconSize as UitkIconSize2 } from "uitk-react-icons";
var __Fragment12 = gql14(_templateObject13(), Icon.fragment);
var MultiSelectionStackedTileFieldOption = function(param) {
    var data = param.data, onSelectedField = param.onSelectedField, resetFilters = param.resetFilters;
    var fieldId = data.fieldId, primary = data.primary, selected = data.selected, value = data.value, icon = data.icon, accessibility = data.accessibility, disabled = data.disabled, __typename = data.__typename;
    var _useState = _slicedToArray(useState(selected), 2), checked = _useState[0], setChecked = _useState[1];
    var track = useClickTracker7();
    var handleChange = useFormCallback4(fieldId, function(event) {
        if (data.selectAnalytics && !checked) {
            var _data_selectAnalytics = data.selectAnalytics, referrerId = _data_selectAnalytics.referrerId, linkName = _data_selectAnalytics.linkName;
            track(referrerId, linkName);
        }
        if (data.deselectAnalytics && checked) {
            var _data_deselectAnalytics = data.deselectAnalytics, referrerId1 = _data_deselectAnalytics.referrerId, linkName1 = _data_deselectAnalytics.linkName;
            track(referrerId1, linkName1);
        }
        setChecked(event.currentTarget.checked);
        onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
        return event;
    });
    React13.useEffect(function() {
        if (resetFilters) {
            setChecked(false);
        }
    }, [
        resetFilters
    ]);
    return /* @__PURE__ */ React13.createElement(UitkButtonToggle, _objectSpreadProps(_objectSpread({
        key: "".concat(fieldId, "-").concat(value),
        name: fieldId,
        id: "".concat(__typename, "-").concat(fieldId, "-").concat(value),
        value: value,
        checked: checked,
        disabled: disabled
    }, icon ? {
        icon: icon === null || icon === void 0 ? void 0 : icon.id
    } : {}), {
        labelText: primary,
        altText: accessibility || "",
        iconSize: UitkIconSize2.EXTRA_SMALL,
        onChange: handleChange
    }));
};
MultiSelectionStackedTileFieldOption.displayName = "MultiSelectionStackedTileFieldOption";
MultiSelectionStackedTileFieldOption.fragment = __Fragment12;
// ../internal/src/components/sort-filter/__private/__fragments/multi-selection-stacked-tile-field.tsx
var __Fragment13 = gql15(_templateObject14(), MultiSelectionStackedTileFieldOption.fragment);
var MultiSelectionStackedTileField = function(param) {
    var data = param.data, onSelectedField = param.onSelectedField, resetFilters = param.resetFilters;
    var multiOptions = data.multiOptions, primary = data.primary, secondary = data.secondary;
    return /* @__PURE__ */ React14.createElement("fieldset", null, /* @__PURE__ */ React14.createElement("legend", null, primary && /* @__PURE__ */ React14.createElement(UitkSpacing3, {
        margin: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React14.createElement(UitkHeading2, {
        tag: "h4",
        size: 7
    }, primary))), secondary && /* @__PURE__ */ React14.createElement(UitkParagraph, null, secondary), multiOptions && /* @__PURE__ */ React14.createElement(UitkSpacing3, {
        padding: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React14.createElement(UitkButtonToggleGroup, {
        wrapButtons: true
    }, multiOptions === null || multiOptions === void 0 ? void 0 : multiOptions.map(function(option, i) {
        return(/**
     * To remove a selected filter on the PWA and reset the state we change the key using the selected prop and reset the filter
     */ /* @__PURE__ */ React14.createElement(MultiSelectionStackedTileFieldOption, {
            resetFilters: resetFilters,
            data: option,
            key: "".concat(i, "-").concat(option.selected),
            onSelectedField: onSelectedField
        }));
    }))));
};
MultiSelectionStackedTileField.displayName = "MultiSelectionStackedTileField";
MultiSelectionStackedTileField.fragment = __Fragment13;
MultiSelectionStackedTileField.fragment.__typename = "ShoppingMultiSelectionStackedTileField";
// ../internal/src/components/sort-filter/__private/__fragments/multi-selection-tile-field.tsx
import React16 from "react";
import { gql as gql17 } from "@apollo/client";
import { UitkButtonToggleGroup as UitkButtonToggleGroup2 } from "uitk-react-button-toggle";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading3, UitkParagraph as UitkParagraph2 } from "uitk-react-text";
// ../internal/src/components/sort-filter/__private/__fragments/multi-selection-tile-field-option.tsx
import React15, { useState as useState2 } from "react";
import { gql as gql16 } from "@apollo/client";
import { useClickTracker as useClickTracker8 } from "@shared-ui/clickstream-analytics-context";
import { UitkButtonToggle as UitkButtonToggle2 } from "uitk-react-button-toggle";
import { useFormCallback as useFormCallback5 } from "uitk-react-form";
import { UitkIconSize as UitkIconSize3 } from "uitk-react-icons";
var __Fragment14 = gql16(_templateObject15(), Icon.fragment);
var MultiSelectionTileFieldOption = function(param) {
    var data = param.data, onSelectedField = param.onSelectedField, resetFilters = param.resetFilters;
    var fieldId = data.fieldId, primary = data.primary, secondary = data.secondary, selected = data.selected, value = data.value, icon = data.icon, accessibility = data.accessibility, disabled = data.disabled, __typename = data.__typename;
    var _useState2 = _slicedToArray(useState2(selected), 2), checked = _useState2[0], setChecked = _useState2[1];
    var track = useClickTracker8();
    var handleChange = useFormCallback5(fieldId, function(event) {
        if (data.selectAnalytics && !checked) {
            var _data_selectAnalytics = data.selectAnalytics, referrerId = _data_selectAnalytics.referrerId, linkName = _data_selectAnalytics.linkName;
            track(referrerId, linkName);
        }
        if (data.deselectAnalytics && checked) {
            var _data_deselectAnalytics = data.deselectAnalytics, referrerId1 = _data_deselectAnalytics.referrerId, linkName1 = _data_deselectAnalytics.linkName;
            track(referrerId1, linkName1);
        }
        setChecked(event.currentTarget.checked);
        onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
        return event;
    });
    React15.useEffect(function() {
        if (resetFilters) {
            setChecked(false);
        }
    }, [
        resetFilters
    ]);
    return /* @__PURE__ */ React15.createElement(UitkButtonToggle2, _objectSpreadProps(_objectSpread({
        key: "".concat(fieldId, "-").concat(value),
        name: fieldId,
        id: "".concat(__typename, "-").concat(fieldId, "-").concat(value),
        value: value,
        checked: checked,
        disabled: disabled
    }, icon ? {
        icon: icon === null || icon === void 0 ? void 0 : icon.id
    } : {}), {
        labelText: primary,
        subLabelText: secondary || "",
        altText: accessibility || "",
        iconSize: UitkIconSize3.EXTRA_SMALL,
        onChange: handleChange,
        stacked: true
    }));
};
MultiSelectionTileFieldOption.displayName = "MultiSelectionTileFieldOption";
MultiSelectionTileFieldOption.fragment = __Fragment14;
// ../internal/src/components/sort-filter/__private/__fragments/multi-selection-tile-field.tsx
var __Fragment15 = gql17(_templateObject16(), MultiSelectionTileFieldOption.fragment);
var MultiSelectionTileField = function(param) {
    var data = param.data, onSelectedField = param.onSelectedField, resetFilters = param.resetFilters;
    var multiOptions = data.multiOptions, primary = data.primary, secondary = data.secondary;
    return /* @__PURE__ */ React16.createElement("fieldset", null, /* @__PURE__ */ React16.createElement("legend", null, primary && /* @__PURE__ */ React16.createElement(UitkSpacing4, {
        margin: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React16.createElement(UitkHeading3, {
        tag: "h4",
        size: 7
    }, primary))), secondary && /* @__PURE__ */ React16.createElement(UitkParagraph2, null, secondary), multiOptions && /* @__PURE__ */ React16.createElement(UitkSpacing4, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React16.createElement(UitkButtonToggleGroup2, {
        wrapButtons: true
    }, multiOptions === null || multiOptions === void 0 ? void 0 : multiOptions.map(function(option, i) {
        return(/**
     * To remove a selected filter on the PWA and reset the state we change the key using the selected prop and reset the filter
     */ /* @__PURE__ */ React16.createElement(MultiSelectionTileFieldOption, {
            data: option,
            key: "".concat(i, "-").concat(option.selected),
            onSelectedField: onSelectedField,
            resetFilters: resetFilters
        }));
    }))));
};
MultiSelectionTileField.displayName = "MultiSelectionTileField";
MultiSelectionTileField.fragment = __Fragment15;
MultiSelectionTileField.fragment.__typename = "ShoppingMultiSelectionTileField";
// ../internal/src/components/sort-filter/__private/__fragments/multiselection-field.tsx
import React22 from "react";
import { gql as gql24 } from "@apollo/client";
import { useClickTracker as useClickTracker10 } from "@shared-ui/clickstream-analytics-context";
import { UitkExpandoPeek } from "uitk-react-expando";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing6 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading4 } from "uitk-react-text";
// ../internal/src/components/sort-filter/__private/__fragments/multiselection-option-field.tsx
import React21, { useEffect, useState as useState3 } from "react";
import { gql as gql23 } from "@apollo/client";
import { useClickTracker as useClickTracker9 } from "@shared-ui/clickstream-analytics-context";
import { useSignalSubscriber } from "@shared-ui/signal-events-context";
import { UitkCheckbox } from "uitk-react-checkbox";
import { useFormCallback as useFormCallback6 } from "uitk-react-form";
import { UitkLayoutFlex, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing5 } from "uitk-react-spacing";
import { UitkText as UitkText2 } from "uitk-react-text";
// ../internal/src/utils/trigger-input-change-event.ts
var triggerInputChangeEvent = function(value, handler, inputType) {
    var event = new CustomEvent("change");
    var input = document.createElement("input");
    if (inputType) {
        input.type = inputType;
    }
    input.value = value;
    var changeListener = function(inputEvent) {
        handler(inputEvent);
    };
    input.addEventListener("change", changeListener);
    input.dispatchEvent(event);
    input.removeEventListener("change", changeListener);
};
// ../internal/src/components/sort-filter/__private/__fragments/signals/state-utils.ts
var selectedFiltersStateReducer = function(state, action) {
    if (action.type === "SortAndFilterClearAllFilters" /* CLEAR */ ) {
        return _objectSpreadProps(_objectSpread({}, state), {
            selectedFilters: [],
            isFirstSelectedFilter: false
        });
    }
    if (action.type === "SortAndFilterClearFilterById" /* CLEAR_BY_ID */ ) {
        var selectedFilters = state.selectedFilters.filter(function(param) {
            var filter = param.filter;
            if ((filter === null || filter === void 0 ? void 0 : filter.__typename) !== "EGDSBasicRemovablePill") {
                return true;
            }
            return filter.id !== action.payload.id;
        });
        return _objectSpreadProps(_objectSpread({}, state), {
            selectedFilters: selectedFilters,
            isFirstSelectedFilter: false
        });
    }
    var payload = action.payload;
    switch(payload.__typename){
        case "SortAndFilterSelectedFilterPillPayload" /* SELECTED_PILL */ :
            {
                var deselectionSignalId = payload.deselectionSignalId, filter = payload.filter, filterNameResolved = payload.filterNameResolved;
                if (filter.__typename !== "EGDSBasicRemovablePill") {
                    return state;
                }
                var filterId = filter.id;
                var selectedFilters1 = state.selectedFilters;
                var filterPillExists = selectedFilters1.some(function(selectedFilter) {
                    var _selectedFilter_filter;
                    if (((_selectedFilter_filter = selectedFilter.filter) === null || _selectedFilter_filter === void 0 ? void 0 : _selectedFilter_filter.__typename) !== "EGDSBasicRemovablePill") {
                        return false;
                    }
                    return selectedFilter.filter.id === filterId;
                });
                if (filterPillExists) {
                    var updatedSelectedFilters = selectedFilters1.map(function(selectedFilter) {
                        var filterPill = selectedFilter.filter;
                        if ((filterPill === null || filterPill === void 0 ? void 0 : filterPill.__typename) !== "EGDSBasicRemovablePill") {
                            return selectedFilter;
                        }
                        if (filterPill.id === filterId) {
                            return _objectSpreadProps(_objectSpread({}, selectedFilter), {
                                filter: _objectSpreadProps(_objectSpread({}, filterPill), {
                                    primary: filterNameResolved !== null && filterNameResolved !== void 0 ? filterNameResolved : "",
                                    removeAnalytics: filter.removeAnalytics
                                })
                            });
                        }
                        return selectedFilter;
                    });
                    return _objectSpreadProps(_objectSpread({}, state), {
                        selectedFilters: updatedSelectedFilters,
                        isFirstSelectedFilter: false
                    });
                }
                var newFilter = {
                    __typename: "ShoppingSelectedFilter",
                    filter: _objectSpreadProps(_objectSpread({}, filter), {
                        primary: filterNameResolved !== null && filterNameResolved !== void 0 ? filterNameResolved : "",
                        removeAnalytics: filter.removeAnalytics
                    }),
                    emitters: [
                        {
                            __typename: "SortAndFilterSignalEmitter",
                            signalId: deselectionSignalId !== null && deselectionSignalId !== void 0 ? deselectionSignalId : "",
                            condition: "UNSELECTED" /* UNSELECTED */ ,
                            payload: {
                                __typename: "SortAndFilterBasicFilterPayload" /* BASIC */ ,
                                filterId: filterId !== null && filterId !== void 0 ? filterId : "",
                                type: "REMOVE" /* REMOVE */ 
                            }
                        }
                    ]
                };
                return _objectSpreadProps(_objectSpread({}, state), {
                    isFirstSelectedFilter: selectedFilters1.length === 0,
                    selectedFilters: _toConsumableArray(selectedFilters1).concat([
                        newFilter
                    ])
                });
            }
        case "SortAndFilterBasicFilterPayload" /* BASIC */ :
            {
                switch(payload.type){
                    case "REMOVE" /* REMOVE */ :
                        return _objectSpreadProps(_objectSpread({}, state), {
                            isFirstSelectedFilter: false,
                            selectedFilters: state.selectedFilters.filter(function(param) {
                                var filter = param.filter;
                                if ((filter === null || filter === void 0 ? void 0 : filter.__typename) !== "EGDSBasicRemovablePill") {
                                    return true;
                                }
                                return filter.id !== payload.filterId;
                            })
                        });
                    default:
                        return state;
                }
            }
        default:
            return state;
    }
};
var resolveDataValue = function(source, options) {
    switch(source){
        case "selected.min" /* RANGE_MIN */ :
            var _options_rangeOptions;
            return "".concat((_options_rangeOptions = options.rangeOptions) === null || _options_rangeOptions === void 0 ? void 0 : _options_rangeOptions.nextMin);
        case "selected.max" /* RANGE_MAX */ :
            var _options_rangeOptions1;
            return "".concat((_options_rangeOptions1 = options.rangeOptions) === null || _options_rangeOptions1 === void 0 ? void 0 : _options_rangeOptions1.nextMax);
        case "stepInput.value" /* STEP_VALUE */ :
            var _options_stepInputOptions;
            return "".concat((_options_stepInputOptions = options.stepInputOptions) === null || _options_stepInputOptions === void 0 ? void 0 : _options_stepInputOptions.nextValue);
        default:
            return "";
    }
};
var resolveFilterName = function(filterName, options) {
    switch(filterName.__typename){
        case "EGDSPlainText" /* PLAIN_TEXT */ :
            return filterName.text;
        case "EGDSBasicLocalizedText" /* BASIC_LOCALIZED_TEXT */ :
            {
                var template = filterName.template, models = filterName.models;
                return models.reduce(function(resolvedTemplate, param) {
                    var key = param.key, source = param.source;
                    var value = resolveDataValue(source, options);
                    return resolvedTemplate.replace("{".concat(key, "}"), value);
                }, template);
            }
        default:
            return "";
    }
};
var buildPayload = function(payload, condition) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _options_selectionOptions;
    var guardClause = true;
    switch(condition){
        case "SELECTED" /* SELECTED */ :
            if (options.selectionOptions) {
                guardClause = options.selectionOptions.prevChecked;
            }
            break;
        case "UNSELECTED" /* UNSELECTED */ :
            guardClause = false;
            if (options.selectionOptions) {
                guardClause = !options.selectionOptions.prevChecked;
            }
            break;
        case "DEFAULT_TO_NON_DEFAULT" /* DEFAULT_TO_NON_DEFAULT */ :
            if (options.rangeOptions) {
                var _options_rangeOptions = options.rangeOptions, prevMin = _options_rangeOptions.prevMin, nextMin = _options_rangeOptions.nextMin, defaultMin = _options_rangeOptions.defaultMin, prevMax = _options_rangeOptions.prevMax, nextMax = _options_rangeOptions.nextMax, defaultMax = _options_rangeOptions.defaultMax;
                guardClause = prevMin !== defaultMin || prevMax !== defaultMax || nextMin === defaultMin && nextMax === defaultMax;
            } else if (options.stepInputOptions) {
                var _options_stepInputOptions = options.stepInputOptions, prevValue = _options_stepInputOptions.prevValue, defaultValue = _options_stepInputOptions.defaultValue;
                guardClause = prevValue !== defaultValue;
            }
            break;
        case "NON_DEFAULT_TO_NON_DEFAULT" /* NON_DEFAULT_TO_NON_DEFAULT */ :
            if (options.rangeOptions) {
                var _options_rangeOptions1 = options.rangeOptions, prevMin1 = _options_rangeOptions1.prevMin, nextMin1 = _options_rangeOptions1.nextMin, defaultMin1 = _options_rangeOptions1.defaultMin, prevMax1 = _options_rangeOptions1.prevMax, nextMax1 = _options_rangeOptions1.nextMax, defaultMax1 = _options_rangeOptions1.defaultMax;
                guardClause = prevMin1 === defaultMin1 && prevMax1 === defaultMax1 || nextMin1 === defaultMin1 && nextMax1 === defaultMax1;
            } else if (options.stepInputOptions) {
                var _options_stepInputOptions1 = options.stepInputOptions, prevValue1 = _options_stepInputOptions1.prevValue, nextValue = _options_stepInputOptions1.nextValue, defaultValue1 = _options_stepInputOptions1.defaultValue;
                guardClause = prevValue1 === defaultValue1 || nextValue === defaultValue1;
            }
            break;
        case "NON_DEFAULT_TO_DEFAULT" /* NON_DEFAULT_TO_DEFAULT */ :
            if (options.rangeOptions) {
                var _options_rangeOptions2 = options.rangeOptions, nextMin2 = _options_rangeOptions2.nextMin, defaultMin2 = _options_rangeOptions2.defaultMin, nextMax2 = _options_rangeOptions2.nextMax, defaultMax2 = _options_rangeOptions2.defaultMax;
                guardClause = nextMin2 !== defaultMin2 || nextMax2 !== defaultMax2;
            } else if (options.stepInputOptions) {
                var _options_stepInputOptions2 = options.stepInputOptions, nextValue1 = _options_stepInputOptions2.nextValue, defaultValue2 = _options_stepInputOptions2.defaultValue;
                guardClause = nextValue1 !== defaultValue2;
            }
            break;
        default:
            guardClause = true;
    }
    if (guardClause) {
        return null;
    }
    if (payload.__typename === "SortAndFilterSelectedFilterPillPayload" /* SELECTED_PILL */ ) {
        var filterNameResolved = resolveFilterName(payload.filterName, options);
        if (payload.filter.__typename === "EGDSBasicRemovablePill" && payload.filter.removeAnalytics) {
            var newReferrerId = payload.filter.removeAnalytics.referrerId;
            if (options.rangeOptions) {
                var _options_rangeOptions3 = options.rangeOptions, analyticsMin = _options_rangeOptions3.analyticsMin, analyticsMax = _options_rangeOptions3.analyticsMax;
                var minMaxValues = "".concat(analyticsMin, ",").concat(analyticsMax);
                newReferrerId = "".concat(newReferrerId, ".").concat(minMaxValues);
            } else if (options.stepInputOptions) {
                var nextValue2 = options.stepInputOptions.nextValue;
                newReferrerId = "".concat(newReferrerId, ".").concat(nextValue2);
            }
            return _objectSpreadProps(_objectSpread({}, payload), {
                filter: _objectSpreadProps(_objectSpread({}, payload.filter), {
                    removeAnalytics: _objectSpreadProps(_objectSpread({}, payload.filter.removeAnalytics), {
                        referrerId: newReferrerId
                    })
                }),
                filterNameResolved: filterNameResolved
            });
        }
        return _objectSpreadProps(_objectSpread({}, payload), {
            filterNameResolved: filterNameResolved
        });
    }
    return _objectSpreadProps(_objectSpread({}, payload), {
        prevChecked: (_options_selectionOptions = options.selectionOptions) === null || _options_selectionOptions === void 0 ? void 0 : _options_selectionOptions.prevChecked
    });
};
// ../internal/src/components/common/ui-graphic/ui-graphic.tsx
import React18 from "react";
import { gql as gql19 } from "@apollo/client";
// ../internal/src/components/common/ui-graphic/mark.tsx
import React17 from "react";
import { gql as gql18 } from "@apollo/client";
import { UitkMark } from "uitk-react-mark";
var fragment = gql18(_templateObject17());
var Mark = function(param) {
    var data = param.data, className = param.className;
    return /* @__PURE__ */ React17.createElement(UitkMark, {
        className: className,
        description: data.description,
        id: data.id,
        name: data.id
    });
};
Mark.displayName = "Mark";
Mark.fragment = fragment;
Mark.fragment.__typename = "Mark";
// ../internal/src/components/common/ui-graphic/ui-graphic.tsx
var fragment2 = gql19(_templateObject18(), Mark.fragment);
var UIGraphic = function(param) {
    var data = param.data, markOptions = param.markOptions;
    switch(data.__typename){
        case "Mark":
            return /* @__PURE__ */ React18.createElement(Mark, _objectSpread({
                data: data
            }, markOptions));
        default:
            return null;
    }
};
UIGraphic.displayName = "UIGraphic";
UIGraphic.fragment = fragment2;
// ../internal/src/components/sort-filter/__private/__fragments/signals/signals-fragments.ts
import { gql as gql22 } from "@apollo/client";
// ../internal/src/components/common/egds-text/egds-localized-text-fragments.ts
import { gql as gql20 } from "@apollo/client";
var TemplateModelFragment = gql20(_templateObject19());
var EGDSBasicLocalizedTextFragment = gql20(_templateObject20(), TemplateModelFragment);
var EGDSCardinalLocalizedTextFragment = gql20(_templateObject21(), TemplateModelFragment);
var EGDSCompositeLocalizedTextFragment = gql20(_templateObject22(), TemplateModelFragment);
var EGDSLocalizedTextFragment = gql20(_templateObject23(), EGDSBasicLocalizedTextFragment, EGDSCardinalLocalizedTextFragment, EGDSCompositeLocalizedTextFragment);
// ../internal/src/components/common/egds-text/egds-plain-text.tsx
import React19 from "react";
import { gql as gql21 } from "@apollo/client";
import { UitkText } from "uitk-react-text";
var fragment3 = gql21(_templateObject24());
var EGDSPlainText = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React19.createElement(UitkText, null, data.text);
};
EGDSPlainText.fragment = fragment3;
EGDSPlainText.displayName = "EGDSParagraph";
// ../internal/src/components/sort-filter/__private/__fragments/signals/signals-fragments.ts
var ReceiverFragment = gql22(_templateObject25());
var EmitterFragment = gql22(_templateObject26(), EGDSPlainText.fragment, EGDSBasicLocalizedTextFragment, EGDSBasicRemovablePill.fragment);
// ../internal/src/components/sort-filter/__private/__fragments/signals/with-signals-hoc.tsx
import React20, { useCallback } from "react";
import { useSignalPublisher } from "@shared-ui/signal-events-context";
var withSignals = function(WrappedComponent) {
    var WithSignals = function(props) {
        var publishSignal = useSignalPublisher().publishSignal;
        var emitSignal = useCallback(function(emitters, options) {
            emitters.forEach(function(param) {
                var signalId = param.signalId, condition = param.condition, payload = param.payload;
                var newPayload = buildPayload(payload, condition, options);
                if (newPayload) {
                    publishSignal({
                        type: signalId,
                        payload: newPayload
                    });
                }
            });
        }, [
            publishSignal
        ]);
        var newProps = _objectSpreadProps(_objectSpread({}, props), {
            emitSignal: emitSignal
        });
        return /* @__PURE__ */ React20.createElement(WrappedComponent, _objectSpread({}, newProps));
    };
    WithSignals.displayName = "withSignals(".concat(WrappedComponent.displayName, ")");
    WithSignals.fragment = WrappedComponent.fragment;
    return WithSignals;
};
// ../internal/src/components/sort-filter/__private/__fragments/multiselection-option-field.tsx
var __Fragment16 = gql23(_templateObject27(), UIGraphic.fragment, ReceiverFragment, EmitterFragment);
var MultiSelectionOptionFieldComponent = function(param) {
    var data = param.data, onSelectedField = param.onSelectedField, resetFilters = param.resetFilters, emitSignal = param.emitSignal;
    var fieldId = data.fieldId, primary = data.primary, secondary = data.secondary, selected = data.selected, value = data.value, description = data.description, emitters = data.emitters, receivers = data.receivers, disabled = data.disabled, graphic = data.graphic;
    var _useState3 = _slicedToArray(useState3(selected), 2), checked = _useState3[0], setChecked = _useState3[1];
    var _useState31 = _slicedToArray(useState3(false), 2), triggerInputChange = _useState31[0], setTriggerInputChange = _useState31[1];
    var inputFieldWithSelectionFormCallback = useFormCallback6(fieldId, function(event) {
        return event;
    });
    var uniqueFieldId = React21.useMemo(function() {
        return Math.random().toString(36).slice(2, 5);
    }, []);
    var track = useClickTracker9();
    var _receivers_map;
    var subscriptions = (_receivers_map = receivers === null || receivers === void 0 ? void 0 : receivers.map(function(param) {
        var signalId = param.signalId;
        return {
            query: {
                type: signalId
            },
            callback: function(param) {
                var payload = param.payload;
                if (payload.__typename === "SortAndFilterBasicFilterPayload" /* BASIC */ ) {
                    switch(payload.type){
                        case "REMOVE" /* REMOVE */ :
                            setChecked(false);
                            setTriggerInputChange(true);
                            break;
                        case "OPTION" /* OPTION */ :
                            setChecked(!payload.prevChecked);
                            break;
                        default:
                    }
                }
            }
        };
    })) !== null && _receivers_map !== void 0 ? _receivers_map : [];
    useSignalSubscriber(subscriptions);
    var handleChange = useFormCallback6(fieldId, function(event) {
        if (data.selectAnalytics && !checked) {
            var _data_selectAnalytics = data.selectAnalytics, referrerId = _data_selectAnalytics.referrerId, linkName = _data_selectAnalytics.linkName;
            track(referrerId, linkName);
        }
        if (data.deselectAnalytics && checked) {
            var _data_deselectAnalytics = data.deselectAnalytics, referrerId1 = _data_deselectAnalytics.referrerId, linkName1 = _data_deselectAnalytics.linkName;
            track(referrerId1, linkName1);
        }
        var selectionOptions = {
            prevChecked: checked
        };
        emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal(emitters !== null && emitters !== void 0 ? emitters : [], {
            selectionOptions: selectionOptions
        });
        setChecked(event.currentTarget.checked);
        onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
        return event;
    });
    useEffect(function() {
        if (resetFilters) {
            setChecked(false);
        }
    }, [
        resetFilters
    ]);
    useEffect(function() {
        setChecked(selected);
    }, [
        selected
    ]);
    useEffect(function() {
        if (triggerInputChange) {
            triggerInputChangeEvent(value, inputFieldWithSelectionFormCallback, "checkbox" /* CHECKBOX */ );
            onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
            setTriggerInputChange(false);
        }
    }, [
        triggerInputChange
    ]);
    return /* @__PURE__ */ React21.createElement(UitkLayoutFlex, {
        alignItems: "center",
        space: "two"
    }, /* @__PURE__ */ React21.createElement(UitkSpacing5, {
        padding: {
            inlinestart: "one"
        }
    }, /* @__PURE__ */ React21.createElement(UitkLayoutFlexItem2, {
        grow: 1
    }, /* @__PURE__ */ React21.createElement("div", null, /* @__PURE__ */ React21.createElement(UitkCheckbox, {
        id: "".concat(fieldId, "-").concat(value, "-").concat(uniqueFieldId),
        name: fieldId,
        value: value,
        checked: checked,
        description: description !== null && description !== void 0 ? description : "",
        onChange: handleChange,
        disabled: disabled
    }, graphic && /* @__PURE__ */ React21.createElement(UIGraphic, {
        data: graphic
    }), " ", primary)))), secondary && /* @__PURE__ */ React21.createElement(UitkLayoutFlexItem2, {
        shrink: 0
    }, /* @__PURE__ */ React21.createElement(UitkText2, null, secondary)));
};
MultiSelectionOptionFieldComponent.displayName = "MultiSelectionOptionField";
MultiSelectionOptionFieldComponent.fragment = __Fragment16;
var MultiSelectionOptionField = withSignals(MultiSelectionOptionFieldComponent);
// ../internal/src/components/sort-filter/__private/__fragments/multiselection-field.tsx
var __Fragment17 = gql24(_templateObject28(), MultiSelectionOptionField.fragment);
var MultiSelectionField = function(param) {
    var data = param.data, keepSectionExpanded = param.keepSectionExpanded, onSelectedField = param.onSelectedField, resetFilters = param.resetFilters;
    var _data_options, _data_options1, _data_options2;
    var primary = data.primary, secondary = data.secondary, expando = data.expando, options = data.options;
    var _expando_threshold, _ref;
    var expandoThreshold = (_ref = (_expando_threshold = expando === null || expando === void 0 ? void 0 : expando.threshold) !== null && _expando_threshold !== void 0 ? _expando_threshold : expando === null || expando === void 0 ? void 0 : expando.minimalHeight) !== null && _ref !== void 0 ? _ref : void 0;
    var unexpandedOptions = expandoThreshold ? options === null || options === void 0 ? void 0 : options.slice(expandoThreshold) : null;
    var getExpandoIsVisibleState = function() {
        return !!(keepSectionExpanded && (unexpandedOptions === null || unexpandedOptions === void 0 ? void 0 : unexpandedOptions.some(function(option) {
            return option.selected;
        })));
    };
    var _React22_useState = _slicedToArray(React22.useState(getExpandoIsVisibleState()), 2), expandoIsVisible = _React22_useState[0], setExpandoIsVisible = _React22_useState[1];
    var track = useClickTracker10();
    var handleClick = React22.useCallback(function() {
        setExpandoIsVisible(!expandoIsVisible);
        if ((expando === null || expando === void 0 ? void 0 : expando.expandAnalytics) && !expandoIsVisible) {
            var _expando_expandAnalytics = expando.expandAnalytics, referrerId = _expando_expandAnalytics.referrerId, linkName = _expando_expandAnalytics.linkName;
            track(referrerId, linkName);
        }
        if ((expando === null || expando === void 0 ? void 0 : expando.collapseAnalytics) && expandoIsVisible) {
            var _expando_collapseAnalytics = expando.collapseAnalytics, referrerId1 = _expando_collapseAnalytics.referrerId, linkName1 = _expando_collapseAnalytics.linkName;
            track(referrerId1, linkName1);
        }
    }, [
        setExpandoIsVisible,
        expandoIsVisible
    ]);
    if (!((_data_options = data.options) === null || _data_options === void 0 ? void 0 : _data_options.length)) {
        return null;
    }
    var Base = (expando === null || expando === void 0 ? void 0 : expando.threshold) && ((_data_options1 = data.options) === null || _data_options1 === void 0 ? void 0 : _data_options1.length) > expando.threshold ? UitkExpandoPeek : React22.Fragment;
    var _expando_collapseAccessibilityLabel, _expando_expandAccessibilityLabel;
    var expandoProps = (expando === null || expando === void 0 ? void 0 : expando.threshold) && ((_data_options2 = data.options) === null || _data_options2 === void 0 ? void 0 : _data_options2.length) > expando.threshold ? {
        collapseLabel: expando.collapseLabel,
        expandLabel: expando.expandLabel,
        collapseA11yLabel: (_expando_collapseAccessibilityLabel = expando.collapseAccessibilityLabel) !== null && _expando_collapseAccessibilityLabel !== void 0 ? _expando_collapseAccessibilityLabel : void 0,
        expandA11yLabel: (_expando_expandAccessibilityLabel = expando.expandAccessibilityLabel) !== null && _expando_expandAccessibilityLabel !== void 0 ? _expando_expandAccessibilityLabel : void 0,
        items: expandoThreshold,
        isVisible: expandoIsVisible,
        hideScrim: true,
        handleClick: handleClick
    } : {};
    return /* @__PURE__ */ React22.createElement("fieldset", null, secondary ? /* @__PURE__ */ React22.createElement(React22.Fragment, null, /* @__PURE__ */ React22.createElement("legend", {
        className: "is-visually-hidden"
    }, primary), /* @__PURE__ */ React22.createElement(UitkSpacing6, {
        margin: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React22.createElement(UitkLayoutFlex2, {
        space: "two"
    }, primary && /* @__PURE__ */ React22.createElement(UitkLayoutFlexItem3, {
        grow: 1
    }, /* @__PURE__ */ React22.createElement(UitkHeading4, {
        tag: "h4",
        size: 7
    }, primary)), secondary && /* @__PURE__ */ React22.createElement(UitkLayoutFlexItem3, {
        shrink: 0
    }, /* @__PURE__ */ React22.createElement(UitkHeading4, {
        tag: "h4",
        size: 7
    }, secondary))))) : /* @__PURE__ */ React22.createElement("legend", null, primary && /* @__PURE__ */ React22.createElement(UitkHeading4, {
        tag: "h4",
        size: 7
    }, primary)), /* @__PURE__ */ React22.createElement(Base, _objectSpread({}, expandoProps), options === null || options === void 0 ? void 0 : options.map(function(option, optionIndex) {
        return(/**
     * To remove a selected filter on the PWA and reset the state we change the key using the selected prop and reset the filter
     */ /* @__PURE__ */ React22.createElement(MultiSelectionOptionField, {
            key: "option-".concat(option.fieldId, "-").concat(optionIndex, "-").concat(option.value),
            data: option,
            resetFilters: resetFilters,
            onSelectedField: onSelectedField
        }));
    })));
};
MultiSelectionField.displayName = "MultiSelectionField";
MultiSelectionField.fragment = __Fragment17;
MultiSelectionField.fragment.__typename = "ShoppingMultiSelectionField";
// ../internal/src/components/sort-filter/__private/__fragments/mutex-field.tsx
import React27 from "react";
import { gql as gql29 } from "@apollo/client";
import { useClickTracker as useClickTracker14 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment } from "@shared-ui/experiment-context";
import { useSignalSubscriber as useSignalSubscriber4 } from "@shared-ui/signal-events-context";
import { useFormCallback as useFormCallback8 } from "uitk-react-form";
import { UitkRadioButtonGroup as UitkRadioButtonGroup2 } from "uitk-react-radio-button";
import { UitkSpacing as UitkSpacing9 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading8 } from "uitk-react-text";
// ../internal/src/components/sort-filter/__private/__fragments/range-field.tsx
import React23, { useEffect as useEffect2, useState as useState4 } from "react";
import { gql as gql25 } from "@apollo/client";
import { useClickTracker as useClickTracker11 } from "@shared-ui/clickstream-analytics-context";
import { useSignalSubscriber as useSignalSubscriber2 } from "@shared-ui/signal-events-context";
import { UitkSlider } from "uitk-react-slider";
import { UitkSpacing as UitkSpacing7 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading5 } from "uitk-react-text";
var __Fragment18 = gql25(_templateObject29(), ReceiverFragment, EmitterFragment);
var RangeFieldComponent = function(param) {
    var data = param.data, onRangeSelectionChange = param.onRangeSelectionChange, onSelectedField = param.onSelectedField, resetFilters = param.resetFilters, _param_shouldFireSignalOnMount = param.shouldFireSignalOnMount, shouldFireSignalOnMount = _param_shouldFireSignalOnMount === void 0 ? false : _param_shouldFireSignalOnMount, // default to falsy
    emitSignal = param.emitSignal;
    var primary = data.primary, range = data.range;
    var _ref = range || {}, selected = _ref.selected, characteristics = _ref.characteristics, _ref_id = _ref.id, id = _ref_id === void 0 ? "" : _ref_id, emitters = _ref.emitters, receivers = _ref.receivers;
    var _ref1 = characteristics || {}, _ref_min = _ref1.min, min = _ref_min === void 0 ? 0 : _ref_min, _ref_max = _ref1.max, max = _ref_max === void 0 ? 0 : _ref_max, step = _ref1.step;
    var _ref2 = selected || {}, initialMin = _ref2.min, initialMax = _ref2.max;
    var _useState4 = _slicedToArray(useState4(initialMin), 2), currentMin = _useState4[0], setMin = _useState4[1];
    var _useState41 = _slicedToArray(useState4(initialMax), 2), currentMax = _useState41[0], setMax = _useState41[1];
    var _useState42 = _slicedToArray(useState4(false), 2), triggerInputChange = _useState42[0], setTriggerInputChange = _useState42[1];
    var track = useClickTracker11();
    var unboundedPriceRangeValue = -1;
    var _receivers_map;
    var subscriptions = (_receivers_map = receivers === null || receivers === void 0 ? void 0 : receivers.map(function(param) {
        var signalId = param.signalId;
        return {
            query: {
                type: signalId
            },
            callback: function(param) {
                var payload = param.payload;
                if (payload.__typename === "SortAndFilterBasicFilterPayload" /* BASIC */  && payload.type === "REMOVE" /* REMOVE */ ) {
                    setMin(min);
                    setMax(max);
                    setTriggerInputChange(true);
                }
            }
        };
    })) !== null && _receivers_map !== void 0 ? _receivers_map : [];
    useSignalSubscriber2(subscriptions);
    var formatValue = function(number) {
        var _characteristics_labels;
        var currentLabel = characteristics === null || characteristics === void 0 ? void 0 : (_characteristics_labels = characteristics.labels) === null || _characteristics_labels === void 0 ? void 0 : _characteristics_labels.find(function(param) {
            var value = param.value;
            return value === number;
        });
        var _currentLabel_label;
        return (_currentLabel_label = currentLabel === null || currentLabel === void 0 ? void 0 : currentLabel.label) !== null && _currentLabel_label !== void 0 ? _currentLabel_label : "";
    };
    var handleSliderChange = function(lowerValue, upperValue) {
        var safeLowerValue = upperValue ? lowerValue : min;
        var safeUpperValue = upperValue || lowerValue;
        var rangeOptions = {
            analyticsMin: safeLowerValue,
            analyticsMax: safeUpperValue,
            defaultMax: formatValue(max),
            defaultMin: formatValue(min),
            nextMax: formatValue(safeUpperValue),
            nextMin: formatValue(safeLowerValue),
            prevMax: formatValue(currentMax),
            prevMin: formatValue(currentMin)
        };
        var minDistanceBetweenHandles = step && (characteristics === null || characteristics === void 0 ? void 0 : characteristics.minStepDistance) ? step * characteristics.minStepDistance : 0;
        if (minDistanceBetweenHandles === 0 || typeof upperValue === "undefined" || safeUpperValue - safeLowerValue >= minDistanceBetweenHandles) {
            emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal(emitters !== null && emitters !== void 0 ? emitters : [], {
                rangeOptions: rangeOptions
            });
            setMin(safeLowerValue);
            setMax(safeUpperValue);
        }
    };
    var handleSliderAfterChange = function(lowerValue, upperValue) {
        var safeLowerValue = upperValue ? lowerValue : min;
        var safeUpperValue = upperValue || lowerValue;
        var isRangeSetToDefault = min === safeLowerValue && max === safeUpperValue;
        onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
        if (isRangeSetToDefault) {
            onRangeSelectionChange === null || onRangeSelectionChange === void 0 ? void 0 : onRangeSelectionChange({
                id: id,
                min: unboundedPriceRangeValue,
                max: unboundedPriceRangeValue
            });
        } else {
            onRangeSelectionChange === null || onRangeSelectionChange === void 0 ? void 0 : onRangeSelectionChange({
                id: id,
                min: safeLowerValue,
                max: safeUpperValue
            });
        }
        if (range === null || range === void 0 ? void 0 : range.analytics) {
            track("".concat(range.analytics.referrerId).concat(!isRangeSetToDefault, ".").concat(safeLowerValue, ",").concat(safeUpperValue), range.analytics.linkName);
        }
    };
    useEffect2(function() {
        if (resetFilters) {
            setMin(min);
            setMax(max);
        }
    }, [
        resetFilters
    ]);
    useEffect2(function() {
        if (initialMin === min) {
            setMin(min);
        }
        if (initialMax === max) {
            setMax(max);
        }
    }, [
        initialMin,
        initialMax
    ]);
    useEffect2(function() {
        if (triggerInputChange) {
            onRangeSelectionChange === null || onRangeSelectionChange === void 0 ? void 0 : onRangeSelectionChange({
                id: id,
                min: unboundedPriceRangeValue,
                max: unboundedPriceRangeValue
            });
            onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
            setTriggerInputChange(false);
        }
    }, [
        triggerInputChange
    ]);
    useEffect2(function() {
        if (shouldFireSignalOnMount) {
            var rangeOptions = {
                analyticsMax: max,
                analyticsMin: min,
                defaultMax: formatValue(max),
                defaultMin: formatValue(min),
                nextMax: formatValue(selected === null || selected === void 0 ? void 0 : selected.max),
                nextMin: formatValue(selected === null || selected === void 0 ? void 0 : selected.min),
                prevMax: formatValue(currentMax),
                prevMin: formatValue(currentMin)
            };
            emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal(emitters !== null && emitters !== void 0 ? emitters : [], {
                rangeOptions: rangeOptions
            });
        }
    }, [
        shouldFireSignalOnMount
    ]);
    if (!range) {
        return null;
    }
    return /* @__PURE__ */ React23.createElement(UitkSpacing7, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React23.createElement("div", null, /* @__PURE__ */ React23.createElement("fieldset", null, /* @__PURE__ */ React23.createElement("legend", null, /* @__PURE__ */ React23.createElement(UitkHeading5, {
        tag: "h4",
        size: 7
    }, primary)), /* @__PURE__ */ React23.createElement(UitkSpacing7, {
        margin: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React23.createElement("div", null, /* @__PURE__ */ React23.createElement(UitkSlider, {
        id: id,
        key: "".concat(id, "-").concat(initialMin, "-").concat(initialMax),
        name: id,
        type: "dual",
        min: min,
        max: max,
        step: step,
        handleChange: handleSliderChange,
        handleAfterChange: handleSliderAfterChange,
        lowerValue: currentMin,
        upperValue: currentMax,
        formatValueForDisplay: formatValue,
        formatSecondaryValueForDisplay: formatValue,
        gap: 0
    }))))));
};
RangeFieldComponent.displayName = "RangeField";
RangeFieldComponent.fragment = __Fragment18;
RangeFieldComponent.fragment.__typename = "ShoppingRangeField";
var RangeField = withSignals(RangeFieldComponent);
// ../internal/src/components/sort-filter/__private/__fragments/selection-field.tsx
import React25 from "react";
import { gql as gql27 } from "@apollo/client";
import { useClickTracker as useClickTracker12 } from "@shared-ui/clickstream-analytics-context";
import { UitkExpandoPeek as UitkExpandoPeek2 } from "uitk-react-expando";
import { useFormCallback as useFormCallback7 } from "uitk-react-form";
import { UitkRadioButtonGroup } from "uitk-react-radio-button";
import { UitkSpacing as UitkSpacing8 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading6 } from "uitk-react-text";
// ../internal/src/components/sort-filter/__private/__fragments/selection-option-field.tsx
import React24 from "react";
import { gql as gql26 } from "@apollo/client";
import { UitkRadioButton } from "uitk-react-radio-button";
var __Fragment19 = gql26(_templateObject30());
var SelectionOptionField = function(param) {
    var data = param.data;
    var fieldId = data.fieldId, primary = data.primary, disabled = data.disabled, value = data.value;
    var uniqueFieldId = React24.useMemo(function() {
        return Math.random().toString(36).slice(2, 5);
    }, []);
    return /* @__PURE__ */ React24.createElement(UitkRadioButton, {
        name: fieldId,
        disabled: disabled,
        id: "".concat(fieldId, "-").concat(value, "-").concat(uniqueFieldId),
        value: value
    }, primary);
};
SelectionOptionField.displayName = "SelectionOptionField";
SelectionOptionField.fragment = __Fragment19;
// ../internal/src/components/sort-filter/__private/__fragments/selection-field.tsx
var __Fragment20 = gql27(_templateObject31(), SelectionOptionField.fragment);
var SelectionField = function(param) {
    var data = param.data, keepSectionExpanded = param.keepSectionExpanded, onSelectedField = param.onSelectedField, resetFilters = param.resetFilters;
    var _options_find;
    var primary = data.primary, expando = data.expando, options = data.options;
    var _expando_threshold, _ref;
    var expandoThreshold = (_ref = (_expando_threshold = expando === null || expando === void 0 ? void 0 : expando.threshold) !== null && _expando_threshold !== void 0 ? _expando_threshold : expando === null || expando === void 0 ? void 0 : expando.minimalHeight) !== null && _ref !== void 0 ? _ref : void 0;
    var unexpandedOptions = expandoThreshold ? options === null || options === void 0 ? void 0 : options.slice(expandoThreshold) : null;
    var getExpandoIsVisibleState = function() {
        return !!(keepSectionExpanded && (unexpandedOptions === null || unexpandedOptions === void 0 ? void 0 : unexpandedOptions.some(function(option) {
            return option.selected;
        })));
    };
    var defaultValue = Array.isArray(options) ? (_options_find = options.find(function(option) {
        return option.selected;
    })) === null || _options_find === void 0 ? void 0 : _options_find.value : "";
    var _React25_useState = _slicedToArray(React25.useState(defaultValue), 2), selectedFieldValue = _React25_useState[0], setSelectedFieldValue = _React25_useState[1];
    var _React25_useState1 = _slicedToArray(React25.useState(getExpandoIsVisibleState()), 2), expandoIsVisible = _React25_useState1[0], setExpandoIsVisible = _React25_useState1[1];
    var track = useClickTracker12();
    var fieldId = (options === null || options === void 0 ? void 0 : options.length) ? options[0].fieldId : "";
    var handleChange = useFormCallback7(fieldId, function(event) {
        var _data_options, _data_options1;
        var deselectedOption = (_data_options = data.options) === null || _data_options === void 0 ? void 0 : _data_options.find(function(option) {
            return option.value === selectedFieldValue;
        });
        var selectedOption = (_data_options1 = data.options) === null || _data_options1 === void 0 ? void 0 : _data_options1.find(function(option) {
            return option.value === event.currentTarget.value;
        });
        if (deselectedOption === null || deselectedOption === void 0 ? void 0 : deselectedOption.deselectAnalytics) {
            var _deselectedOption_deselectAnalytics = deselectedOption.deselectAnalytics, referrerId = _deselectedOption_deselectAnalytics.referrerId, linkName = _deselectedOption_deselectAnalytics.linkName;
            track(referrerId, linkName);
        }
        if (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.selectAnalytics) {
            var _selectedOption_selectAnalytics = selectedOption.selectAnalytics, referrerId1 = _selectedOption_selectAnalytics.referrerId, linkName1 = _selectedOption_selectAnalytics.linkName;
            track(referrerId1, linkName1);
        }
        setSelectedFieldValue(event.currentTarget.value);
        onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
        return event;
    });
    var handleClick = React25.useCallback(function() {
        setExpandoIsVisible(!expandoIsVisible);
        if ((expando === null || expando === void 0 ? void 0 : expando.expandAnalytics) && !expandoIsVisible) {
            var _expando_expandAnalytics = expando.expandAnalytics, referrerId = _expando_expandAnalytics.referrerId, linkName = _expando_expandAnalytics.linkName;
            track(referrerId, linkName);
        }
        if ((expando === null || expando === void 0 ? void 0 : expando.collapseAnalytics) && expandoIsVisible) {
            var _expando_collapseAnalytics = expando.collapseAnalytics, referrerId1 = _expando_collapseAnalytics.referrerId, linkName1 = _expando_collapseAnalytics.linkName;
            track(referrerId1, linkName1);
        }
    }, [
        setExpandoIsVisible,
        expandoIsVisible
    ]);
    React25.useEffect(function() {
        setSelectedFieldValue(defaultValue);
    }, [
        defaultValue
    ]);
    React25.useEffect(function() {
        if (resetFilters) {
            setSelectedFieldValue("");
        }
    }, [
        resetFilters
    ]);
    if (!Array.isArray(options) || options.length === 0) {
        return null;
    }
    var Base = (expando === null || expando === void 0 ? void 0 : expando.threshold) && (options === null || options === void 0 ? void 0 : options.length) > expando.threshold ? UitkExpandoPeek2 : React25.Fragment;
    var _expando_collapseAccessibilityLabel, _expando_expandAccessibilityLabel;
    var expandoProps = (expando === null || expando === void 0 ? void 0 : expando.threshold) && (options === null || options === void 0 ? void 0 : options.length) > expando.threshold ? {
        collapseLabel: expando.collapseLabel,
        expandLabel: expando.expandLabel,
        collapseA11yLabel: (_expando_collapseAccessibilityLabel = expando.collapseAccessibilityLabel) !== null && _expando_collapseAccessibilityLabel !== void 0 ? _expando_collapseAccessibilityLabel : void 0,
        expandA11yLabel: (_expando_expandAccessibilityLabel = expando.expandAccessibilityLabel) !== null && _expando_expandAccessibilityLabel !== void 0 ? _expando_expandAccessibilityLabel : void 0,
        items: expandoThreshold,
        isVisible: expandoIsVisible,
        hideScrim: true,
        handleClick: handleClick
    } : {};
    return /* @__PURE__ */ React25.createElement("fieldset", null, /* @__PURE__ */ React25.createElement(UitkSpacing8, {
        margin: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React25.createElement("legend", null, primary && /* @__PURE__ */ React25.createElement(UitkHeading6, {
        tag: "h4",
        size: 7
    }, primary))), options && /* @__PURE__ */ React25.createElement(UitkRadioButtonGroup, {
        key: selectedFieldValue,
        group: options[0].fieldId,
        selected: selectedFieldValue,
        onChange: handleChange,
        defaultChecked: true
    }, /* @__PURE__ */ React25.createElement(Base, _objectSpread({}, expandoProps), options.map(function(option, optionIndex) {
        return /* @__PURE__ */ React25.createElement(SelectionOptionField, {
            key: "option-".concat(option.fieldId, "-").concat(optionIndex, "-").concat(option.value),
            data: option
        });
    }))));
};
SelectionField.displayName = "SelectionField";
SelectionField.fragment = __Fragment20;
SelectionField.fragment.__typename = "ShoppingSelectionField";
// ../internal/src/components/sort-filter/__private/__fragments/step-input-field.tsx
import React26, { useEffect as useEffect3, useState as useState5 } from "react";
import { gql as gql28 } from "@apollo/client";
import { useClickTracker as useClickTracker13 } from "@shared-ui/clickstream-analytics-context";
import { useSignalSubscriber as useSignalSubscriber3 } from "@shared-ui/signal-events-context";
import { UitkStepInput } from "uitk-react-step-input";
import { UitkHeading as UitkHeading7 } from "uitk-react-text";
var __Fragment21 = gql28(_templateObject32(), ReceiverFragment, EmitterFragment);
var StepInputFieldComponent = function(param) {
    var data = param.data, onSelectedField = param.onSelectedField, resetFilters = param.resetFilters, onStepInputChange = param.onStepInputChange, emitSignal = param.emitSignal;
    var primary = data.primary, stepInput = data.stepInput, stepInputId = data.stepInputId, emitters = data.emitters, receivers = data.receivers, accessibility = data.accessibility;
    var decreaseText = stepInput.decreaseText, increaseText = stepInput.increaseText, max = stepInput.max, min = stepInput.min, label = stepInput.label, step = stepInput.step, subLabel = stepInput.subLabel, value = stepInput.value, increaseAnalytics = stepInput.increaseAnalytics, decreaseAnalytics = stepInput.decreaseAnalytics;
    var defaultProps = UitkStepInput.defaultProps;
    var tmp = defaultProps.min, defaultPropsMin = tmp === void 0 ? 0 : tmp;
    var defaultMin = min !== null && min !== void 0 ? min : defaultPropsMin;
    var _useState5 = _slicedToArray(useState5(value), 2), counter = _useState5[0], setCounter = _useState5[1];
    var _useState51 = _slicedToArray(useState5(false), 2), triggerInputChange = _useState51[0], setTriggerInputChange = _useState51[1];
    var track = useClickTracker13();
    useEffect3(function() {
        if (resetFilters) {
            setCounter(defaultMin);
        }
    }, [
        resetFilters
    ]);
    useEffect3(function() {
        if (triggerInputChange) {
            onStepInputChange === null || onStepInputChange === void 0 ? void 0 : onStepInputChange(stepInputId !== null && stepInputId !== void 0 ? stepInputId : "", counter);
            onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
            setTriggerInputChange(false);
        }
    }, [
        triggerInputChange
    ]);
    var _receivers_map;
    var subscriptions = (_receivers_map = receivers === null || receivers === void 0 ? void 0 : receivers.map(function(param) {
        var signalId = param.signalId;
        return {
            query: {
                type: signalId
            },
            callback: function(param) {
                var payload = param.payload;
                if (payload.__typename === "SortAndFilterBasicFilterPayload" /* BASIC */  && payload.type === "REMOVE" /* REMOVE */ ) {
                    setCounter(defaultMin);
                    setTriggerInputChange(true);
                }
            }
        };
    })) !== null && _receivers_map !== void 0 ? _receivers_map : [];
    useSignalSubscriber3(subscriptions);
    var handleStepInputChange = function(e) {
        var newValue = Number(e.target.value);
        if (increaseAnalytics && newValue > counter) {
            var linkName = increaseAnalytics.linkName, referrerId = increaseAnalytics.referrerId;
            track("".concat(referrerId, ".").concat(newValue !== value), linkName);
        }
        if (decreaseAnalytics && newValue < counter) {
            var linkName1 = decreaseAnalytics.linkName, referrerId1 = decreaseAnalytics.referrerId;
            track("".concat(referrerId1, ".").concat(newValue !== value), linkName1);
        }
        var stepInputOptions = {
            prevValue: counter,
            nextValue: newValue,
            defaultValue: defaultMin
        };
        emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal(emitters !== null && emitters !== void 0 ? emitters : [], {
            stepInputOptions: stepInputOptions
        });
        setCounter(newValue);
        onStepInputChange === null || onStepInputChange === void 0 ? void 0 : onStepInputChange(stepInputId !== null && stepInputId !== void 0 ? stepInputId : "", newValue);
        onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
    };
    return /* @__PURE__ */ React26.createElement(React26.Fragment, null, /* @__PURE__ */ React26.createElement(UitkHeading7, {
        tag: "h4",
        size: 7
    }, primary), /* @__PURE__ */ React26.createElement("fieldset", null, /* @__PURE__ */ React26.createElement("legend", {
        className: "is-visually-hidden"
    }, accessibility), /* @__PURE__ */ React26.createElement(UitkStepInput, {
        decrementText: decreaseText !== null && decreaseText !== void 0 ? decreaseText : "",
        incrementText: increaseText !== null && increaseText !== void 0 ? increaseText : "",
        max: max !== null && max !== void 0 ? max : defaultProps.max,
        min: defaultMin,
        label: label,
        onChange: handleStepInputChange,
        value: counter,
        step: step || defaultProps.step,
        description: subLabel !== null && subLabel !== void 0 ? subLabel : ""
    })));
};
StepInputFieldComponent.displayName = "StepInputField";
StepInputFieldComponent.fragment = __Fragment21;
StepInputFieldComponent.fragment.__typename = "ShoppingStepInputField";
var StepInputField = withSignals(StepInputFieldComponent);
// ../internal/src/components/sort-filter/__private/__fragments/mutex-field.tsx
var __Fragment22 = gql29(_templateObject33(), MultiSelectionField.fragment, RangeField.fragment, MultiSelectionStackedTileField.fragment, MultiSelectionTileField.fragment, StepInputField.fragment, SelectionOptionField.fragment, ReceiverFragment, EmitterFragment);
var validFieldComponents = [
    DropdownField,
    MultiSelectionField,
    RangeField,
    SelectionField,
    MultiSelectionStackedTileField,
    MultiSelectionTileField,
    StepInputField
];
var MutexFieldComponent = function(props) {
    var data = props.data, onFieldClick = props.onFieldClick, onRangeSelectionChange = props.onRangeSelectionChange, onStepInputChange = props.onStepInputChange, onSelectedField = props.onSelectedField, resetFilters = props.resetFilters, emitSignal = props.emitSignal;
    var _useFieldStateContext = useFieldStateContext(), dispatch = _useFieldStateContext.dispatch, state = _useFieldStateContext.state;
    var exposure = useExperiment("mutex_state_management").exposure;
    var mutexStateData = state.field.__typename === data.__typename && exposure.bucket === 1 ? state.field : data;
    var initSignalOnMount = exposure.bucket !== 0;
    var primary = mutexStateData.primary, options = mutexStateData.options, mutexId = mutexStateData.mutexId;
    var defaultValue = options === null || options === void 0 ? void 0 : options.find(function(option) {
        return option.mutexValue.selected;
    });
    var _React27_useState = _slicedToArray(React27.useState(defaultValue), 2), selectedFieldValue = _React27_useState[0], setSelectedFieldValue = _React27_useState[1];
    var fieldId = mutexId || "";
    var _option_mutexValue_receivers;
    var mutexValueReceivers = options === null || options === void 0 ? void 0 : options.map(function(option) {
        return (_option_mutexValue_receivers = option.mutexValue.receivers) !== null && _option_mutexValue_receivers !== void 0 ? _option_mutexValue_receivers : [];
    }).flat();
    var track = useClickTracker14();
    var _mutexValueReceivers_map;
    var subscriptions = (_mutexValueReceivers_map = mutexValueReceivers === null || mutexValueReceivers === void 0 ? void 0 : mutexValueReceivers.map(function(param) {
        var signalId = param.signalId;
        return {
            query: {
                type: signalId
            },
            callback: function(param) {
                var payload = param.payload;
                if (payload.__typename === "SortAndFilterBasicFilterPayload" /* BASIC */  && payload.type === "REMOVE" /* REMOVE */ ) {
                    setSelectedFieldValue(defaultValue);
                }
            }
        };
    })) !== null && _mutexValueReceivers_map !== void 0 ? _mutexValueReceivers_map : [];
    useSignalSubscriber4(subscriptions);
    var handleChange = useFormCallback8(fieldId, function(event) {
        var deselectedOption = options === null || options === void 0 ? void 0 : options.find(function(option) {
            return option.mutexValue.value === (selectedFieldValue === null || selectedFieldValue === void 0 ? void 0 : selectedFieldValue.mutexValue.value);
        });
        var selectedOption = options === null || options === void 0 ? void 0 : options.find(function(option) {
            return option.mutexValue.value === event.currentTarget.value;
        });
        if (deselectedOption === null || deselectedOption === void 0 ? void 0 : deselectedOption.mutexValue.deselectAnalytics) {
            var _deselectedOption_mutexValue_deselectAnalytics = deselectedOption.mutexValue.deselectAnalytics, referrerId = _deselectedOption_mutexValue_deselectAnalytics.referrerId, linkName = _deselectedOption_mutexValue_deselectAnalytics.linkName;
            track(referrerId, linkName);
        }
        if (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.mutexValue.selectAnalytics) {
            var _selectedOption_mutexValue_selectAnalytics = selectedOption.mutexValue.selectAnalytics, referrerId1 = _selectedOption_mutexValue_selectAnalytics.referrerId, linkName1 = _selectedOption_mutexValue_selectAnalytics.linkName;
            track(referrerId1, linkName1);
        }
        if (exposure.bucket === 0) {
            var deselectedOptionEmittedSignalValue = {
                prevChecked: (deselectedOption === null || deselectedOption === void 0 ? void 0 : deselectedOption.mutexValue.selected) || true
            };
            var _deselectedOption_mutexValue_emitters;
            emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal((_deselectedOption_mutexValue_emitters = deselectedOption === null || deselectedOption === void 0 ? void 0 : deselectedOption.mutexValue.emitters) !== null && _deselectedOption_mutexValue_emitters !== void 0 ? _deselectedOption_mutexValue_emitters : [], {
                selectionOptions: deselectedOptionEmittedSignalValue
            });
            var selectedOptionEmittedSignalValue = {
                prevChecked: false
            };
            var _selectedOption_mutexValue_emitters;
            emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal((_selectedOption_mutexValue_emitters = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.mutexValue.emitters) !== null && _selectedOption_mutexValue_emitters !== void 0 ? _selectedOption_mutexValue_emitters : [], {
                selectionOptions: selectedOptionEmittedSignalValue
            });
        }
        setSelectedFieldValue(selectedOption);
        onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
        return event;
    });
    var handleRangeSelectionChange = function(selected) {
        var id = selected.id, min = selected.min, max = selected.max;
        dispatch({
            type: "UPDATE_SLIDER_VALUE" /* UPDATE_SLIDER_VALUE_FOR_MUTEX */ ,
            id: id,
            min: min,
            max: max
        });
        onRangeSelectionChange === null || onRangeSelectionChange === void 0 ? void 0 : onRangeSelectionChange(selected);
        onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
    };
    React27.useEffect(function() {
        if (resetFilters) {
            dispatch({
                type: "RESET_STATE" /* RESET_STATE_FOR_MUTEX */ ,
                state: {
                    field: data
                }
            });
        }
    }, [
        resetFilters
    ]);
    if (!options) {
        return null;
    }
    return /* @__PURE__ */ React27.createElement("fieldset", {
        "data-testid": fieldId
    }, /* @__PURE__ */ React27.createElement(UitkSpacing9, {
        margin: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React27.createElement("legend", null, primary && /* @__PURE__ */ React27.createElement(UitkSpacing9, {
        margin: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React27.createElement(UitkHeading8, {
        "data-testid": primary,
        tag: "h4",
        size: 7
    }, primary)))), options && /* @__PURE__ */ React27.createElement(UitkRadioButtonGroup2, {
        selected: selectedFieldValue === null || selectedFieldValue === void 0 ? void 0 : selectedFieldValue.mutexValue.value,
        "data-testid": fieldId,
        onChange: handleChange,
        group: fieldId,
        legendLabel: " ",
        defaultChecked: true
    }, options.map(function(mutexOption, mutexOptionIndex) {
        return /* @__PURE__ */ React27.createElement(SelectionOptionField, {
            key: "option-".concat(mutexOption.mutexValue.primary, "-").concat(mutexOptionIndex),
            data: mutexOption.mutexValue
        });
    })), options.map(function(param, optionIndex) {
        var mutexOption = param.mutexOption, mutexValue = param.mutexValue;
        var Field = validFieldComponents.find(function(component) {
            return component.fragment.__typename === (selectedFieldValue === null || selectedFieldValue === void 0 ? void 0 : selectedFieldValue.mutexOption.__typename);
        });
        var isSelected = mutexValue.value === (selectedFieldValue === null || selectedFieldValue === void 0 ? void 0 : selectedFieldValue.mutexValue.value);
        if (!Field || !isSelected) {
            return null;
        }
        switch(mutexOption.__typename){
            case RangeField.fragment.__typename:
                return /* @__PURE__ */ React27.createElement(Field, {
                    key: "field-section-".concat(optionIndex),
                    data: mutexOption,
                    onSelectedField: onSelectedField,
                    onRangeSelectionChange: handleRangeSelectionChange,
                    resetFilters: resetFilters,
                    shouldFireSignalOnMount: initSignalOnMount
                });
            default:
                return /* @__PURE__ */ React27.createElement(Field, {
                    key: "field-section-".concat(optionIndex),
                    data: mutexOption,
                    onClick: onFieldClick,
                    onSelectedField: onSelectedField,
                    resetFilters: resetFilters,
                    onStepInputChange: onStepInputChange
                });
        }
    }));
};
MutexFieldComponent.displayName = "MutexField";
MutexFieldComponent.fragment = __Fragment22;
MutexFieldComponent.fragment.__typename = "ShoppingMutexField";
var MutexField = withSignals(MutexFieldComponent);
// ../internal/src/components/sort-filter/__private/__fragments/selected-filters-field.tsx
import React29, { useEffect as useEffect4, useReducer } from "react";
import { gql as gql31 } from "@apollo/client";
import { useSignalSubscriber as useSignalSubscriber5 } from "@shared-ui/signal-events-context";
import { UitkPillContainer as UitkPillContainer3 } from "uitk-react-pill";
import { UitkSpacing as UitkSpacing10 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading9, UitkParagraph as UitkParagraph3 } from "uitk-react-text";
import { Level, liveAnnounce as liveAnnounce2 } from "uitk-react-utils";
// ../internal/src/utils/sort-by-selected-fields-ordering.ts
var sortBySelectedFieldsOrdering = function(originalArray, sortingArray) {
    var sortingMap = new Map(sortingArray.map(function(item, index) {
        return [
            item,
            index
        ];
    }));
    var shoppingSelectedFilters = JSON.parse(JSON.stringify(originalArray));
    return shoppingSelectedFilters.sort(function(previousFilter, currentFilter) {
        var _previousFilter_filter, _currentFilter_filter;
        if (((_previousFilter_filter = previousFilter.filter) === null || _previousFilter_filter === void 0 ? void 0 : _previousFilter_filter.__typename) === "EGDSBasicRemovablePill" && previousFilter.filter.id && ((_currentFilter_filter = currentFilter.filter) === null || _currentFilter_filter === void 0 ? void 0 : _currentFilter_filter.__typename) === "EGDSBasicRemovablePill" && currentFilter.filter.id) {
            var previousIndex = sortingMap.get(previousFilter.filter.id);
            var currentIndex = sortingMap.get(currentFilter.filter.id);
            if (previousIndex === void 0 && currentIndex === void 0) {
                return 0;
            }
            if (previousIndex === void 0) {
                return 1;
            }
            if (currentIndex === void 0) {
                return -1;
            }
            return previousIndex - currentIndex;
        }
        return 0;
    });
};
// ../internal/src/components/sort-filter/__private/__fragments/selected-filter.tsx
import React28 from "react";
import { gql as gql30 } from "@apollo/client";
var __Fragment23 = gql30(_templateObject34(), EmitterFragment, EGDSPill.fragment);
var SelectedFilterComponent = function(param) {
    var data = param.data, onRemoveFilterPill = param.onRemoveFilterPill, emitSignal = param.emitSignal;
    var filter = data.filter, emitters = data.emitters;
    if ((filter === null || filter === void 0 ? void 0 : filter.__typename) !== "EGDSBasicRemovablePill") {
        return null;
    }
    var id = filter.id, primary = filter.primary, name = filter.name, accessibility = filter.accessibility;
    if (!id || !primary || !name || !accessibility) {
        return null;
    }
    var handleClick = function() {
        onRemoveFilterPill === null || onRemoveFilterPill === void 0 ? void 0 : onRemoveFilterPill(id);
        emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal(emitters !== null && emitters !== void 0 ? emitters : []);
    };
    return /* @__PURE__ */ React28.createElement(EGDSPill, {
        data: filter,
        onClick: handleClick
    });
};
SelectedFilterComponent.displayName = "SelectedFilter";
SelectedFilterComponent.fragment = __Fragment23;
var SelectedFilter = withSignals(SelectedFilterComponent);
// ../internal/src/components/sort-filter/__private/__fragments/selected-filters-field.tsx
var __Fragment24 = gql31(_templateObject35(), SelectedFilter.fragment, ReceiverFragment);
var SelectedFiltersField = function(param) {
    var data = param.data, resetFilters = param.resetFilters, focusNextElement = param.focusNextElement;
    var selectedFiltersFieldAccessiblity = data.selectedFiltersFieldAccessiblity, primary = data.primary, secondary = data.secondary, shoppingSelectedFilters = data.shoppingSelectedFilters, receivers = data.receivers, selectedFiltersOrdering = data.selectedFiltersOrdering;
    var _useReducer = _slicedToArray(useReducer(selectedFiltersStateReducer, {
        selectedFilters: shoppingSelectedFilters !== null && shoppingSelectedFilters !== void 0 ? shoppingSelectedFilters : [],
        isFirstSelectedFilter: false
    }), 2), _useReducer_ = _useReducer[0], selectedFilters = _useReducer_.selectedFilters, isFirstSelectedFilter = _useReducer_.isFirstSelectedFilter, dispatch = _useReducer[1];
    var ariaLabel = (selectedFiltersFieldAccessiblity === null || selectedFiltersFieldAccessiblity === void 0 ? void 0 : selectedFiltersFieldAccessiblity.__typename) === "EGDSCardinalLocalizedText" ? selectedFiltersFieldAccessiblity.accessibilityText : selectedFiltersFieldAccessiblity === null || selectedFiltersFieldAccessiblity === void 0 ? void 0 : selectedFiltersFieldAccessiblity.text;
    var liveAnnounceRef = React29.useRef(null);
    useEffect4(function() {
        if (resetFilters) {
            dispatch({
                type: "SortAndFilterClearAllFilters" /* CLEAR */ ,
                payload: {}
            });
        }
    }, [
        resetFilters
    ]);
    useEffect4(function() {
        if (isFirstSelectedFilter) {
            liveAnnounce2("A list of your filter selections have been added. Check headings menu to review.", Level.POLITE, "is-visually-hidden", liveAnnounceRef, "selected-filter-field-live");
        }
    }, [
        isFirstSelectedFilter
    ]);
    var _receivers_map;
    var subscriptions = (_receivers_map = receivers === null || receivers === void 0 ? void 0 : receivers.map(function(param) {
        var signalId = param.signalId;
        return {
            query: {
                type: signalId
            },
            callback: dispatch
        };
    })) !== null && _receivers_map !== void 0 ? _receivers_map : [];
    useSignalSubscriber5(subscriptions);
    var orderedSelectedFilterList = selectedFiltersOrdering ? sortBySelectedFieldsOrdering(selectedFilters, selectedFiltersOrdering) : selectedFilters;
    if (!(orderedSelectedFilterList === null || orderedSelectedFilterList === void 0 ? void 0 : orderedSelectedFilterList.length)) {
        return null;
    }
    var removeFilterPill = function(id) {
        var _lastOrderedSelectedFilter_filter;
        var lastOrderedSelectedFilter = orderedSelectedFilterList[orderedSelectedFilterList.length - 1];
        var isLastFilterPill = ((_lastOrderedSelectedFilter_filter = lastOrderedSelectedFilter.filter) === null || _lastOrderedSelectedFilter_filter === void 0 ? void 0 : _lastOrderedSelectedFilter_filter.__typename) === "EGDSBasicRemovablePill" && lastOrderedSelectedFilter.filter.id === id;
        if (isLastFilterPill) {
            focusNextElement === null || focusNextElement === void 0 ? void 0 : focusNextElement();
        }
        dispatch({
            type: "SortAndFilterClearFilterById" /* CLEAR_BY_ID */ ,
            payload: {
                id: id
            }
        });
    };
    return /* @__PURE__ */ React29.createElement("fieldset", {
        "data-testid": "selected-filter-field",
        ref: liveAnnounceRef
    }, /* @__PURE__ */ React29.createElement("legend", null, primary && /* @__PURE__ */ React29.createElement(UitkHeading9, {
        tag: "h4",
        size: 7,
        "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : ""
    }, primary)), secondary && /* @__PURE__ */ React29.createElement(UitkParagraph3, null, secondary), /* @__PURE__ */ React29.createElement(UitkSpacing10, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React29.createElement(UitkPillContainer3, {
        wrap: true
    }, orderedSelectedFilterList.map(function(selectedFilter, index) {
        return /* @__PURE__ */ React29.createElement(SelectedFilter, {
            key: "selected-filter-".concat(index),
            data: selectedFilter,
            onRemoveFilterPill: removeFilterPill
        });
    }))));
};
SelectedFiltersField.displayName = "SelectedFiltersField";
SelectedFiltersField.fragment = __Fragment24;
SelectedFiltersField.fragment.__typename = "ShoppingSelectedFiltersField";
// ../internal/src/components/sort-filter/__private/__fragments/text-input-field.tsx
import React32 from "react";
import { gql as gql32 } from "@apollo/client";
import { useClickTracker as useClickTracker17 } from "@shared-ui/clickstream-analytics-context";
import { UitkTextInput } from "uitk-react-input";
import { UitkHeading as UitkHeading10 } from "uitk-react-text";
// ../internal/src/components/sort-filter/__private/__fragments/text-input-field-multi-typeahead.tsx
import React30 from "react";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker15 } from "@shared-ui/clickstream-analytics-context";
import { UitkSpacing as UitkSpacing11 } from "uitk-react-spacing";
import { ESSAdapter, UitkTypeahead } from "uitk-react-typeahead";
var TextInputFieldMultiTypeahead = function(props) {
    var onMultiSelectClose = props.onMultiSelectClose, onMultiSelectItemRemove = props.onMultiSelectItemRemove, onMultiSelectClearAll = props.onMultiSelectClearAll, onSelectionChange = props.onSelectionChange, label = props.label, placeholder = props.placeholder, icon = props.icon, multiSelections = props.multiSelections, id = props.id, typeaheadInfo = props.typeaheadInfo, typeaheadAdapter = props.typeaheadAdapter, analytics = props.analytics, essLogger = props.essLogger;
    var context = useBexApi().context;
    var _ref = typeaheadInfo || {}, client = _ref.client, isDestination = _ref.isDestination, lineOfBusiness = _ref.lineOfBusiness, maxNumberOfResults = _ref.maxNumberOfResults, regionType = _ref.regionType, typeaheadFeatures = _ref.typeaheadFeatures, categorize = _ref.categorize, allowExactMatch = _ref.allowExactMatch, dismissButtonText = _ref.dismissButtonText, listTitle = _ref.listTitle, typeaheadMultiSelect = _ref.typeaheadMultiSelect, emptyResultsPlaceholder = _ref.emptyResultsPlaceholder;
    var _ref1 = typeaheadMultiSelect || {}, isMultiLocation = _ref1.isMultiLocation, showPills = _ref1.showPills, selectedItemHeading = _ref1.selectedItemHeading, clearAllText = _ref1.clearAllText;
    var identity = context.identity, locale = context.locale, siteId = context.siteId;
    var expuserid = Number(identity === null || identity === void 0 ? void 0 : identity.expUserId) || -1;
    var _ref2 = identity || {}, guid = _ref2.duaid;
    var defaultMaxNumberOfResults = 10;
    var essAdapter = typeaheadAdapter !== null && typeaheadAdapter !== void 0 ? typeaheadAdapter : new ESSAdapter({
        client: client !== null && client !== void 0 ? client : "",
        domain: "https://www.expedia.com/",
        dest: isDestination !== null && isDestination !== void 0 ? isDestination : true,
        expuserid: expuserid,
        features: typeaheadFeatures !== null && typeaheadFeatures !== void 0 ? typeaheadFeatures : "",
        guid: guid,
        lob: lineOfBusiness !== null && lineOfBusiness !== void 0 ? lineOfBusiness : "",
        locale: locale,
        maxResults: maxNumberOfResults || defaultMaxNumberOfResults,
        regionType: regionType || 128,
        siteId: siteId,
        essLogger: essLogger
    });
    var currentMultiSelection = React30.useMemo(function() {
        return multiSelections ? multiSelections.map(function(item) {
            return {
                term: item.text,
                data: {
                    value: item.value
                }
            };
        }) : [];
    }, [
        multiSelections
    ]);
    var _React30_useState = _slicedToArray(React30.useState(currentMultiSelection), 2), selection = _React30_useState[0], setSelection = _React30_useState[1];
    React30.useEffect(function() {
        setSelection(currentMultiSelection);
    }, [
        currentMultiSelection
    ]);
    var track = useClickTracker15();
    var handleUpdate = function(typeaheadSelection) {
        var isNewSelectionRepeated = selection.find(function(item) {
            return item === typeaheadSelection;
        });
        if (!isNewSelectionRepeated && typeaheadSelection.data) {
            setSelection(function(prevSelection) {
                return _toConsumableArray(prevSelection).concat([
                    typeaheadSelection
                ]);
            });
            onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange(typeaheadSelection, id);
        }
        if (analytics) {
            var referrerId = analytics.referrerId, linkName = analytics.linkName;
            track(referrerId, linkName);
        }
    };
    var handleRemove = function(selectedIndex) {
        if (selection.length > 0) {
            setSelection(selection.filter(function(_, i) {
                return i !== selectedIndex;
            }));
            onMultiSelectItemRemove === null || onMultiSelectItemRemove === void 0 ? void 0 : onMultiSelectItemRemove(selection[selectedIndex], id);
        }
    };
    var handleClear = function() {
        setSelection([]);
        onMultiSelectClearAll === null || onMultiSelectClearAll === void 0 ? void 0 : onMultiSelectClearAll(id);
        onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange({
            term: "",
            data: {}
        }, id);
    };
    var handleDismiss = function(renderType) {
        onMultiSelectClose === null || onMultiSelectClose === void 0 ? void 0 : onMultiSelectClose(renderType, id);
    };
    var _ref3, _icon_id;
    return /* @__PURE__ */ React30.createElement(UitkSpacing11, {
        padding: {
            block: "two"
        }
    }, /* @__PURE__ */ React30.createElement("div", null, /* @__PURE__ */ React30.createElement(UitkTypeahead, {
        stid: id,
        id: id,
        name: id,
        value: selection.map(function(item) {
            return item.term;
        }),
        label: (_ref3 = label !== null && label !== void 0 ? label : placeholder) !== null && _ref3 !== void 0 ? _ref3 : "",
        icon: (_icon_id = icon === null || icon === void 0 ? void 0 : icon.id) !== null && _icon_id !== void 0 ? _icon_id : "",
        typeaheadPlaceholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
        adapter: essAdapter,
        onUpdate: handleUpdate,
        onItemRemove: isMultiLocation ? handleRemove : void 0,
        handleClear: handleClear,
        onDismiss: isMultiLocation ? handleDismiss : void 0,
        isMulti: isMultiLocation !== null && isMultiLocation !== void 0 ? isMultiLocation : false,
        categorize: categorize,
        allowExactMatch: allowExactMatch,
        listTitle: listTitle,
        selectedItemHeading: selectedItemHeading !== null && selectedItemHeading !== void 0 ? selectedItemHeading : "",
        clearAllText: clearAllText !== null && clearAllText !== void 0 ? clearAllText : "",
        dismissButtonText: dismissButtonText !== null && dismissButtonText !== void 0 ? dismissButtonText : "",
        showPills: showPills,
        hasClearButton: true,
        typeaheadEmptyResultPlaceholder: emptyResultsPlaceholder !== null && emptyResultsPlaceholder !== void 0 ? emptyResultsPlaceholder : ""
    })));
};
// ../internal/src/components/sort-filter/__private/__fragments/text-input-field-typeahead.tsx
import React31 from "react";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker16 } from "@shared-ui/clickstream-analytics-context";
import { ESSAdapter as ESSAdapter2, UitkTypeahead as UitkTypeahead2 } from "uitk-react-typeahead";
var TextInputFieldTypeahead = function(props) {
    var onSelectionChange = props.onSelectionChange, label = props.label, placeholder = props.placeholder, icon = props.icon, selected = props.selected, id = props.id, typeaheadInfo = props.typeaheadInfo, typeaheadAdapter = props.typeaheadAdapter, analytics = props.analytics, essLogger = props.essLogger;
    var context = useBexApi2().context;
    var track = useClickTracker16();
    var _React31_useState = _slicedToArray(React31.useState(selected), 2), selection = _React31_useState[0], setSelection = _React31_useState[1];
    React31.useEffect(function() {
        setSelection(selected);
    }, [
        selected
    ]);
    var _ref = typeaheadInfo || {}, client = _ref.client, isDestination = _ref.isDestination, lineOfBusiness = _ref.lineOfBusiness, maxNumberOfResults = _ref.maxNumberOfResults, regionType = _ref.regionType, typeaheadFeatures = _ref.typeaheadFeatures, categorize = _ref.categorize, allowExactMatch = _ref.allowExactMatch, listTitle = _ref.listTitle;
    var identity = context.identity, locale = context.locale, siteId = context.siteId;
    var expuserid = Number(identity === null || identity === void 0 ? void 0 : identity.expUserId) || -1;
    var _ref1 = identity || {}, guid = _ref1.duaid;
    var defaultMaxNumberOfResults = 10;
    var essAdapter = typeaheadAdapter !== null && typeaheadAdapter !== void 0 ? typeaheadAdapter : new ESSAdapter2({
        client: client !== null && client !== void 0 ? client : "",
        domain: "https://www.expedia.com/",
        dest: isDestination !== null && isDestination !== void 0 ? isDestination : true,
        expuserid: expuserid,
        features: typeaheadFeatures !== null && typeaheadFeatures !== void 0 ? typeaheadFeatures : "",
        guid: guid,
        lob: lineOfBusiness !== null && lineOfBusiness !== void 0 ? lineOfBusiness : "",
        locale: locale,
        maxResults: maxNumberOfResults || defaultMaxNumberOfResults,
        regionType: regionType || 128,
        siteId: siteId,
        essLogger: essLogger
    });
    var handleUpdate = function(typeaheadSelection) {
        setSelection(typeaheadSelection.term);
        onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange(typeaheadSelection, id);
        if (analytics) {
            var referrerId = analytics.referrerId, linkName = analytics.linkName;
            track(referrerId, linkName);
        }
    };
    var handleClear = function() {
        setSelection("");
        onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange({
            term: "",
            data: {}
        }, id);
    };
    var _ref2, _icon_id;
    return /* @__PURE__ */ React31.createElement(UitkTypeahead2, {
        id: id,
        name: id,
        value: selection !== null && selection !== void 0 ? selection : "",
        label: (_ref2 = label !== null && label !== void 0 ? label : placeholder) !== null && _ref2 !== void 0 ? _ref2 : "",
        icon: (_icon_id = icon === null || icon === void 0 ? void 0 : icon.id) !== null && _icon_id !== void 0 ? _icon_id : "",
        typeaheadPlaceholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
        adapter: essAdapter,
        onUpdate: handleUpdate,
        handleClear: handleClear,
        categorize: categorize,
        allowExactMatch: allowExactMatch,
        listTitle: listTitle,
        hasClearButton: true
    });
};
// ../internal/src/components/sort-filter/__private/__fragments/text-input-field.tsx
var __Fragment25 = gql32(_templateObject36());
var TextInputField = function(props) {
    var _typeaheadInfo_typeaheadMultiSelect, _typeaheadInfo_typeaheadMultiSelect1;
    var data = props.data, onKeyDown = props.onKeyDown;
    var primary = data.primary, label = data.label, placeholder = data.placeholder, icon = data.icon, selected = data.selected, id = data.id, typeaheadInfo = data.typeaheadInfo, analytics = data.analytics;
    var _React32_useState = _slicedToArray(React32.useState(selected !== null && selected !== void 0 ? selected : ""), 2), value = _React32_useState[0], setValue = _React32_useState[1];
    var track = useClickTracker17();
    React32.useEffect(function() {
        setValue(selected || "");
    }, [
        selected
    ]);
    var handleChange = function(event) {
        setValue(event.target.value);
        if (analytics) {
            var referrerId = analytics.referrerId, linkName = analytics.linkName;
            track(referrerId, linkName);
        }
    };
    var handleKeyDown = function(event) {
        if (event.key === "Enter") {
            event.preventDefault();
            var inputElement = event.target;
            setValue(inputElement.value);
            if (onKeyDown) {
                onKeyDown({
                    name: id,
                    value: value
                }, event);
            }
            if (analytics) {
                var referrerId = analytics.referrerId, linkName = analytics.linkName;
                track(referrerId, linkName);
            }
        }
    };
    var _icon_id;
    return /* @__PURE__ */ React32.createElement(React32.Fragment, null, primary && /* @__PURE__ */ React32.createElement(UitkHeading10, {
        tag: "h4",
        size: 7
    }, primary), !typeaheadInfo && /* @__PURE__ */ React32.createElement(UitkTextInput, {
        label: label !== null && label !== void 0 ? label : "",
        id: id,
        placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
        icon: (_icon_id = icon === null || icon === void 0 ? void 0 : icon.id) !== null && _icon_id !== void 0 ? _icon_id : "",
        value: value,
        onChange: handleChange,
        onKeyDown: handleKeyDown
    }), typeaheadInfo && !((_typeaheadInfo_typeaheadMultiSelect = typeaheadInfo.typeaheadMultiSelect) === null || _typeaheadInfo_typeaheadMultiSelect === void 0 ? void 0 : _typeaheadInfo_typeaheadMultiSelect.isMultiLocation) && /* @__PURE__ */ React32.createElement(TextInputFieldTypeahead, _objectSpread({}, data, props)), (typeaheadInfo === null || typeaheadInfo === void 0 ? void 0 : (_typeaheadInfo_typeaheadMultiSelect1 = typeaheadInfo.typeaheadMultiSelect) === null || _typeaheadInfo_typeaheadMultiSelect1 === void 0 ? void 0 : _typeaheadInfo_typeaheadMultiSelect1.isMultiLocation) && /* @__PURE__ */ React32.createElement(TextInputFieldMultiTypeahead, _objectSpread({}, data, props)));
};
TextInputField.displayName = "TextInputField";
TextInputField.fragment = __Fragment25;
TextInputField.fragment.__typename = "ShoppingTextInputField";
// ../internal/src/components/sort-filter/__private/__fragments/section.tsx
var __Fragment26 = gql33(_templateObject37(), DropdownField.fragment, MultiSelectionField.fragment, RangeField.fragment, SelectionField.fragment, TextInputField.fragment, MultiSelectionStackedTileField.fragment, MultiSelectionTileField.fragment, StepInputField.fragment, MutexField.fragment, SelectedFiltersField.fragment);
var validFieldComponents2 = [
    DropdownField,
    MultiSelectionField,
    RangeField,
    SelectionField,
    TextInputField,
    MultiSelectionStackedTileField,
    MultiSelectionTileField,
    StepInputField,
    MutexField,
    SelectedFiltersField
];
var SortAndFilterSection = function(props) {
    var data = props.data, keepSectionExpanded = props.keepSectionExpanded, onFieldClick = props.onFieldClick, onMultiSelectClose = props.onMultiSelectClose, onMultiSelectItemRemove = props.onMultiSelectItemRemove, onMultiSelectClearAll = props.onMultiSelectClearAll, onSelectionChange = props.onSelectionChange, typeaheadAdapters = props.typeaheadAdapters, onRangeSelectionChange = props.onRangeSelectionChange, onStepInputChange = props.onStepInputChange, onSelectedField = props.onSelectedField, useUnsetMargin = props.useUnsetMargin, useUnsetTopBorder = props.useUnsetTopBorder, resetFilters = props.resetFilters, essLogger = props.essLogger, onKeyDown = props.onKeyDown;
    var fields = data.fields, subTitle = data.subTitle, title = data.title, id = data.id;
    var containerRef = React33.useRef(null);
    var hasSupportedFields = fields.some(function(param) {
        var __typename = param.__typename;
        return validFieldComponents2.find(function(param) {
            var fragment4 = param.fragment;
            return fragment4.__typename === __typename;
        });
    });
    if (!hasSupportedFields) {
        return null;
    }
    var isFilterSectionInputType = fields.some(function(param) {
        var __typename = param.__typename;
        return __typename === "ShoppingTextInputField";
    });
    var borderedSpacingProps = {
        border: isFilterSectionInputType ? [
            "blockend",
            "blockstart"
        ] : [],
        padding: isFilterSectionInputType ? {
            block: "six"
        } : {},
        margin: !useUnsetMargin ? {
            blockstart: "six"
        } : {
            blockstart: "unset"
        }
    };
    var noTopBorderSpacingProps = {
        border: isFilterSectionInputType ? [
            "blockend"
        ] : [],
        padding: isFilterSectionInputType ? {
            blockstart: "four",
            blockend: "six"
        } : {},
        margin: isFilterSectionInputType ? {
            blockstart: "unset"
        } : {
            blockstart: "six"
        }
    };
    var fieldSpacingProps = {
        margin: isFilterSectionInputType && fields.length === 1 ? {
            blockstart: "two"
        } : {
            blockstart: "six"
        }
    };
    var spacingProps = useUnsetTopBorder ? noTopBorderSpacingProps : borderedSpacingProps;
    var focusNextElement = function() {
        var _containerRef_current;
        var focusableElements = (_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
        var currentElement = document.activeElement;
        if (focusableElements && _instanceof(currentElement, HTMLElement)) {
            var index = _toConsumableArray(focusableElements).indexOf(currentElement);
            if (index > -1) {
                var _focusableElements_;
                var nextElement = (_focusableElements_ = focusableElements[index + 1]) !== null && _focusableElements_ !== void 0 ? _focusableElements_ : focusableElements[0];
                nextElement.focus();
            }
        }
    };
    return /* @__PURE__ */ React33.createElement(UitkSpacing12, _objectSpread({}, spacingProps), /* @__PURE__ */ React33.createElement("div", {
        "data-test-id": id,
        ref: containerRef
    }, title && /* @__PURE__ */ React33.createElement(UitkHeading11, {
        tag: "h3",
        size: 5
    }, title), /* @__PURE__ */ React33.createElement(UitkHeading11, {
        tag: "h4",
        size: 6
    }, subTitle), fields.map(function(field, fieldIndex) {
        var __typename = (field || {}).__typename;
        var typeaheadAdapter = field.__typename === "ShoppingTextInputField" ? typeaheadAdapters === null || typeaheadAdapters === void 0 ? void 0 : typeaheadAdapters.get(field.id) : void 0;
        var Field = validFieldComponents2.find(function(component) {
            return component.fragment.__typename === __typename;
        });
        if (!Field) {
            return null;
        }
        return /* @__PURE__ */ React33.createElement(UitkSpacing12, _objectSpreadProps(_objectSpread({}, fieldSpacingProps), {
            key: fieldIndex
        }), /* @__PURE__ */ React33.createElement("div", null, /* @__PURE__ */ React33.createElement(FieldStateProvider, {
            field: field
        }, /* @__PURE__ */ React33.createElement("div", null, __typename === TextInputField.fragment.__typename && /* @__PURE__ */ React33.createElement(Field, {
            key: "field-section-".concat(fieldIndex),
            data: field,
            typeaheadAdapter: typeaheadAdapter,
            onMultiSelectClose: onMultiSelectClose,
            onMultiSelectItemRemove: onMultiSelectItemRemove,
            onMultiSelectClearAll: onMultiSelectClearAll,
            onSelectionChange: onSelectionChange,
            essLogger: essLogger,
            onKeyDown: onKeyDown
        }), __typename === RangeField.fragment.__typename && /* @__PURE__ */ React33.createElement(Field, {
            key: "field-section-".concat(fieldIndex),
            data: field,
            onSelectedField: onSelectedField,
            onRangeSelectionChange: onRangeSelectionChange,
            resetFilters: resetFilters
        }), __typename !== TextInputField.fragment.__typename && __typename !== RangeField.fragment.__typename && /* @__PURE__ */ React33.createElement(Field, {
            key: "field-section-".concat(fieldIndex),
            data: field,
            onClick: onFieldClick,
            onSelectedField: onSelectedField,
            keepSectionExpanded: keepSectionExpanded,
            resetFilters: resetFilters,
            onStepInputChange: onStepInputChange,
            onRangeSelectionChange: onRangeSelectionChange,
            hasNoSectionTitle: !title,
            focusNextElement: focusNextElement
        })))));
    })));
};
SortAndFilterSection.displayName = "SortAndFilterSection";
SortAndFilterSection.fragment = __Fragment26;
// ../internal/src/components/sort-filter/search-tools-filters.tsx
var __Fragment27 = gql34(_templateObject38(), SortAndFilterSection.fragment);
var SearchToolsFilters = function(props) {
    var data = props.data, onMultiSelectClose = props.onMultiSelectClose, onMultiSelectItemRemove = props.onMultiSelectItemRemove, onMultiSelectClearAll = props.onMultiSelectClearAll, onSelectionChange = props.onSelectionChange, typeaheadAdapters = props.typeaheadAdapters, onRangeSelectionChange = props.onRangeSelectionChange, useUnsetMargin = props.useUnsetMargin, useUnsetTopBorder = props.useUnsetTopBorder, onEmptyResults = props.onEmptyResults, keepSectionExpanded = props.keepSectionExpanded, essLogger = props.essLogger, onKeyDown = props.onKeyDown;
    var filterSections = data.filterSections;
    if (!Array.isArray(filterSections)) {
        onEmptyResults === null || onEmptyResults === void 0 ? void 0 : onEmptyResults();
        return null;
    }
    return /* @__PURE__ */ React34.createElement(React34.Fragment, null, filterSections.map(function(section, index) {
        return /* @__PURE__ */ React34.createElement(SortAndFilterSection, {
            key: "filter-section-".concat(index),
            data: section,
            typeaheadAdapters: typeaheadAdapters,
            onMultiSelectClose: onMultiSelectClose,
            onMultiSelectItemRemove: onMultiSelectItemRemove,
            onMultiSelectClearAll: onMultiSelectClearAll,
            onSelectionChange: onSelectionChange,
            onRangeSelectionChange: onRangeSelectionChange,
            useUnsetMargin: useUnsetMargin,
            useUnsetTopBorder: useUnsetTopBorder,
            keepSectionExpanded: keepSectionExpanded,
            essLogger: essLogger,
            onKeyDown: onKeyDown
        });
    }));
};
SearchToolsFilters.displayName = "SearchToolsFilters";
SearchToolsFilters.fragment = __Fragment27;
// ../internal/src/components/sort-filter/search-tools-sort.tsx
import React35 from "react";
import { gql as gql35 } from "@apollo/client";
var __Fragment28 = gql35(_templateObject39(), DropdownField.fragment);
var SearchToolsSort = function(param) {
    var data = param.data, onKeyPress = param.onKeyPress, onClick = param.onClick, onEmptyResults = param.onEmptyResults;
    var sortSections = data.sortSections;
    if (!Array.isArray(sortSections)) {
        onEmptyResults === null || onEmptyResults === void 0 ? void 0 : onEmptyResults();
        return null;
    }
    return /* @__PURE__ */ React35.createElement(React35.Fragment, null, sortSections.map(function(section) {
        return section.fields.map(function(field, index) {
            if (!(field.__typename === DropdownField.fragment.__typename)) {
                return null;
            }
            return /* @__PURE__ */ React35.createElement("div", {
                "data-test-id": section.id,
                key: index
            }, /* @__PURE__ */ React35.createElement(DropdownField, {
                key: "sort-field-".concat(index),
                data: field,
                onKeyPress: onKeyPress,
                onClick: onClick
            }));
        });
    }));
};
SearchToolsSort.displayName = "SearchToolsSort";
SearchToolsSort.fragment = __Fragment28;
// ../internal/src/components/sort-filter/search-tools-sort-and-filter.tsx
import React41 from "react";
import { gql as gql42 } from "@apollo/client";
import { useDialog } from "@shared-ui/dialog-context";
import { TOGGLE_PLACEMENT_FILTERS_SHEET } from "@shared-ui/retail-compare-providers";
import { CompareToggle } from "@shared-ui/retail-compare-toggle";
import { defaultViewSizes, useMediaQueries } from "@shared-ui/viewport-context";
import { UitkButtonSize as UitkButtonSize2 } from "uitk-react-button";
import { UitkDialogContent } from "uitk-react-dialog";
import { UitkScrim, UitkScrimType } from "uitk-react-scrim";
import { UitkSheet } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing13 } from "uitk-react-spacing";
// ../internal/src/components/common/ui-floating-action-button/ui-floating-action-button.tsx
import React38 from "react";
import { gql as gql39 } from "@apollo/client";
import { UitkButtonSize } from "uitk-react-button";
// ../internal/src/components/common/ui-floating-action-button/ui-primary-floating-action-button.tsx
import React36 from "react";
import { gql as gql37 } from "@apollo/client";
import { useClickTracker as useClickTracker18 } from "@shared-ui/clickstream-analytics-context";
import { UitkNotificationBadge1 } from "uitk-react-badge";
import { UitkPrimaryButton } from "uitk-react-button";
// ../internal/src/components/common/client-side-analytics.ts
import { gql as gql36 } from "@apollo/client";
var clientSideAnalyticsFragment = gql36(_templateObject40());
// ../internal/src/components/common/ui-floating-action-button/ui-primary-floating-action-button.tsx
var __Fragment29 = gql37(_templateObject41(), clientSideAnalyticsFragment, Icon.fragment);
var UIPrimaryFloatingActionButton = function(props) {
    var data = props.data, onClick = props.onClick, isFullWidth = props.isFullWidth, size = props.size, triggerRef = props.triggerRef;
    var primary = data.primary, icon = data.icon, badge = data.badge, analytics = data.analytics, egdsElementId = data.egdsElementId, disabled = data.disabled;
    var track = useClickTracker18();
    var handleClick = React36.useCallback(function() {
        if (analytics) {
            var referrerId = analytics.referrerId, linkName = analytics.linkName;
            track(referrerId, linkName);
        }
        onClick();
    }, [
        analytics,
        onClick,
        track
    ]);
    return /* @__PURE__ */ React36.createElement(UitkPrimaryButton, {
        isFullWidth: isFullWidth,
        onClick: handleClick,
        size: size,
        "data-test-id": egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "",
        domRef: triggerRef,
        disabled: disabled
    }, badge && /* @__PURE__ */ React36.createElement(UitkNotificationBadge1, {
        text: badge.toString()
    }), primary, icon && /* @__PURE__ */ React36.createElement(Icon, {
        data: icon
    }));
};
UIPrimaryFloatingActionButton.displayName = "UIPrimaryFloatingActionButton";
UIPrimaryFloatingActionButton.fragment = __Fragment29;
// ../internal/src/components/common/ui-floating-action-button/ui-secondary-floating-action-button.tsx
import React37 from "react";
import { gql as gql38 } from "@apollo/client";
import { useClickTracker as useClickTracker19 } from "@shared-ui/clickstream-analytics-context";
import { UitkBadgeNotification, UitkNotificationBadge1 as UitkNotificationBadge12 } from "uitk-react-badge";
import { UitkSecondaryButton } from "uitk-react-button";
import { UitkLayoutFlex as UitkLayoutFlex3, UitkLayoutFlexItem as UitkLayoutFlexItem4 } from "uitk-react-layout-flex";
import { UitkLayoutPosition } from "uitk-react-layout-position";
var __Fragment30 = gql38(_templateObject42(), clientSideAnalyticsFragment, Icon.fragment);
var Badge = function(param) {
    var badge = param.badge, withUpdatedNotification = param.withUpdatedNotification;
    if (withUpdatedNotification) {
        return /* @__PURE__ */ React37.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React37.createElement(UitkLayoutPosition, {
            type: "relative",
            position: {
                right: "one",
                bottom: "half"
            }
        }, /* @__PURE__ */ React37.createElement(UitkBadgeNotification, {
            count: badge.toString(),
            theme: "action",
            visible: true
        })));
    }
    return /* @__PURE__ */ React37.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React37.createElement(UitkNotificationBadge12, {
        text: badge.toString()
    }));
};
var UISecondaryFloatingActionButton = function(props) {
    var data = props.data, onClick = props.onClick, isFullWidth = props.isFullWidth, size = props.size, withUpdatedNotification = props.withUpdatedNotification, triggerRef = props.triggerRef;
    var primary = data.primary, icon = data.icon, badge = data.badge, analytics = data.analytics, egdsElementId = data.egdsElementId;
    var track = useClickTracker19();
    var handleClick = React37.useCallback(function() {
        if (analytics) {
            var referrerId = analytics.referrerId, linkName = analytics.linkName;
            track(referrerId, linkName);
        }
        onClick();
    }, [
        analytics,
        onClick,
        track
    ]);
    return /* @__PURE__ */ React37.createElement(UitkSecondaryButton, {
        isFullWidth: isFullWidth,
        onClick: handleClick,
        size: size,
        "data-test-id": egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "",
        domRef: triggerRef
    }, /* @__PURE__ */ React37.createElement(UitkLayoutFlex3, {
        space: withUpdatedNotification && !!badge ? "six" : "two"
    }, !!badge && /* @__PURE__ */ React37.createElement(Badge, {
        badge: badge,
        withUpdatedNotification: withUpdatedNotification
    }), icon && !badge && /* @__PURE__ */ React37.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React37.createElement(Icon, {
        data: icon
    })), /* @__PURE__ */ React37.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React37.createElement("div", null, primary))));
};
UISecondaryFloatingActionButton.displayName = "UISecondaryFloatingActionButton";
UISecondaryFloatingActionButton.fragment = __Fragment30;
// ../internal/src/components/common/ui-floating-action-button/ui-floating-action-button.tsx
var __Fragment31 = gql39(_templateObject43(), UIPrimaryFloatingActionButton.fragment, UISecondaryFloatingActionButton.fragment);
var UIFloatingActionButtonImplementationsMap = {
    UIPrimaryFloatingActionButton: UIPrimaryFloatingActionButton,
    UISecondaryFloatingActionButton: UISecondaryFloatingActionButton
};
var UIFloatingActionButton = function(param) {
    var onClick = param.onClick, _param_isFullWidth = param.isFullWidth, isFullWidth = _param_isFullWidth === void 0 ? false : _param_isFullWidth, _param_size = param.size, size = _param_size === void 0 ? UitkButtonSize.MEDIUM : _param_size, data = param.data, withUpdatedNotification = param.withUpdatedNotification, triggerRef = param.triggerRef;
    var __typename = data.__typename;
    var Button = UIFloatingActionButtonImplementationsMap[__typename];
    if (Button) {
        return /* @__PURE__ */ React38.createElement(Button, {
            onClick: onClick,
            isFullWidth: isFullWidth,
            size: size,
            data: data,
            withUpdatedNotification: withUpdatedNotification,
            triggerRef: triggerRef
        });
    }
    return null;
};
UIFloatingActionButton.displayName = "UIFloatingActionButton";
UIFloatingActionButton.fragment = __Fragment31;
// ../internal/src/components/sort-filter/__private/__fragments/toolbar.tsx
import React40 from "react";
import { gql as gql41 } from "@apollo/client";
import { useClickTracker as useClickTracker21 } from "@shared-ui/clickstream-analytics-context";
import { UitkToolbar } from "uitk-react-toolbar";
// ../internal/src/components/common/button/egds-tertiary-button.tsx
import React39 from "react";
import { gql as gql40 } from "@apollo/client";
import { useClickTracker as useClickTracker20 } from "@shared-ui/clickstream-analytics-context";
import { UitkTertiaryButton } from "uitk-react-button";
import { UitkIcon as UitkIcon2 } from "uitk-react-icons";
var __Fragment32 = gql40(_templateObject44(), EGDSButtonFragment);
var EGDSTertiaryButton = function(param) {
    var onClick = param.onClick, isFullWidth = param.isFullWidth, size = param.size, data = param.data, isDisabled = param.isDisabled;
    var egdsElementId = data.egdsElementId, primary = data.primary, disabled = data.disabled, accessibility = data.accessibility, analytics = data.analytics, icon = data.icon;
    var id = egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "search_form_tertiary_button";
    var track = useClickTracker20();
    var disableState = isDisabled || disabled;
    var handleClick = React39.useCallback(function() {
        if (analytics) {
            var referrerId = analytics.referrerId, linkName = analytics.linkName;
            track(referrerId, linkName);
        }
        onClick();
    }, [
        analytics,
        onClick,
        track
    ]);
    return /* @__PURE__ */ React39.createElement(UitkTertiaryButton, {
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : "",
        id: id,
        "data-test-id": id,
        onClick: handleClick,
        disabled: disableState,
        isFullWidth: isFullWidth,
        size: size
    }, icon && /* @__PURE__ */ React39.createElement(UitkIcon2, {
        name: icon.id
    }), primary);
};
EGDSTertiaryButton.displayName = "EGDSTertiaryButton";
EGDSTertiaryButton.fragment = __Fragment32;
// ../internal/src/components/sort-filter/__private/__fragments/toolbar.tsx
var __Fragment33 = gql41(_templateObject45(), EGDSTertiaryButton.fragment);
var Toolbar = function(props) {
    var data = props.data, onCloseButtonClick = props.onCloseButtonClick, onClearAllButtonClick = props.onClearAllButtonClick;
    var actions = data.actions, primary = data.primary;
    var close = actions.primary, secondaries = actions.secondaries;
    var track = useClickTracker21();
    var _actions_primary_egdsElementId;
    var id = (_actions_primary_egdsElementId = actions.primary.egdsElementId) !== null && _actions_primary_egdsElementId !== void 0 ? _actions_primary_egdsElementId : "";
    var _close_accessibility;
    var closeAccessibility = (_close_accessibility = close.accessibility) !== null && _close_accessibility !== void 0 ? _close_accessibility : "";
    var handleCloseButton = React40.useCallback(function() {
        if (actions.primary.analytics) {
            var _actions_primary_analytics = actions.primary.analytics, referrerId = _actions_primary_analytics.referrerId, linkName = _actions_primary_analytics.linkName;
            track(referrerId, linkName);
        }
        onCloseButtonClick === null || onCloseButtonClick === void 0 ? void 0 : onCloseButtonClick();
    }, [
        actions.primary.analytics,
        onCloseButtonClick,
        track
    ]);
    if (!primary || !Array.isArray(secondaries) || secondaries.length === 0) {
        return null;
    }
    var _secondaries = _slicedToArray(secondaries, 1), clearAll = _secondaries[0];
    return /* @__PURE__ */ React40.createElement(UitkToolbar, {
        toolbarTitle: primary,
        navigationContent: onCloseButtonClick ? {
            onClick: handleCloseButton,
            navIconLabel: closeAccessibility,
            navButtonId: id
        } : void 0,
        toolbarActionContent: /* @__PURE__ */ React40.createElement(EGDSTertiaryButton, {
            data: clearAll,
            onClick: onClearAllButtonClick
        })
    });
};
Toolbar.displayName = "Toolbar";
Toolbar.fragment = __Fragment33;
// ../internal/src/components/sort-filter/search-tools-sort-and-filter.tsx
var __Fragment34 = gql42(_templateObject46(), SortAndFilterSection.fragment, Toolbar.fragment, UIFloatingActionButton.fragment);
var viewType = "SORT_AND_FILTERS" /* SORT_AND_FILTERS */ ;
var SearchToolsSortAndFilter = function(props) {
    var data = props.data, onEmptyResults = props.onEmptyResults, onFieldClick = props.onFieldClick, onMultiSelectClose = props.onMultiSelectClose, onMultiSelectItemRemove = props.onMultiSelectItemRemove, onMultiSelectClearAll = props.onMultiSelectClearAll, onSubmit = props.onSubmit, onOpenDialog = props.onOpenDialog, onClearFilters = props.onClearFilters, typeaheadAdapters = props.typeaheadAdapters, onSelectionChange = props.onSelectionChange, onRangeSelectionChange = props.onRangeSelectionChange, onRemoveAllAppliedFilters = props.onRemoveAllAppliedFilters, keepSectionExpanded = props.keepSectionExpanded, onStepInputChange = props.onStepInputChange, withExtraMarginBlockEnd = props.withExtraMarginBlockEnd, withUpdatedNotification = props.withUpdatedNotification;
    var _ref = data || {}, __typename = _ref.__typename, sortSections = _ref.sortSections, filterSections = _ref.filterSections, legacySections = _ref.sections, containers = _ref.containers;
    var _ref1 = (containers === null || containers === void 0 ? void 0 : containers.find(function(container) {
        return container.view === viewType;
    })) || {}, toolbarData = _ref1.toolbar, revealAction = _ref1.revealAction, applyAction = _ref1.applyAction;
    var combinedSections = [
        sortSections,
        filterSections,
        legacySections
    ];
    var isSmallViewSize = useMediaQueries({
        viewSizes: defaultViewSizes
    }) === defaultViewSizes.SMALL;
    var _useDialog = _slicedToArray(useDialog("".concat(__typename, "-").concat(viewType)), 3), dialogActions = _useDialog[1], DialogComponent = _useDialog[2];
    var openDialog = dialogActions.openDialog, closeDialog = dialogActions.closeDialog;
    var _React41_useState = _slicedToArray(React41.useState(toolbarData), 2), toolbar = _React41_useState[0], setToolbar = _React41_useState[1];
    var _React41_useState1 = _slicedToArray(React41.useState(false), 2), resetFilters = _React41_useState1[0], setResetFilters = _React41_useState1[1];
    var triggerRef = React41.useRef(null);
    var handleTriggerClick = React41.useCallback(function() {
        if (onOpenDialog) {
            onOpenDialog();
        }
        setResetFilters(false);
        setToolbar(toolbarData);
        openDialog();
    }, [
        onOpenDialog,
        openDialog,
        toolbarData
    ]);
    var handleSubmitClick = React41.useCallback(function() {
        if (onSubmit) {
            onSubmit();
        }
        closeDialog();
    }, [
        onSubmit,
        closeDialog
    ]);
    var handleCloseButtonClick = React41.useCallback(function() {
        if (onClearFilters) {
            onClearFilters({
                name: "restore" /* RESTORE */ ,
                value: {}
            });
        }
        closeDialog();
    }, [
        closeDialog
    ]);
    var handleClearButtonClick = React41.useCallback(function() {
        var _toolbar_actions_secondaries;
        if (onRemoveAllAppliedFilters) {
            onRemoveAllAppliedFilters();
        }
        if (onClearFilters) {
            onClearFilters({
                name: "clear" /* CLEAR */ ,
                value: {}
            });
        }
        setResetFilters(true);
        var toolBarAttributes = _objectSpreadProps(_objectSpread({}, toolbar), {
            actions: _objectSpreadProps(_objectSpread({}, toolbar === null || toolbar === void 0 ? void 0 : toolbar.actions), {
                secondaries: (_toolbar_actions_secondaries = toolbar === null || toolbar === void 0 ? void 0 : toolbar.actions.secondaries) === null || _toolbar_actions_secondaries === void 0 ? void 0 : _toolbar_actions_secondaries.map(function(element) {
                    return _objectSpreadProps(_objectSpread({}, element), {
                        disabled: true
                    });
                })
            })
        });
        setToolbar(toolBarAttributes);
    }, [
        onRemoveAllAppliedFilters
    ]);
    var onSelectedField = React41.useCallback(function() {
        setToolbar(toolbarData);
        setResetFilters(false);
    }, [
        toolbarData
    ]);
    var hasSections = combinedSections.some(function(sections) {
        return Array.isArray(sections) && sections.length > 0;
    });
    if (!hasSections || !revealAction || !applyAction) {
        onEmptyResults === null || onEmptyResults === void 0 ? void 0 : onEmptyResults();
        return null;
    }
    return /* @__PURE__ */ React41.createElement(React41.Fragment, null, /* @__PURE__ */ React41.createElement(UIFloatingActionButton, {
        data: revealAction,
        isFullWidth: true,
        onClick: handleTriggerClick,
        withUpdatedNotification: withUpdatedNotification,
        triggerRef: triggerRef
    }), /* @__PURE__ */ React41.createElement(DialogComponent, null, /* @__PURE__ */ React41.createElement(UitkSheet, {
        type: isSmallViewSize ? "full" : "centered",
        isVisible: true,
        returnFocusOnClose: true,
        triggerRef: triggerRef
    }, toolbar && /* @__PURE__ */ React41.createElement(Toolbar, {
        data: toolbar,
        onCloseButtonClick: handleCloseButtonClick,
        onClearAllButtonClick: handleClearButtonClick
    }), /* @__PURE__ */ React41.createElement(UitkDialogContent, {
        zeroPadding: true
    }, /* @__PURE__ */ React41.createElement(CompareToggle, {
        placement: TOGGLE_PLACEMENT_FILTERS_SHEET
    }), /* @__PURE__ */ React41.createElement(UitkSpacing13, {
        padding: {
            blockend: "twelve",
            inline: "four"
        },
        margin: {
            blockend: withExtraMarginBlockEnd ? "twelve" : "three"
        }
    }, /* @__PURE__ */ React41.createElement("div", {
        "data-test-id": "sort-filter-drawer"
    }, combinedSections.map(function(sections) {
        if (!Array.isArray(sections)) {
            return null;
        }
        return sections.map(function(section, index) {
            return /* @__PURE__ */ React41.createElement(SortAndFilterSection, {
                key: "sort-section-".concat(index),
                data: section,
                typeaheadAdapters: typeaheadAdapters,
                onFieldClick: onFieldClick,
                onMultiSelectClose: onMultiSelectClose,
                onMultiSelectItemRemove: onMultiSelectItemRemove,
                onMultiSelectClearAll: onMultiSelectClearAll,
                onSelectionChange: onSelectionChange,
                onSelectedField: onSelectedField,
                onRangeSelectionChange: onRangeSelectionChange,
                onStepInputChange: onStepInputChange,
                keepSectionExpanded: keepSectionExpanded,
                resetFilters: resetFilters
            });
        });
    })))), /* @__PURE__ */ React41.createElement(UitkScrim, {
        type: UitkScrimType.BUTTON
    }, /* @__PURE__ */ React41.createElement(UIFloatingActionButton, {
        data: applyAction,
        isFullWidth: true,
        size: UitkButtonSize2.LARGE,
        onClick: handleSubmitClick
    })))));
};
SearchToolsSortAndFilter.displayName = "SearchToolsSortAndFilter";
SearchToolsSortAndFilter.fragment = __Fragment34;
// ../internal/src/components/sort-filter/search-tools-filter-bar.tsx
import React49 from "react";
import { gql as gql49 } from "@apollo/client";
import { useClickTracker as useClickTracker25 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog4 } from "@shared-ui/dialog-context";
import { SignalEventsContextProvider } from "@shared-ui/signal-events-context";
import { PubSubEventManager } from "@shared-ui/signal-events-context_pub-sub-observer";
import { defaultViewSizes as defaultViewSizes4, useMediaQueries as useMediaQueries4 } from "@shared-ui/viewport-context";
import { UitkDialogContent as UitkDialogContent3 } from "uitk-react-dialog";
import { UitkLayoutFlex as UitkLayoutFlex8, UitkLayoutFlexItem as UitkLayoutFlexItem9 } from "uitk-react-layout-flex";
import { UitkPill as UitkPill3 } from "uitk-react-pill";
import { UitkSheet as UitkSheet4 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing18 } from "uitk-react-spacing";
// ../internal/src/components/sort-filter/__private/__fragments/filter-sheet-footer/all-filter-sheet-footer.tsx
import React42 from "react";
import { gql as gql43 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex4, UitkLayoutFlexItem as UitkLayoutFlexItem5 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing14 } from "uitk-react-spacing";
import { UitkParagraph as UitkParagraph4 } from "uitk-react-text";
var __Fragment35 = gql43(_templateObject47(), UIFloatingActionButton.fragment);
var AllFilterSheetFooter = function(param) {
    var data = param.data, viewType4 = param.viewType, onClick = param.onClick;
    var footerLabel = data.footerLabel, containers = data.containers;
    var _containers_find;
    var applyAction = ((_containers_find = containers === null || containers === void 0 ? void 0 : containers.find(function(container) {
        return container.view === viewType4;
    })) !== null && _containers_find !== void 0 ? _containers_find : {}).applyAction;
    if (!applyAction) {
        return null;
    }
    return /* @__PURE__ */ React42.createElement(UitkSpacing14, {
        padding: {
            small: "four",
            large: {
                inline: "six"
            }
        },
        border: [
            "blockstart"
        ]
    }, /* @__PURE__ */ React42.createElement(UitkLayoutFlex4, {
        justifyContent: footerLabel ? "space-between" : "end",
        alignItems: "center"
    }, /* @__PURE__ */ React42.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */ React42.createElement(UitkParagraph4, null, footerLabel)), /* @__PURE__ */ React42.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */ React42.createElement(UIFloatingActionButton, {
        data: applyAction,
        onClick: onClick,
        withUpdatedNotification: true
    }))));
};
AllFilterSheetFooter.displayName = "AllFilterSheetFooter";
AllFilterSheetFooter.fragment = __Fragment35;
// ../internal/src/components/sort-filter/__private/__fragments/quick-access-filter-field.tsx
import React47 from "react";
import { gql as gql47 } from "@apollo/client";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
import { Experiment, ExperimentControl, ExperimentVariant, useExperiment as useExperiment2 } from "@shared-ui/experiment-context";
import { defaultViewSizes as defaultViewSizes3, useMediaQueries as useMediaQueries3 } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex6, UitkLayoutFlexItem as UitkLayoutFlexItem7 } from "uitk-react-layout-flex";
import { UitkSheetContent } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing16 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading12 } from "uitk-react-text";
// ../internal/src/components/common/button/egds-secondary-button.tsx
import React43 from "react";
import { gql as gql44 } from "@apollo/client";
import { useClickTracker as useClickTracker22 } from "@shared-ui/clickstream-analytics-context";
import { UitkSecondaryButton as UitkSecondaryButton2 } from "uitk-react-button";
var __Fragment36 = gql44(_templateObject48(), EGDSButtonFragment);
var EGDSSecondaryButton = function(param) {
    var onClick = param.onClick, data = param.data;
    var egdsElementId = data.egdsElementId, primary = data.primary, analytics = data.analytics;
    var id = egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "search_form_secondary_button";
    var track = useClickTracker22();
    var handleClick = React43.useCallback(function() {
        if (analytics) {
            var referrerId = analytics.referrerId, linkName = analytics.linkName;
            track(referrerId, linkName);
        }
        onClick();
    }, [
        analytics,
        onClick,
        track
    ]);
    return /* @__PURE__ */ React43.createElement(UitkSecondaryButton2, {
        id: id,
        onClick: handleClick
    }, primary);
};
EGDSSecondaryButton.displayName = "EGDSSecondaryButton";
EGDSSecondaryButton.fragment = __Fragment36;
// ../internal/src/components/sort-filter/quick-access-filter-wrappers.tsx
import React44 from "react";
import { defaultViewSizes as defaultViewSizes2, useMediaQueries as useMediaQueries2 } from "@shared-ui/viewport-context";
import { UitkSheet as UitkSheet2 } from "uitk-react-sheet";
var QuickAccessFilterSheetWrapper = function(_param) {
    var children = _param.children, sheetProps = _objectWithoutProperties(_param, [
        "children"
    ]);
    var triggerRef = sheetProps.triggerRef, isVisible = sheetProps.isVisible, onDismiss = sheetProps.onDismiss, isBottomSheet = sheetProps.isBottomSheet;
    var isSmallViewSize = useMediaQueries2({
        viewSizes: defaultViewSizes2
    }) === defaultViewSizes2.SMALL;
    var popoverSheetProps = {
        position: {
            inline: "leading",
            block: "trailing"
        },
        liveAnnounceString: "Popover Sheet has opened",
        type: "popover",
        width: 400,
        applyBlockStartMargin: true,
        autoFocus: true,
        triggerRef: triggerRef,
        isVisible: isVisible,
        onDismiss: onDismiss
    };
    var sideSheetProps = {
        liveAnnounceString: "Sheet has opened",
        type: "side",
        isVisible: isVisible,
        triggerRef: triggerRef
    };
    var bottomSheetProps = {
        liveAnnounceString: "Bottom has opened",
        type: "bottom",
        isVisible: isVisible,
        triggerRef: triggerRef
    };
    var controlSheetType = isSmallViewSize ? sideSheetProps : popoverSheetProps;
    var variantSheetType = bottomSheetProps;
    var props = isBottomSheet ? variantSheetType : controlSheetType;
    return /* @__PURE__ */ React44.createElement(UitkSheet2, _objectSpread({}, props), children);
};
var QuickAccessFilterDialogWrapper = function(_param) {
    var children = _param.children, DialogComponent = _param.DialogComponent, sheetProps = _objectWithoutProperties(_param, [
        "children",
        "DialogComponent"
    ]);
    var isVisible = sheetProps.isVisible, triggerRef = sheetProps.triggerRef;
    var centeredSheetProps = {
        liveAnnounceString: "Centered has opened",
        type: "centered",
        centeredSheetSize: "small",
        isVisible: isVisible,
        triggerRef: triggerRef
    };
    return /* @__PURE__ */ React44.createElement(DialogComponent, null, /* @__PURE__ */ React44.createElement(UitkSheet2, _objectSpread({}, centeredSheetProps), children));
};
// ../internal/src/components/sort-filter/__private/__fragments/filter-sheet-footer/quick-access-filter-sheet-footer.tsx
import React46 from "react";
import { gql as gql46 } from "@apollo/client";
import { UitkButtonSize as UitkButtonSize4 } from "uitk-react-button";
import { UitkLayoutFlex as UitkLayoutFlex5, UitkLayoutFlexItem as UitkLayoutFlexItem6 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing15 } from "uitk-react-spacing";
import { UitkParagraph as UitkParagraph5 } from "uitk-react-text";
// ../internal/src/components/common/button/egds-primary-button.tsx
import React45 from "react";
import { gql as gql45 } from "@apollo/client";
import { useClickTracker as useClickTracker23 } from "@shared-ui/clickstream-analytics-context";
import { UitkButtonSize as UitkButtonSize3, UitkFloatingFullWidthButton, UitkPrimaryButton as UitkPrimaryButton2 } from "uitk-react-button";
import { UitkScrim as UitkScrim2 } from "uitk-react-scrim";
var __Fragment37 = gql45(_templateObject49(), EGDSButtonFragment);
var EGDSPrimaryButton = function(param) {
    var data = param.data, onClick = param.onClick, size = param.size, _param_isFullWidth = param.isFullWidth, isFullWidth = _param_isFullWidth === void 0 ? true : _param_isFullWidth, _param_floating = param.floating, floating = _param_floating === void 0 ? false : _param_floating;
    var egdsElementId = data.egdsElementId, primary = data.primary, analytics = data.analytics;
    var id = egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "search_form_primary_button";
    var track = useClickTracker23();
    var handleClick = React45.useCallback(function() {
        if (analytics) {
            var referrerId = analytics.referrerId, linkName = analytics.linkName;
            track(referrerId, linkName);
        }
        onClick();
    }, [
        analytics,
        onClick,
        track
    ]);
    var primaryButtonProps = {
        onClick: handleClick,
        id: id,
        isFullWidth: isFullWidth,
        size: size || UitkButtonSize3.LARGE
    };
    return floating ? /* @__PURE__ */ React45.createElement(UitkScrim2, {
        type: "fade-button"
    }, /* @__PURE__ */ React45.createElement(UitkFloatingFullWidthButton, _objectSpread({}, primaryButtonProps), primary)) : /* @__PURE__ */ React45.createElement(UitkPrimaryButton2, _objectSpread({}, primaryButtonProps), primary);
};
EGDSPrimaryButton.displayName = "EGDSPrimaryButton";
EGDSPrimaryButton.fragment = __Fragment37;
// ../internal/src/components/sort-filter/__private/__fragments/filter-sheet-footer/quick-access-filter-sheet-footer.tsx
var __Fragment38 = gql46(_templateObject50(), EGDSPrimaryButton.fragment);
var QuickAccessFilterSheetFooter = function(param) {
    var data = param.data, onClick = param.onClick;
    var resultCountLabel = data.resultCountLabel, applyAction = data.applyAction;
    if ((applyAction === null || applyAction === void 0 ? void 0 : applyAction.__typename) !== "UIPrimaryButton") {
        return null;
    }
    return /* @__PURE__ */ React46.createElement(UitkSpacing15, {
        padding: {
            small: "four",
            large: {
                inline: "six"
            }
        }
    }, /* @__PURE__ */ React46.createElement(UitkLayoutFlex5, {
        justifyContent: resultCountLabel ? "space-between" : "end",
        alignItems: "center"
    }, /* @__PURE__ */ React46.createElement(UitkLayoutFlexItem6, null, /* @__PURE__ */ React46.createElement(UitkParagraph5, null, resultCountLabel)), /* @__PURE__ */ React46.createElement(UitkLayoutFlexItem6, null, /* @__PURE__ */ React46.createElement(EGDSPrimaryButton, {
        isFullWidth: false,
        data: applyAction,
        onClick: onClick,
        size: UitkButtonSize4.MEDIUM
    }))));
};
QuickAccessFilterSheetFooter.displayName = "QuickAccessFilterSheetFooter";
QuickAccessFilterSheetFooter.fragment = __Fragment38;
// ../internal/src/components/sort-filter/__private/__fragments/quick-access-filter-field.tsx
var __Fragment39 = gql47(_templateObject51(), EGDSPill.fragment, Toolbar.fragment, EGDSSecondaryButton.fragment, DropdownField.fragment, MultiSelectionField.fragment, RangeField.fragment, SelectionField.fragment, TextInputField.fragment, MultiSelectionStackedTileField.fragment, MultiSelectionTileField.fragment, StepInputField.fragment, MutexField.fragment, SelectedFiltersField.fragment, QuickAccessFilterSheetFooter.fragment);
var validFieldComponents3 = [
    DropdownField,
    MultiSelectionField,
    RangeField,
    SelectionField,
    TextInputField,
    MultiSelectionStackedTileField,
    MultiSelectionTileField,
    StepInputField,
    MutexField,
    SelectedFiltersField
];
var QuickAccessFilterField = function(param) {
    var data = param.data, keepSectionExpanded = param.keepSectionExpanded, onSubmit = param.onSubmit, onFieldClick = param.onFieldClick, onRangeSelectionChange = param.onRangeSelectionChange, onStepInputChange = param.onStepInputChange, onSelectedField = param.onSelectedField, handleClearButtonClick = param.handleClearButtonClick, loading = param.loading, isSheetVisible = param.isSheetVisible, onSheetToggle = param.onSheetToggle, sheetIndex = param.sheetIndex;
    var filterPill = data.filterPill, resultCountLabel = data.resultCountLabel, applyAction = data.applyAction, fields = data.fields, toolbar = data.toolbar;
    var _React47_useState = _slicedToArray(React47.useState(false), 2), resetFilters = _React47_useState[0], setResetFilters = _React47_useState[1];
    var domRef = React47.useRef(null);
    var isSmallViewSize = useMediaQueries3({
        viewSizes: defaultViewSizes3
    }) === defaultViewSizes3.SMALL;
    var _React47_useState1 = _slicedToArray(React47.useState([]), 2), quickAccessFields = _React47_useState1[0], setQuickAccessFields = _React47_useState1[1];
    var _useDialog2 = _slicedToArray(useDialog2("shopping-sort-and-filter-quick-filter-dialog-".concat(sheetIndex)), 3), isOpen = _useDialog2[0], _useDialog2_ = _useDialog2[1], openDialog = _useDialog2_.openDialog, closeDialog = _useDialog2_.closeDialog, DialogComponent = _useDialog2[2];
    var _useBexApi3 = useBexApi3(), device = _useBexApi3.context.device;
    var isMobileWeb = device.type === "MOBILE_PHONE";
    var quickFiltersExperimentName = "Introduce_Quick_Sort_and_Filters_at_top_of_SRP_".concat(isMobileWeb ? "mweb" : "web");
    var exposure = useExperiment2(quickFiltersExperimentName).exposure;
    React47.useEffect(function() {
        if (data.__typename === "ShoppingSortAndFilterQuickFilter") {
            var returnQuickFilterFields = calculateQuickFilterFields(data.fields);
            setQuickAccessFields(returnQuickFilterFields);
        }
    }, []);
    React47.useEffect(function() {
        if (resetFilters) {
            setResetFilters(false);
        }
    }, [
        resetFilters
    ]);
    if ((filterPill === null || filterPill === void 0 ? void 0 : filterPill.__typename) !== "EGDSBasicTriggerPill") {
        return null;
    }
    var filterPillData = _objectSpreadProps(_objectSpread({}, filterPill), {
        disabled: loading !== null && loading !== void 0 ? loading : false
    });
    var toolbarPrimary = toolbar === null || toolbar === void 0 ? void 0 : toolbar.primary;
    var toolbarSecondaries = toolbar === null || toolbar === void 0 ? void 0 : toolbar.actions.secondaries;
    var _ref = _slicedToArray(toolbarSecondaries !== null && toolbarSecondaries !== void 0 ? toolbarSecondaries : [], 1), clearAll = _ref[0];
    var clearButtonClick = function() {
        setResetFilters(true);
        handleClearButtonClick === null || handleClearButtonClick === void 0 ? void 0 : handleClearButtonClick(quickAccessFields);
    };
    var toggleSheet = function() {
        if (exposure.bucket === 1) {
            openDialog();
        }
        onSheetToggle(sheetIndex);
    };
    var handleSubmit = function() {
        if (exposure.bucket === 1) {
            closeDialog();
        }
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
        onSheetToggle(sheetIndex);
    };
    var hasSupportedFields = fields.some(function(param) {
        var __typename = param.__typename;
        return validFieldComponents3.find(function(param) {
            var fragment4 = param.fragment;
            return fragment4.__typename === __typename;
        });
    });
    if (!hasSupportedFields) {
        return null;
    }
    var quickAccessFilterSheetFooterData = {
        __typename: "ShoppingSortAndFilterQuickFilter",
        resultCountLabel: resultCountLabel,
        applyAction: applyAction,
        filterPill: {
            __typename: "EGDSBasicTriggerPill",
            id: filterPillData.id
        }
    };
    var QuickAccessFilterContent = /* @__PURE__ */ React47.createElement(React47.Fragment, null, isSmallViewSize ? toolbar && /* @__PURE__ */ React47.createElement(Toolbar, {
        onClearAllButtonClick: clearButtonClick,
        onCloseButtonClick: toggleSheet,
        data: toolbar
    }) : /* @__PURE__ */ React47.createElement(UitkSpacing16, {
        padding: {
            small: "four",
            medium: {
                inlinestart: "six",
                blockstart: "six",
                inlineend: "six",
                blockend: "two"
            }
        }
    }, /* @__PURE__ */ React47.createElement(UitkLayoutFlex6, {
        alignItems: "center",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React47.createElement(UitkLayoutFlexItem7, null, /* @__PURE__ */ React47.createElement(UitkHeading12, {
        tag: "h2",
        size: 6
    }, toolbarPrimary)), /* @__PURE__ */ React47.createElement(UitkLayoutFlexItem7, null, /* @__PURE__ */ React47.createElement(EGDSTertiaryButton, {
        data: clearAll,
        onClick: clearButtonClick
    })))), /* @__PURE__ */ React47.createElement(UitkSpacing16, {
        padding: {
            medium: {
                blockstart: "unset",
                blockend: "one",
                inlinestart: "six",
                inlineend: "six"
            }
        }
    }, /* @__PURE__ */ React47.createElement(UitkSheetContent, {
        padded: isSmallViewSize
    }, fields.map(function(field, fieldIndex) {
        var __typename = field.__typename;
        var Field = validFieldComponents3.find(function(component) {
            return component.fragment.__typename === __typename;
        });
        if (!Field) {
            return null;
        }
        return /* @__PURE__ */ React47.createElement(UitkSpacing16, {
            margin: {
                block: exposure.bucket === 0 ? "unset" : "four"
            },
            key: "field-section-".concat(fieldIndex)
        }, /* @__PURE__ */ React47.createElement("div", null, /* @__PURE__ */ React47.createElement(FieldStateProvider, {
            field: field
        }, __typename === RangeField.fragment.__typename && /* @__PURE__ */ React47.createElement(Field, {
            data: field,
            onSelectedField: onSelectedField,
            onRangeSelectionChange: onRangeSelectionChange,
            resetFilters: resetFilters
        }), __typename !== TextInputField.fragment.__typename && __typename !== RangeField.fragment.__typename && /* @__PURE__ */ React47.createElement(Field, {
            data: field,
            onClick: onFieldClick,
            onSelectedField: onSelectedField,
            keepSectionExpanded: keepSectionExpanded,
            resetFilters: resetFilters,
            onStepInputChange: onStepInputChange,
            onRangeSelectionChange: onRangeSelectionChange
        }))));
    }))));
    return /* @__PURE__ */ React47.createElement(React47.Fragment, null, /* @__PURE__ */ React47.createElement(EGDSPill, {
        data: filterPillData,
        onClick: toggleSheet,
        active: isSheetVisible,
        triggerPill: true,
        domRef: domRef
    }), /* @__PURE__ */ React47.createElement(Experiment, {
        name: quickFiltersExperimentName
    }, /* @__PURE__ */ React47.createElement(ExperimentControl, null, /* @__PURE__ */ React47.createElement(QuickAccessFilterSheetWrapper, {
        triggerRef: domRef,
        isVisible: isSheetVisible,
        onDismiss: toggleSheet
    }, /* @__PURE__ */ React47.createElement(React47.Fragment, null, QuickAccessFilterContent, /* @__PURE__ */ React47.createElement(QuickAccessFilterSheetFooter, {
        data: quickAccessFilterSheetFooterData,
        onClick: handleSubmit
    })))), /* @__PURE__ */ React47.createElement(ExperimentVariant, {
        bucket: 1
    }, isMobileWeb ? /* @__PURE__ */ React47.createElement(QuickAccessFilterSheetWrapper, {
        triggerRef: domRef,
        isVisible: isSheetVisible,
        onDismiss: toggleSheet,
        isBottomSheet: true
    }, /* @__PURE__ */ React47.createElement(React47.Fragment, null, QuickAccessFilterContent, /* @__PURE__ */ React47.createElement(QuickAccessFilterSheetFooter, {
        data: quickAccessFilterSheetFooterData,
        onClick: handleSubmit
    }))) : /* @__PURE__ */ React47.createElement(QuickAccessFilterDialogWrapper, {
        DialogComponent: DialogComponent,
        isVisible: isOpen,
        triggerRef: domRef
    }, /* @__PURE__ */ React47.createElement(React47.Fragment, null, QuickAccessFilterContent, /* @__PURE__ */ React47.createElement(QuickAccessFilterSheetFooter, {
        data: quickAccessFilterSheetFooterData,
        onClick: handleSubmit
    }))))));
};
QuickAccessFilterField.displayName = "QuickAccessFilterField";
QuickAccessFilterField.fragment = __Fragment39;
QuickAccessFilterField.fragment.__typename = "ShoppingSortAndFilterQuickFilter";
// ../internal/src/components/sort-filter/__private/__fragments/quick-access-filter-more-filters.tsx
import React48 from "react";
import { gql as gql48 } from "@apollo/client";
import { useClickTracker as useClickTracker24 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog3 } from "@shared-ui/dialog-context";
import { UitkButtonSize as UitkButtonSize5, UitkSecondaryButton as UitkSecondaryButton3 } from "uitk-react-button";
import { UitkDialogContent as UitkDialogContent2 } from "uitk-react-dialog";
import { UitkLayoutFlex as UitkLayoutFlex7, UitkLayoutFlexItem as UitkLayoutFlexItem8 } from "uitk-react-layout-flex";
import { UitkSheet as UitkSheet3 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing17 } from "uitk-react-spacing";
var __Fragment40 = gql48(_templateObject52(), UIFloatingActionButton.fragment, Toolbar.fragment);
var QuickAccessFilterMoreFilters = function(param) {
    var data = param.data, onOpenDialog = param.onOpenDialog, onClearFilters = param.onClearFilters, onRemoveAllAppliedFilters = param.onRemoveAllAppliedFilters, onSubmit = param.onSubmit, setFiltersActive = param.setFiltersActive, setResetFilters = param.setResetFilters, setSubmitButtonClicked = param.setSubmitButtonClicked, filterSections = param.filterSections, loading = param.loading;
    var _useDialog3 = _slicedToArray(useDialog3("quick-access-filters-more-filters"), 3), _useDialog3_ = _useDialog3[1], openDialog = _useDialog3_.openDialog, closeDialog = _useDialog3_.closeDialog, DialogComponent = _useDialog3[2];
    var _data_container = data.container, toolbar = _data_container.toolbar, revealAction = _data_container.revealAction, applyAction = _data_container.applyAction;
    var track = useClickTracker24();
    var isUISecondaryFloatingActionButton = (revealAction === null || revealAction === void 0 ? void 0 : revealAction.__typename) === "UISecondaryFloatingActionButton";
    var handleTriggerClick = React48.useCallback(function() {
        onOpenDialog === null || onOpenDialog === void 0 ? void 0 : onOpenDialog();
        openDialog();
        if (isUISecondaryFloatingActionButton && (revealAction === null || revealAction === void 0 ? void 0 : revealAction.analytics)) {
            var _revealAction_analytics = revealAction.analytics, referrerId = _revealAction_analytics.referrerId, linkName = _revealAction_analytics.linkName;
            track(referrerId, linkName);
        }
    }, [
        openDialog,
        onOpenDialog
    ]);
    var handleSubmitClick = React48.useCallback(function() {
        setSubmitButtonClicked(true);
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
        closeDialog();
    }, [
        onSubmit,
        closeDialog
    ]);
    var handleCloseButtonClick = React48.useCallback(function() {
        onClearFilters === null || onClearFilters === void 0 ? void 0 : onClearFilters({
            name: "restore" /* RESTORE */ ,
            value: {}
        });
        setResetFilters(false);
        closeDialog();
    }, [
        closeDialog
    ]);
    var handleClearButtonClick = React48.useCallback(function() {
        onRemoveAllAppliedFilters === null || onRemoveAllAppliedFilters === void 0 ? void 0 : onRemoveAllAppliedFilters();
        onClearFilters === null || onClearFilters === void 0 ? void 0 : onClearFilters({
            name: "clear" /* CLEAR */ ,
            value: {}
        });
        setResetFilters(true);
        setFiltersActive(false);
    }, [
        onRemoveAllAppliedFilters,
        onClearFilters
    ]);
    if (!isUISecondaryFloatingActionButton || !applyAction || !filterSections) {
        return null;
    }
    var _revealAction_egdsElementId;
    return /* @__PURE__ */ React48.createElement(React48.Fragment, null, /* @__PURE__ */ React48.createElement(UitkLayoutFlexItem8, {
        shrink: 0
    }, /* @__PURE__ */ React48.createElement(UitkSpacing17, {
        margin: {
            inline: "two"
        }
    }, /* @__PURE__ */ React48.createElement(UitkSecondaryButton3, {
        size: UitkButtonSize5.SMALL,
        disabled: loading,
        onClick: handleTriggerClick,
        "data-test-id": (_revealAction_egdsElementId = revealAction.egdsElementId) !== null && _revealAction_egdsElementId !== void 0 ? _revealAction_egdsElementId : ""
    }, revealAction.primary))), /* @__PURE__ */ React48.createElement(DialogComponent, null, /* @__PURE__ */ React48.createElement(UitkSheet3, {
        type: "full",
        isVisible: true,
        returnFocusOnClose: true,
        triggerRef: null
    }, toolbar && /* @__PURE__ */ React48.createElement(Toolbar, {
        data: toolbar,
        onCloseButtonClick: handleCloseButtonClick,
        onClearAllButtonClick: handleClearButtonClick
    }), /* @__PURE__ */ React48.createElement(UitkDialogContent2, {
        zeroPadding: true
    }, /* @__PURE__ */ React48.createElement(UitkSpacing17, {
        padding: {
            inline: "six"
        }
    }, filterSections)), applyAction && /* @__PURE__ */ React48.createElement(UitkSpacing17, {
        padding: {
            small: "four",
            large: {
                inline: "six"
            }
        },
        border: [
            "blockstart"
        ]
    }, /* @__PURE__ */ React48.createElement(UitkLayoutFlex7, {
        justifyContent: "end",
        alignItems: "center"
    }, /* @__PURE__ */ React48.createElement(UitkLayoutFlexItem8, null, /* @__PURE__ */ React48.createElement(UIFloatingActionButton, {
        data: applyAction,
        onClick: handleSubmitClick,
        withUpdatedNotification: true
    })))))));
};
QuickAccessFilterMoreFilters.displayName = "QuickAccessFilterMoreFilters";
QuickAccessFilterMoreFilters.fragment = __Fragment40;
// ../internal/src/components/sort-filter/search-tools-filter-bar.tsx
var __Fragment41 = gql49(_templateObject53(), Toolbar.fragment, SortAndFilterSection.fragment, UIFloatingActionButton.fragment, QuickAccessFilterField.fragment, AllFilterSheetFooter.fragment, QuickAccessFilterMoreFilters.fragment);
var viewType2 = "FILTER_BAR" /* FILTER_BAR */ ;
var SearchToolsFilterBar = function(param) {
    var data = param.data, onOpenDialog = param.onOpenDialog, onRangeSelectionChange = param.onRangeSelectionChange, onStepInputChange = param.onStepInputChange, onSubmit = param.onSubmit, onRemoveAllAppliedFilters = param.onRemoveAllAppliedFilters, onClearFilters = param.onClearFilters, loading = param.loading;
    var _toolbarData_actions, _toolbarData_actions1, _revealAction_icon;
    var __typename = data.__typename, containers = data.containers, filterSections = data.filterSections, quickAccessFilters = data.quickAccessFilters, footerLabel = data.footerLabel;
    var _ref = (containers === null || containers === void 0 ? void 0 : containers.find(function(container) {
        return container.view === viewType2;
    })) || {}, toolbarData = _ref.toolbar, revealAction = _ref.revealAction, applyAction = _ref.applyAction;
    var _useDialog4 = _slicedToArray(useDialog4("".concat(__typename, "-").concat(viewType2)), 3), isOpen = _useDialog4[0], _useDialog4_ = _useDialog4[1], openDialog = _useDialog4_.openDialog, closeDialog = _useDialog4_.closeDialog, DialogComponent = _useDialog4[2];
    var isSmallViewSize = useMediaQueries4({
        viewSizes: defaultViewSizes4
    }) === defaultViewSizes4.SMALL;
    var _React49_useState = _slicedToArray(React49.useState(toolbarData), 2), toolbar = _React49_useState[0], setToolbar = _React49_useState[1];
    var _React49_useState1 = _slicedToArray(React49.useState(false), 2), resetFilters = _React49_useState1[0], setResetFilters = _React49_useState1[1];
    var _React49_useState2 = _slicedToArray(React49.useState((toolbarData === null || toolbarData === void 0 ? void 0 : (_toolbarData_actions = toolbarData.actions) === null || _toolbarData_actions === void 0 ? void 0 : _toolbarData_actions.secondaries) && (toolbarData === null || toolbarData === void 0 ? void 0 : (_toolbarData_actions1 = toolbarData.actions) === null || _toolbarData_actions1 === void 0 ? void 0 : _toolbarData_actions1.secondaries[0].disabled)), 2), filtersActive = _React49_useState2[0], setFiltersActive = _React49_useState2[1];
    var _React49_useState3 = _slicedToArray(React49.useState(true), 2), submitButtonClicked = _React49_useState3[0], setSubmitButtonClicked = _React49_useState3[1];
    var _quickAccessFilters_map;
    var _React49_useState4 = _slicedToArray(React49.useState((_quickAccessFilters_map = quickAccessFilters === null || quickAccessFilters === void 0 ? void 0 : quickAccessFilters.map(function() {
        return false;
    })) !== null && _quickAccessFilters_map !== void 0 ? _quickAccessFilters_map : []), 2), isSheetVisibleList = _React49_useState4[0], setIsSheetVisibleList = _React49_useState4[1];
    var track = useClickTracker25();
    var isUISecondaryFloatingActionButton = (revealAction === null || revealAction === void 0 ? void 0 : revealAction.__typename) === "UISecondaryFloatingActionButton";
    React49.useEffect(function() {
        var _toolbar_actions_secondaries;
        if (!toolbar) {
            return;
        }
        setToolbar(_objectSpreadProps(_objectSpread({}, toolbar), {
            actions: {
                __typename: "UIToolbarActions",
                primary: _objectSpread({}, toolbar.actions.primary),
                secondaries: ((_toolbar_actions_secondaries = toolbar.actions.secondaries) === null || _toolbar_actions_secondaries === void 0 ? void 0 : _toolbar_actions_secondaries.map(function(element) {
                    return _objectSpreadProps(_objectSpread({}, element), {
                        disabled: !filtersActive && resetFilters
                    });
                })) || []
            }
        }));
    }, [
        filtersActive,
        resetFilters
    ]);
    React49.useEffect(function() {
        if (!isOpen && !submitButtonClicked) {
            onClearFilters === null || onClearFilters === void 0 ? void 0 : onClearFilters({
                name: "restore" /* RESTORE */ ,
                value: {}
            });
            setResetFilters(false);
        }
        setSubmitButtonClicked(false);
    }, [
        isOpen
    ]);
    var handleTriggerClick = React49.useCallback(function() {
        onOpenDialog === null || onOpenDialog === void 0 ? void 0 : onOpenDialog();
        openDialog();
        if (isUISecondaryFloatingActionButton && (revealAction === null || revealAction === void 0 ? void 0 : revealAction.analytics)) {
            var _revealAction_analytics = revealAction.analytics, referrerId = _revealAction_analytics.referrerId, linkName = _revealAction_analytics.linkName;
            track(referrerId, linkName);
        }
    }, [
        openDialog,
        onOpenDialog
    ]);
    var handleSubmitClick = React49.useCallback(function() {
        setSubmitButtonClicked(true);
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
        closeDialog();
    }, [
        onSubmit,
        closeDialog
    ]);
    var handleCloseButtonClick = React49.useCallback(function() {
        onClearFilters === null || onClearFilters === void 0 ? void 0 : onClearFilters({
            name: "restore" /* RESTORE */ ,
            value: {}
        });
        setResetFilters(false);
        closeDialog();
    }, [
        closeDialog
    ]);
    var handleClearButtonClick = React49.useCallback(function() {
        onRemoveAllAppliedFilters === null || onRemoveAllAppliedFilters === void 0 ? void 0 : onRemoveAllAppliedFilters();
        onClearFilters === null || onClearFilters === void 0 ? void 0 : onClearFilters({
            name: "clear" /* CLEAR */ ,
            value: {}
        });
        setResetFilters(true);
        setFiltersActive(false);
    }, [
        onRemoveAllAppliedFilters,
        onClearFilters
    ]);
    var handleQuickAccessFiltersClearButtonClick = React49.useCallback(function(quickAccessFilterFieldsData) {
        onRemoveAllAppliedFilters === null || onRemoveAllAppliedFilters === void 0 ? void 0 : onRemoveAllAppliedFilters();
        onClearFilters === null || onClearFilters === void 0 ? void 0 : onClearFilters({
            name: "clear_quick_filters" /* CLEAR_QUICK_FILTERS */ ,
            value: quickAccessFilterFieldsData
        });
        setFiltersActive(false);
    }, [
        onRemoveAllAppliedFilters,
        onClearFilters
    ]);
    var onSelectedField = React49.useCallback(function() {
        setToolbar(toolbarData);
        setResetFilters(false);
        setFiltersActive(true);
    }, [
        toolbarData
    ]);
    var handleSheetToggle = function(index) {
        var newIsSheetVisibleList = isSheetVisibleList.map(function(isSheetVisible, sheetIndex) {
            if (sheetIndex === index) {
                return !isSheetVisible;
            }
            return false;
        });
        setIsSheetVisibleList(newIsSheetVisibleList);
    };
    if (!(filterSections === null || filterSections === void 0 ? void 0 : filterSections.length) || !revealAction || !applyAction || !isUISecondaryFloatingActionButton) {
        return null;
    }
    var allFilterSheetFooterData = {
        __typename: "ShoppingSortAndFilters",
        footerLabel: footerLabel,
        containers: containers
    };
    var mappedFilterSections = /* @__PURE__ */ React49.createElement("div", null, filterSections.map(function(section, index) {
        return /* @__PURE__ */ React49.createElement(SortAndFilterSection, {
            key: "sort-section-".concat(index),
            onSelectedField: onSelectedField,
            resetFilters: resetFilters,
            data: section,
            onRangeSelectionChange: onRangeSelectionChange,
            onStepInputChange: onStepInputChange
        });
    }));
    return /* @__PURE__ */ React49.createElement(SignalEventsContextProvider, {
        eventManager: PubSubEventManager
    }, /* @__PURE__ */ React49.createElement(UitkLayoutFlex8, {
        wrap: "nowrap"
    }, /* @__PURE__ */ React49.createElement(UitkLayoutFlexItem9, {
        shrink: 0
    }, /* @__PURE__ */ React49.createElement(UitkPill3, {
        id: "all-filters-pill",
        active: isOpen,
        icon: (_revealAction_icon = revealAction.icon) === null || _revealAction_icon === void 0 ? void 0 : _revealAction_icon.id,
        onClick: handleTriggerClick,
        selected: Boolean(revealAction.badge),
        onSubmit: handleSubmitClick,
        disabled: loading,
        triggerPill: true
    }, revealAction.primary)), quickAccessFilters === null || quickAccessFilters === void 0 ? void 0 : quickAccessFilters.map(function(quickAccessFilter, index) {
        switch(quickAccessFilter.__typename){
            case "ShoppingSortAndFilterQuickFilter":
                return /* @__PURE__ */ React49.createElement(QuickAccessFilterField, {
                    key: "quick-access-".concat(index),
                    data: quickAccessFilter,
                    onFieldClick: onSelectedField,
                    onRangeSelectionChange: onRangeSelectionChange,
                    onStepInputChange: onStepInputChange,
                    handleClearButtonClick: handleQuickAccessFiltersClearButtonClick,
                    onSubmit: onSubmit,
                    loading: loading,
                    isSheetVisible: isSheetVisibleList[index],
                    onSheetToggle: handleSheetToggle,
                    sheetIndex: index
                });
            case "ShoppingSortAndFilterButtonTrigger":
                if (!isSmallViewSize) {
                    return null;
                }
                return /* @__PURE__ */ React49.createElement(QuickAccessFilterMoreFilters, {
                    data: quickAccessFilter,
                    filterSections: mappedFilterSections,
                    onOpenDialog: onOpenDialog,
                    onClearFilters: onClearFilters,
                    onSubmit: onSubmit,
                    onRemoveAllAppliedFilters: onRemoveAllAppliedFilters,
                    setFiltersActive: setFiltersActive,
                    setResetFilters: setResetFilters,
                    setSubmitButtonClicked: setSubmitButtonClicked,
                    loading: loading
                });
            default:
                return null;
        }
    })), /* @__PURE__ */ React49.createElement(DialogComponent, null, /* @__PURE__ */ React49.createElement(UitkSheet4, {
        type: isSmallViewSize ? "full" : "centered",
        isVisible: true,
        returnFocusOnClose: true,
        triggerRef: null
    }, toolbar && /* @__PURE__ */ React49.createElement(Toolbar, {
        data: toolbar,
        onCloseButtonClick: handleCloseButtonClick,
        onClearAllButtonClick: handleClearButtonClick
    }), /* @__PURE__ */ React49.createElement(UitkDialogContent3, {
        zeroPadding: true
    }, /* @__PURE__ */ React49.createElement(UitkSpacing18, {
        padding: {
            inline: "six"
        }
    }, mappedFilterSections)), /* @__PURE__ */ React49.createElement(AllFilterSheetFooter, {
        data: allFilterSheetFooterData,
        viewType: viewType2,
        onClick: handleSubmitClick
    }))));
};
SearchToolsFilterBar.displayName = "SearchToolsFilterBar";
SearchToolsFilterBar.fragment = __Fragment41;
// ../internal/src/components/sort-filter/search-tools-filter-dialog.tsx
import React50 from "react";
import { gql as gql50 } from "@apollo/client";
import { useClickTracker as useClickTracker26 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog5 } from "@shared-ui/dialog-context";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkBadgeNotification as UitkBadgeNotification2 } from "uitk-react-badge";
import { UitkButtonSize as UitkButtonSize6, UitkTertiaryButton as UitkTertiaryButton3 } from "uitk-react-button";
import { UitkDialogContent as UitkDialogContent4 } from "uitk-react-dialog";
import { UitkLayoutFlex as UitkLayoutFlex9, UitkLayoutFlexItem as UitkLayoutFlexItem10 } from "uitk-react-layout-flex";
import { UitkLayoutPosition as UitkLayoutPosition2 } from "uitk-react-layout-position";
import { UitkScrim as UitkScrim3, UitkScrimType as UitkScrimType2 } from "uitk-react-scrim";
import { UitkSheet as UitkSheet5 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing19 } from "uitk-react-spacing";
var __Fragment42 = gql50(_templateObject54(), SortAndFilterSection.fragment, Toolbar.fragment, UIFloatingActionButton.fragment);
var viewType3 = "FILTER_DIALOG" /* FILTER_DIALOG */ ;
var SearchToolsFilterDialog = function(props) {
    var _toolbarData_actions, _toolbarData_actions1;
    var data = props.data, onEmptyResults = props.onEmptyResults, onMultiSelectClose = props.onMultiSelectClose, onMultiSelectItemRemove = props.onMultiSelectItemRemove, onMultiSelectClearAll = props.onMultiSelectClearAll, onSubmit = props.onSubmit, onOpenDialog = props.onOpenDialog, onClearFilters = props.onClearFilters, typeaheadAdapters = props.typeaheadAdapters, onSelectionChange = props.onSelectionChange, onRangeSelectionChange = props.onRangeSelectionChange, onRemoveAllAppliedFilters = props.onRemoveAllAppliedFilters, keepSectionExpanded = props.keepSectionExpanded;
    var __typename = data.__typename, containers = data.containers, filterSections = data.filterSections, legacySections = data.sections;
    var _ref = (containers === null || containers === void 0 ? void 0 : containers.find(function(container) {
        return container.view === viewType3;
    })) || {}, toolbarData = _ref.toolbar, revealAction = _ref.revealAction, applyAction = _ref.applyAction;
    var combinedSections = [
        filterSections,
        legacySections
    ];
    var _useDialog5 = _slicedToArray(useDialog5("".concat(__typename, "-").concat(viewType3)), 3), isOpen = _useDialog5[0], dialogActions = _useDialog5[1], DialogComponent = _useDialog5[2];
    var openDialog = dialogActions.openDialog, closeDialog = dialogActions.closeDialog;
    var _React50_useState = _slicedToArray(React50.useState(toolbarData), 2), toolbar = _React50_useState[0], setToolbar = _React50_useState[1];
    var _React50_useState1 = _slicedToArray(React50.useState(false), 2), resetFilters = _React50_useState1[0], setResetFilters = _React50_useState1[1];
    var _React50_useState2 = _slicedToArray(React50.useState((toolbarData === null || toolbarData === void 0 ? void 0 : (_toolbarData_actions = toolbarData.actions) === null || _toolbarData_actions === void 0 ? void 0 : _toolbarData_actions.secondaries) && (toolbarData === null || toolbarData === void 0 ? void 0 : (_toolbarData_actions1 = toolbarData.actions) === null || _toolbarData_actions1 === void 0 ? void 0 : _toolbarData_actions1.secondaries[0].disabled)), 2), filtersActive = _React50_useState2[0], setFiltersActive = _React50_useState2[1];
    var _React50_useState3 = _slicedToArray(React50.useState(true), 2), submitButtonClicked = _React50_useState3[0], setSubmitButtonClicked = _React50_useState3[1];
    var triggerRef = React50.useRef(null);
    React50.useEffect(function() {
        var _toolbar_actions_secondaries;
        if (!toolbar) {
            return;
        }
        setToolbar(_objectSpreadProps(_objectSpread({}, toolbar), {
            actions: {
                __typename: "UIToolbarActions",
                primary: _objectSpread({}, toolbar.actions.primary),
                secondaries: ((_toolbar_actions_secondaries = toolbar.actions.secondaries) === null || _toolbar_actions_secondaries === void 0 ? void 0 : _toolbar_actions_secondaries.map(function(element) {
                    return _objectSpreadProps(_objectSpread({}, element), {
                        disabled: !filtersActive && resetFilters
                    });
                })) || []
            }
        }));
    }, [
        filtersActive,
        resetFilters
    ]);
    React50.useEffect(function() {
        if (!isOpen && !submitButtonClicked) {
            onClearFilters === null || onClearFilters === void 0 ? void 0 : onClearFilters({
                name: "restore" /* RESTORE */ ,
                value: {}
            });
            setResetFilters(false);
        }
        setSubmitButtonClicked(false);
    }, [
        isOpen,
        submitButtonClicked
    ]);
    var track = useClickTracker26();
    var handleTriggerClick = React50.useCallback(function() {
        var _revealAction_analytics;
        if (onOpenDialog) {
            onOpenDialog();
        }
        if (revealAction && revealAction.__typename === "UISecondaryFloatingActionButton" && ((_revealAction_analytics = revealAction.analytics) === null || _revealAction_analytics === void 0 ? void 0 : _revealAction_analytics.__typename) === "ClientSideAnalytics") {
            var _revealAction_analytics1 = revealAction.analytics, referrerId = _revealAction_analytics1.referrerId, linkName = _revealAction_analytics1.linkName;
            track(referrerId, linkName);
        }
        openDialog();
    }, [
        openDialog,
        onOpenDialog,
        revealAction,
        track
    ]);
    var handleSubmitClick = React50.useCallback(function() {
        setSubmitButtonClicked(true);
        if (onSubmit) {
            onSubmit();
        }
        closeDialog();
    }, [
        onSubmit,
        closeDialog
    ]);
    var handleCloseButtonClick = React50.useCallback(function() {
        if (onClearFilters) {
            onClearFilters({
                name: "restore" /* RESTORE */ ,
                value: {}
            });
        }
        setResetFilters(false);
        closeDialog();
    }, [
        closeDialog
    ]);
    var handleClearButtonClick = React50.useCallback(function() {
        if (onRemoveAllAppliedFilters) {
            onRemoveAllAppliedFilters();
        }
        if (onClearFilters) {
            onClearFilters({
                name: "clear" /* CLEAR */ ,
                value: {}
            });
        }
        setResetFilters(true);
        setFiltersActive(false);
    }, [
        onRemoveAllAppliedFilters
    ]);
    var onSelectedField = React50.useCallback(function() {
        setToolbar(toolbarData);
        setResetFilters(false);
        setFiltersActive(true);
    }, [
        toolbarData
    ]);
    var hasSections = combinedSections.some(function(sections) {
        return Array.isArray(sections) && sections.length > 0;
    });
    if (!hasSections || !revealAction || !applyAction) {
        onEmptyResults === null || onEmptyResults === void 0 ? void 0 : onEmptyResults();
        return null;
    }
    if (revealAction.__typename !== "UISecondaryFloatingActionButton") {
        return null;
    }
    var badge = revealAction.badge, icon = revealAction.icon, primary = revealAction.primary;
    var btnContent = /* @__PURE__ */ React50.createElement(React50.Fragment, null, !!badge && /* @__PURE__ */ React50.createElement(UitkLayoutFlexItem10, null, /* @__PURE__ */ React50.createElement(UitkLayoutPosition2, {
        type: "relative",
        position: {
            right: "two",
            bottom: "half"
        }
    }, /* @__PURE__ */ React50.createElement(UitkBadgeNotification2, {
        count: badge.toString(),
        theme: "action",
        visible: true
    }))), icon && !badge && /* @__PURE__ */ React50.createElement(UitkLayoutFlexItem10, null, /* @__PURE__ */ React50.createElement(Icon, {
        data: icon
    })), /* @__PURE__ */ React50.createElement(UitkLayoutFlexItem10, null, /* @__PURE__ */ React50.createElement("div", null, primary)));
    return /* @__PURE__ */ React50.createElement(Viewport, null, /* @__PURE__ */ React50.createElement(ViewSmall, null, /* @__PURE__ */ React50.createElement(React50.Fragment, null, /* @__PURE__ */ React50.createElement(UitkTertiaryButton3, {
        isFullWidth: true,
        onClick: handleTriggerClick,
        size: UitkButtonSize6.MEDIUM,
        domRef: triggerRef
    }, /* @__PURE__ */ React50.createElement(UitkLayoutFlex9, {
        direction: "column",
        alignItems: "center"
    }, btnContent)), /* @__PURE__ */ React50.createElement(DialogComponent, null, /* @__PURE__ */ React50.createElement(UitkSheet5, {
        type: "full",
        isVisible: true,
        returnFocusOnClose: true,
        triggerRef: triggerRef
    }, toolbar && /* @__PURE__ */ React50.createElement(Toolbar, {
        data: toolbar,
        onCloseButtonClick: handleCloseButtonClick,
        onClearAllButtonClick: handleClearButtonClick
    }), /* @__PURE__ */ React50.createElement(UitkDialogContent4, {
        zeroPadding: true
    }, /* @__PURE__ */ React50.createElement(UitkSpacing19, {
        padding: {
            blockend: "twelve",
            inline: "four"
        },
        margin: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React50.createElement("div", null, combinedSections.map(function(sections) {
        if (!Array.isArray(sections) || sections.length === 0) {
            return null;
        }
        return sections.map(function(section, index) {
            return /* @__PURE__ */ React50.createElement(SortAndFilterSection, {
                key: "filter-section-".concat(index),
                data: section,
                typeaheadAdapters: typeaheadAdapters,
                onMultiSelectClose: onMultiSelectClose,
                onMultiSelectItemRemove: onMultiSelectItemRemove,
                onMultiSelectClearAll: onMultiSelectClearAll,
                onSelectionChange: onSelectionChange,
                onSelectedField: onSelectedField,
                onRangeSelectionChange: onRangeSelectionChange,
                keepSectionExpanded: keepSectionExpanded,
                useUnsetTopBorder: true,
                resetFilters: resetFilters
            });
        });
    })))), /* @__PURE__ */ React50.createElement(UitkScrim3, {
        type: UitkScrimType2.BUTTON
    }, /* @__PURE__ */ React50.createElement(UIFloatingActionButton, {
        data: applyAction,
        isFullWidth: true,
        size: UitkButtonSize6.LARGE,
        onClick: handleSubmitClick
    })))))), /* @__PURE__ */ React50.createElement(ViewMedium, null, /* @__PURE__ */ React50.createElement(React50.Fragment, null, /* @__PURE__ */ React50.createElement(UitkTertiaryButton3, {
        isFullWidth: true,
        onClick: handleTriggerClick,
        size: UitkButtonSize6.MEDIUM,
        domRef: triggerRef
    }, /* @__PURE__ */ React50.createElement(UitkLayoutFlex9, {
        space: badge ? "four" : "two"
    }, btnContent)), /* @__PURE__ */ React50.createElement(DialogComponent, null, /* @__PURE__ */ React50.createElement(UitkSheet5, {
        type: "centered",
        isVisible: true,
        returnFocusOnClose: true,
        triggerRef: triggerRef
    }, toolbar && /* @__PURE__ */ React50.createElement(Toolbar, {
        data: toolbar,
        onCloseButtonClick: handleCloseButtonClick,
        onClearAllButtonClick: handleClearButtonClick
    }), /* @__PURE__ */ React50.createElement(UitkDialogContent4, {
        zeroPadding: true
    }, /* @__PURE__ */ React50.createElement(UitkSpacing19, {
        padding: {
            blockend: "twelve",
            inline: "four"
        },
        margin: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React50.createElement("div", null, combinedSections.map(function(sections) {
        if (!Array.isArray(sections) || sections.length === 0) {
            return null;
        }
        return sections.map(function(section, index) {
            return /* @__PURE__ */ React50.createElement(SortAndFilterSection, {
                key: "filter-section-".concat(index),
                data: section,
                typeaheadAdapters: typeaheadAdapters,
                onMultiSelectClose: onMultiSelectClose,
                onMultiSelectItemRemove: onMultiSelectItemRemove,
                onMultiSelectClearAll: onMultiSelectClearAll,
                onSelectionChange: onSelectionChange,
                onSelectedField: onSelectedField,
                onRangeSelectionChange: onRangeSelectionChange,
                keepSectionExpanded: keepSectionExpanded,
                useUnsetTopBorder: true,
                resetFilters: resetFilters
            });
        });
    })))), /* @__PURE__ */ React50.createElement(UitkScrim3, {
        type: UitkScrimType2.BUTTON
    }, /* @__PURE__ */ React50.createElement(UIFloatingActionButton, {
        data: applyAction,
        isFullWidth: true,
        size: UitkButtonSize6.LARGE,
        onClick: handleSubmitClick
    })))))));
};
SearchToolsFilterDialog.displayName = "SearchToolsFilterDialog";
SearchToolsFilterDialog.fragment = __Fragment42;
// ../internal/src/components/sort-filter/search-tools-sort-tabs.tsx
import React52 from "react";
import { gql as gql52 } from "@apollo/client";
// ../internal/src/components/sort-filter/__private/__fragments/tab-selection-field.tsx
import React51, { useCallback as useCallback2, useEffect as useEffect5, useRef as useRef2, useState as useState6 } from "react";
import { gql as gql51 } from "@apollo/client";
import { useClickTracker as useClickTracker27 } from "@shared-ui/clickstream-analytics-context";
import { useFormCallback as useFormCallback9 } from "uitk-react-form";
import { UitkSpacing as UitkSpacing20 } from "uitk-react-spacing";
import { UitkTab, UitkTabs, UitkTabsType } from "uitk-react-tabs";
import { UitkHeading as UitkHeading13, UitkText as UitkText3 } from "uitk-react-text";
var __Fragment43 = gql51(_templateObject55());
var useDidUpdateEffect = function(fn, deps) {
    var didMount = useRef2(false);
    useEffect5(function() {
        if (didMount.current) {
            return fn();
        }
        didMount.current = true;
    }, deps);
};
var TabSelectionField = function(param) {
    var data = param.data;
    var _tabOptions_currentTabIndex;
    var track = useClickTracker27();
    var tabOptions = data.tabOptions;
    var defaultIndex = (tabOptions === null || tabOptions === void 0 ? void 0 : tabOptions.findIndex(function(option) {
        return option.selected;
    })) || 0;
    var _useState6 = _slicedToArray(useState6(defaultIndex), 2), currentTabIndex = _useState6[0], setCurrentTabIndex = _useState6[1];
    var _tabOptions_currentTabIndex_id;
    var tabSelectionFormCallback = useFormCallback9((_tabOptions_currentTabIndex_id = tabOptions === null || tabOptions === void 0 ? void 0 : (_tabOptions_currentTabIndex = tabOptions[currentTabIndex]) === null || _tabOptions_currentTabIndex === void 0 ? void 0 : _tabOptions_currentTabIndex.id) !== null && _tabOptions_currentTabIndex_id !== void 0 ? _tabOptions_currentTabIndex_id : "", function(event) {
        return event;
    });
    var handleTabSelect = useCallback2(function(selectedTabIndex) {
        var selectAnalytics = tabOptions === null || tabOptions === void 0 ? void 0 : tabOptions[selectedTabIndex].selectAnalytics;
        if (selectAnalytics) {
            var referrerId = selectAnalytics.referrerId, linkName = selectAnalytics.linkName;
            track(referrerId, linkName);
        }
        setCurrentTabIndex(selectedTabIndex);
    }, [
        tabOptions,
        track
    ]);
    useEffect5(function() {
        setCurrentTabIndex(defaultIndex);
    }, [
        defaultIndex
    ]);
    useDidUpdateEffect(function() {
        var _tabOptions_currentTabIndex;
        var _tabOptions_currentTabIndex_value;
        var fieldValue = (_tabOptions_currentTabIndex_value = tabOptions === null || tabOptions === void 0 ? void 0 : (_tabOptions_currentTabIndex = tabOptions[currentTabIndex]) === null || _tabOptions_currentTabIndex === void 0 ? void 0 : _tabOptions_currentTabIndex.value) !== null && _tabOptions_currentTabIndex_value !== void 0 ? _tabOptions_currentTabIndex_value : "";
        triggerInputChangeEvent(fieldValue, tabSelectionFormCallback);
    }, [
        currentTabIndex
    ]);
    if (!(tabOptions === null || tabOptions === void 0 ? void 0 : tabOptions.length)) {
        return null;
    }
    return /* @__PURE__ */ React51.createElement(UitkTabs, {
        selectedTab: currentTabIndex,
        onTabSelect: handleTabSelect,
        tabsType: UitkTabsType.EQUAL_WIDTH
    }, tabOptions === null || tabOptions === void 0 ? void 0 : tabOptions.map(function(option, index) {
        var accessibility = option.accessibility, id = option.id, primary = option.primary, secondary = option.secondary, value = option.value;
        var tabID = "".concat(id, "-").concat(value, "-").concat(index);
        return /* @__PURE__ */ React51.createElement(UitkTab, {
            name: primary,
            id: id,
            key: tabID,
            targetURI: "#",
            tabLinkAttr: {
                id: tabID,
                "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : ""
            }
        }, /* @__PURE__ */ React51.createElement(UitkSpacing20, {
            padding: {
                inline: "four",
                blockstart: "one"
            }
        }, /* @__PURE__ */ React51.createElement("div", null, secondary && /* @__PURE__ */ React51.createElement(React51.Fragment, null, /* @__PURE__ */ React51.createElement(UitkHeading13, {
            size: 6,
            tag: "h3"
        }, primary), /* @__PURE__ */ React51.createElement(UitkText3, {
            size: 200,
            spacing: "two"
        }, secondary)))));
    }));
};
TabSelectionField.displayName = "TabSelectionField";
TabSelectionField.fragment = __Fragment43;
TabSelectionField.fragment.__typename = "ShoppingTabSelectionField";
// ../internal/src/components/sort-filter/search-tools-sort-tabs.tsx
var __Fragment44 = gql52(_templateObject56(), TabSelectionField.fragment);
var SearchToolsSortTabs = function(param) {
    var data = param.data, onEmptyResults = param.onEmptyResults;
    var sortSections = data.sortSections;
    if (!sortSections) {
        onEmptyResults === null || onEmptyResults === void 0 ? void 0 : onEmptyResults();
        return null;
    }
    return /* @__PURE__ */ React52.createElement(React52.Fragment, null, sortSections.map(function(section) {
        return section.fields.map(function(field, index) {
            if (field.__typename !== TabSelectionField.fragment.__typename) {
                return null;
            }
            return /* @__PURE__ */ React52.createElement("div", {
                "data-test-id": section.id,
                key: index
            }, /* @__PURE__ */ React52.createElement(TabSelectionField, {
                key: "tabs-field-".concat(index),
                data: field
            }));
        });
    }));
};
SearchToolsSortTabs.displayName = "SearchToolsSortTabs";
SearchToolsSortTabs.fragment = __Fragment44;
var _obj1;
// ../internal/src/components/sort-filter/search-tools-sort-and-filters-views.tsx
var sortAndFiltersViewMap = (_obj1 = {}, _defineProperty(_obj1, "FILTERS" /* FILTERS */ , SearchToolsFilters), _defineProperty(_obj1, "SORT" /* SORT */ , SearchToolsSort), _defineProperty(_obj1, "SORT_AND_FILTERS" /* SORT_AND_FILTERS */ , SearchToolsSortAndFilter), _defineProperty(_obj1, "APPLIED_FILTERS" /* APPLIED_FILTERS */ , SearchToolsAppliedFilters), _defineProperty(_obj1, "FILTER_BAR" /* FILTER_BAR */ , SearchToolsFilterBar), _defineProperty(_obj1, "FILTER_DIALOG" /* FILTER_DIALOG */ , SearchToolsFilterDialog), _defineProperty(_obj1, "FILTERS_PILLS" /* FILTERS_PILLS */ , SearchToolsFilterPill), _defineProperty(_obj1, "SORT_TABS" /* SORT_TABS */ , SearchToolsSortTabs), _obj1);
// src/components/sort-filters/sort-filters.tsx
import { UitkForm } from "uitk-react-form";
// src/__generated__/globalTypes.ts
var FlightsTripType = /* @__PURE__ */ function(FlightsTripType2) {
    FlightsTripType2["MULTI_DESTINATION"] = "MULTI_DESTINATION";
    FlightsTripType2["ONE_WAY"] = "ONE_WAY";
    FlightsTripType2["ROUND_TRIP"] = "ROUND_TRIP";
    return FlightsTripType2;
}(FlightsTripType || {});
// src/components/sort-filters/__private/flights-badge-message.tsx
import React55 from "react";
import { gql as gql55 } from "@apollo/client";
// ../internal/src/components/common/egds-badge/egds-badge.tsx
import React53 from "react";
import { gql as gql53 } from "@apollo/client";
import { UitkBadgeStandard } from "uitk-react-badge";
// ../internal/src/components/common/egds-badge/__private/standard-badge-sizes.ts
var standardBadgeSizes = {
    small: "small",
    large: "large"
};
// ../internal/src/components/common/egds-badge/__private/standard-badge-themes.ts
var standardBadgeThemes = {
    standard: "standard",
    emphasis: "emphasis",
    info: "info",
    featured: "featured",
    brand: "brand",
    warning: "warning",
    positive: "positive"
};
// ../internal/src/components/common/egds-badge/egds-badge.tsx
var __Fragment45 = gql53(_templateObject57());
var EGDSBadge = function(param) {
    var data = param.data;
    if (!data.text) {
        return null;
    }
    var _data_theme;
    var selectedTheme = standardBadgeThemes[(_data_theme = data.theme) !== null && _data_theme !== void 0 ? _data_theme : "standard"];
    var _data_size;
    var size = standardBadgeSizes[(_data_size = data.size) !== null && _data_size !== void 0 ? _data_size : "small"];
    var _data_accessibility;
    return /* @__PURE__ */ React53.createElement(UitkBadgeStandard, {
        a11yText: (_data_accessibility = data.accessibility) !== null && _data_accessibility !== void 0 ? _data_accessibility : void 0,
        text: data.text,
        size: size,
        theme: selectedTheme
    });
};
EGDSBadge.fragment = __Fragment45;
EGDSBadge.displayName = "EGDSBadge";
// ../internal/src/components/common/egds-text/egds-stylized-text.tsx
import React54 from "react";
import { gql as gql54 } from "@apollo/client";
import { UitkText as UitkText4 } from "uitk-react-text";
// ../internal/src/components/common/egds-text/__private/text-size.ts
var textSizeMapper = {
    "100": 100,
    "200": 200,
    "300": 300,
    "400": 400,
    "500": 500,
    "600": 600,
    "700": 700,
    "800": 800,
    "900": 900
};
var _obj2;
// ../internal/src/components/common/egds-text/__private/text-weight.ts
var textWeightMapper = (_obj2 = {}, _defineProperty(_obj2, "BOLD" /* BOLD */ , "bold"), _defineProperty(_obj2, "MEDIUM" /* MEDIUM */ , "medium"), _defineProperty(_obj2, "REGULAR" /* REGULAR */ , "regular"), _obj2);
// ../internal/src/components/common/egds-text/egds-stylized-text.tsx
var __Fragment46 = gql54(_templateObject58());
var EGDSStylizedText = function(param) {
    var className = param.className, inline = param.inline, align = param.align, data = param.data;
    var text = data.text, weight = data.weight, size = data.size;
    var weightProps = weight ? textWeightMapper[weight] : void 0;
    var sizeProps = size ? textSizeMapper[size] : void 0;
    return /* @__PURE__ */ React54.createElement(UitkText4, {
        className: className,
        inline: inline,
        size: sizeProps,
        weight: weightProps,
        align: align
    }, text);
};
EGDSStylizedText.fragment = __Fragment46;
EGDSStylizedText.displayName = "EGDSStylizedText";
// src/components/sort-filters/__private/flights-badge-message.tsx
import { UitkLayoutFlex as UitkLayoutFlex10, UitkLayoutFlexItem as UitkLayoutFlexItem11 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing21 } from "uitk-react-spacing";
var __Fragment47 = gql55(_templateObject59(), EGDSBadge.fragment, EGDSStylizedText.fragment);
var FlightsBadgeMessage = function(param) {
    var data = param.data;
    var badge = data.badge, message = data.message;
    return /* @__PURE__ */ React55.createElement(UitkLayoutFlex10, {
        alignItems: "center"
    }, /* @__PURE__ */ React55.createElement(UitkLayoutFlexItem11, null, /* @__PURE__ */ React55.createElement(UitkSpacing21, {
        margin: {
            inlineend: "two"
        }
    }, /* @__PURE__ */ React55.createElement("div", null, /* @__PURE__ */ React55.createElement(UitkLayoutFlex10, null, /* @__PURE__ */ React55.createElement(EGDSBadge, {
        data: badge
    }))))), /* @__PURE__ */ React55.createElement(UitkLayoutFlexItem11, null, /* @__PURE__ */ React55.createElement(EGDSStylizedText, {
        data: message
    })));
};
FlightsBadgeMessage.fragment = __Fragment47;
FlightsBadgeMessage.displayName = "FlightsBadgeMessage";
// src/components/sort-filters/__private/flights-new-feature-banner.tsx
import React56 from "react";
import { UitkCard } from "uitk-react-cards";
import { UitkSpacing as UitkSpacing22 } from "uitk-react-spacing";
var FlightsNewFeatureBanner = function(param) {
    var children = param.children, data = param.data;
    return /* @__PURE__ */ React56.createElement(UitkCard, {
        padded: true
    }, /* @__PURE__ */ React56.createElement(FlightsBadgeMessage, {
        data: data
    }), /* @__PURE__ */ React56.createElement(UitkSpacing22, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React56.createElement("div", null, children)));
};
// src/components/sort-filters/__private/sort-filters-loading.tsx
import React57 from "react";
import { UitkLineSkeleton } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing23 } from "uitk-react-spacing";
var FlightsSortAndFiltersSkeleton = function() {
    return /* @__PURE__ */ React57.createElement("div", {
        "data-test-id": "filter-loading"
    }, /* @__PURE__ */ React57.createElement(UitkSpacing23, null, /* @__PURE__ */ React57.createElement("div", null, /* @__PURE__ */ React57.createElement(UitkLineSkeleton, {
        animation: true,
        type: "primary"
    }))), /* @__PURE__ */ React57.createElement(UitkSpacing23, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React57.createElement("div", null, /* @__PURE__ */ React57.createElement(UitkLineSkeleton, {
        animation: true,
        type: "secondary"
    }))));
};
// src/components/sort-filters/sort-filters.tsx
var __Query = gql56(_templateObject60(), SearchToolsFilters.fragment, SearchToolsFilterPill.fragment, SearchToolsAppliedFilters.fragment, SearchToolsSort.fragment, SearchToolsSortAndFilter.fragment, SearchToolsSortTabs.fragment, FlightsBadgeMessage.fragment);
var FlightsSortAndFilterWrapper = function(param) {
    var children = param.children, view = param.view, flightsNewFeatureBannerData = param.flightsNewFeatureBannerData;
    return view === "FILTERS_PILLS" /* FILTERS_PILLS */  && flightsNewFeatureBannerData ? /* @__PURE__ */ React58.createElement(FlightsNewFeatureBanner, {
        data: flightsNewFeatureBannerData
    }, children) : children;
};
var FlightsSortAndFilters = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr, view = param.view, onEmptyResults = param.onEmptyResults, onFieldChange = param.onFieldChange, onRemoveAppliedFilter = param.onRemoveAppliedFilter, onRemoveAllAppliedFilters = param.onRemoveAllAppliedFilters, onKeyPress = param.onKeyPress, onClick = param.onClick, onSubmit = param.onSubmit, allowEmptySelectionsPills = param.allowEmptySelectionsPills, useUnsetMargin = param.useUnsetMargin, onOpenDialog = param.onOpenDialog, withExtraMarginBlockEnd = param.withExtraMarginBlockEnd, appliedFiltersSpacing = param.appliedFiltersSpacing;
    var context = useBexApi4().context;
    var variables = _objectSpreadProps(_objectSpread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading, previousData = _useQuery.previousData;
    var results = loading && previousData ? previousData.flightsSearch : data === null || data === void 0 ? void 0 : data.flightsSearch;
    var handleFieldChange = React58.useCallback(function(field, event) {
        onFieldChange === null || onFieldChange === void 0 ? void 0 : onFieldChange(field, event);
    }, [
        onFieldChange
    ]);
    if (loading && !results && view === "FILTERS" /* FILTERS */ ) {
        return /* @__PURE__ */ React58.createElement(FlightsSortAndFiltersSkeleton, null);
    }
    if (!(results === null || results === void 0 ? void 0 : results.universalSortAndFilterResult) || error) {
        if (!loading) {
            onEmptyResults === null || onEmptyResults === void 0 ? void 0 : onEmptyResults();
        }
        return null;
    }
    var View = sortAndFiltersViewMap[view];
    return /* @__PURE__ */ React58.createElement(FlightsSortAndFilterWrapper, {
        view: view,
        flightsNewFeatureBannerData: results.newAddOnFeatureBadgeMessage
    }, /* @__PURE__ */ React58.createElement(UitkForm, {
        onFieldChange: handleFieldChange
    }, /* @__PURE__ */ React58.createElement(View, {
        data: results.universalSortAndFilterResult,
        wrapAppliedFilters: true,
        onEmptyResults: onEmptyResults,
        onClick: onClick,
        onKeyPress: onKeyPress,
        onRemoveAppliedFilter: onRemoveAppliedFilter,
        onSubmit: onSubmit,
        onRemoveAllAppliedFilters: onRemoveAllAppliedFilters,
        allowEmptySelectionsPills: allowEmptySelectionsPills,
        useUnsetMargin: useUnsetMargin,
        onOpenDialog: onOpenDialog,
        withExtraMarginBlockEnd: withExtraMarginBlockEnd,
        appliedFiltersSpacing: appliedFiltersSpacing
    })));
};
FlightsSortAndFilters.displayName = "Flights";
export { FlightsSortAndFilters, FlightsTripType, SortAndFiltersViewType }; /* istanbul ignore file -- @preserve */ 
//# sourceMappingURL=index.js.map